! function(e) {
	function t(i) {
		if (n[i]) return n[i].exports;
		var o = n[i] = {
			i: i,
			l: !1,
			exports: {}
		};
		return e[i].call(o.exports, o, o.exports, t), o.l = !0, o.exports
	}
	var n = {};
	t.m = e, t.c = n, t.i = function(e) {
		return e
	}, t.d = function(e, n, i) {
		t.o(e, n) || Object.defineProperty(e, n, {
			configurable: !1,
			enumerable: !0,
			get: i
		})
	}, t.n = function(e) {
		var n = e && e.__esModule ? function() {
			return e.default
		} : function() {
			return e
		};
		return t.d(n, "a", n), n
	}, t.o = function(e, t) {
		return Object.prototype.hasOwnProperty.call(e, t)
	}, t.p = "", t(t.s = 16)
}([function(e, t, n) {
	var i, o;
	! function(t, n) {
		"use strict";
		"object" == typeof e && "object" == typeof e.exports ? e.exports = t.document ? n(t, !0) : function(e) {
			if (!e.document) throw new Error("jQuery requires a window with a document");
			return n(e)
		} : n(t)
	}("undefined" != typeof window ? window : this, function(n, r) {
		"use strict";

		function s(e, t, n) {
			t = t || ce;
			var i, o = t.createElement("script");
			if (o.text = e, n)
				for (i in Te) n[i] && (o[i] = n[i]);
			t.head.appendChild(o).parentNode.removeChild(o)
		}

		function a(e) {
			return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? me[ve.call(e)] || "object" : typeof e
		}

		function l(e) {
			var t = !!e && "length" in e && e.length,
				n = a(e);
			return !ke(e) && !Ce(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e)
		}

		function u(e, t) {
			return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
		}

		function c(e, t, n) {
			return ke(t) ? Se.grep(e, function(e, i) {
				return !!t.call(e, i, e) !== n
			}) : t.nodeType ? Se.grep(e, function(e) {
				return e === t !== n
			}) : "string" != typeof t ? Se.grep(e, function(e) {
				return ge.call(t, e) > -1 !== n
			}) : Se.filter(t, e, n)
		}

		function d(e, t) {
			for (;
				(e = e[t]) && 1 !== e.nodeType;);
			return e
		}

		function p(e) {
			var t = {};
			return Se.each(e.match(Oe) || [], function(e, n) {
				t[n] = !0
			}), t
		}

		function f(e) {
			return e
		}

		function h(e) {
			throw e
		}

		function g(e, t, n, i) {
			var o;
			try {
				e && ke(o = e.promise) ? o.call(e).done(t).fail(n) : e && ke(o = e.then) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i))
			} catch (e) {
				n.apply(void 0, [e])
			}
		}

		function m() {
			ce.removeEventListener("DOMContentLoaded", m), n.removeEventListener("load", m), Se.ready()
		}

		function v(e, t) {
			return t.toUpperCase()
		}

		function y(e) {
			return e.replace(Be, "ms-").replace(ze, v)
		}

		function w() {
			this.expando = Se.expando + w.uid++
		}

		function b(e) {
			return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : We.test(e) ? JSON.parse(e) : e)
		}

		function x(e, t, n) {
			var i;
			if (void 0 === n && 1 === e.nodeType)
				if (i = "data-" + t.replace(Ue, "-$&").toLowerCase(), "string" == typeof(n = e.getAttribute(i))) {
					try {
						n = b(n)
					} catch (e) {}
					Re.set(e, t, n)
				} else n = void 0;
			return n
		}

		function k(e, t, n, i) {
			var o, r, s = 20,
				a = i ? function() {
					return i.cur()
				} : function() {
					return Se.css(e, t, "")
				},
				l = a(),
				u = n && n[3] || (Se.cssNumber[t] ? "" : "px"),
				c = (Se.cssNumber[t] || "px" !== u && +l) && Ye.exec(Se.css(e, t));
			if (c && c[3] !== u) {
				for (l /= 2, u = u || c[3], c = +l || 1; s--;) Se.style(e, t, c + u), (1 - r) * (1 - (r = a() / l || .5)) <= 0 && (s = 0), c /= r;
				c *= 2, Se.style(e, t, c + u), n = n || []
			}
			return n && (c = +c || +l || 0, o = n[1] ? c + (n[1] + 1) * n[2] : +n[2], i && (i.unit = u, i.start = c, i.end = o)), o
		}

		function C(e) {
			var t, n = e.ownerDocument,
				i = e.nodeName,
				o = Ze[i];
			return o || (t = n.body.appendChild(n.createElement(i)), o = Se.css(t, "display"), t.parentNode.removeChild(t), "none" === o && (o = "block"), Ze[i] = o, o)
		}

		function T(e, t) {
			for (var n, i, o = [], r = 0, s = e.length; r < s; r++) i = e[r], i.style && (n = i.style.display, t ? ("none" === n && (o[r] = Fe.get(i, "display") || null, o[r] || (i.style.display = "")), "" === i.style.display && Qe(i) && (o[r] = C(i))) : "none" !== n && (o[r] = "none", Fe.set(i, "display", n)));
			for (r = 0; r < s; r++) null != o[r] && (e[r].style.display = o[r]);
			return e
		}

		function S(e, t) {
			var n;
			return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && u(e, t) ? Se.merge([e], n) : n
		}

		function E(e, t) {
			for (var n = 0, i = e.length; n < i; n++) Fe.set(e[n], "globalEval", !t || Fe.get(t[n], "globalEval"))
		}

		function _(e, t, n, i, o) {
			for (var r, s, l, u, c, d, p = t.createDocumentFragment(), f = [], h = 0, g = e.length; h < g; h++)
				if ((r = e[h]) || 0 === r)
					if ("object" === a(r)) Se.merge(f, r.nodeType ? [r] : r);
					else if (it.test(r)) {
				for (s = s || p.appendChild(t.createElement("div")), l = (et.exec(r) || ["", ""])[1].toLowerCase(), u = nt[l] || nt._default, s.innerHTML = u[1] + Se.htmlPrefilter(r) + u[2], d = u[0]; d--;) s = s.lastChild;
				Se.merge(f, s.childNodes), s = p.firstChild, s.textContent = ""
			} else f.push(t.createTextNode(r));
			for (p.textContent = "", h = 0; r = f[h++];)
				if (i && Se.inArray(r, i) > -1) o && o.push(r);
				else if (c = Se.contains(r.ownerDocument, r), s = S(p.appendChild(r), "script"), c && E(s), n)
				for (d = 0; r = s[d++];) tt.test(r.type || "") && n.push(r);
			return p
		}

		function A() {
			return !0
		}

		function $() {
			return !1
		}

		function P() {
			try {
				return ce.activeElement
			} catch (e) {}
		}

		function L(e, t, n, i, o, r) {
			var s, a;
			if ("object" == typeof t) {
				"string" != typeof n && (i = i || n, n = void 0);
				for (a in t) L(e, a, n, i, t[a], r);
				return e
			}
			if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), !1 === o) o = $;
			else if (!o) return e;
			return 1 === r && (s = o, o = function(e) {
				return Se().off(e), s.apply(this, arguments)
			}, o.guid = s.guid || (s.guid = Se.guid++)), e.each(function() {
				Se.event.add(this, t, o, i, n)
			})
		}

		function N(e, t) {
			return u(e, "table") && u(11 !== t.nodeType ? t : t.firstChild, "tr") ? Se(e).children("tbody")[0] || e : e
		}

		function j(e) {
			return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
		}

		function q(e) {
			return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
		}

		function H(e, t) {
			var n, i, o, r, s, a, l, u;
			if (1 === t.nodeType) {
				if (Fe.hasData(e) && (r = Fe.access(e), s = Fe.set(t, r), u = r.events)) {
					delete s.handle, s.events = {};
					for (o in u)
						for (n = 0, i = u[o].length; n < i; n++) Se.event.add(t, o, u[o][n])
				}
				Re.hasData(e) && (a = Re.access(e), l = Se.extend({}, a), Re.set(t, l))
			}
		}

		function O(e, t) {
			var n = t.nodeName.toLowerCase();
			"input" === n && Ke.test(e.type) ? t.checked = e.checked : "input" !== n && "textarea" !== n || (t.defaultValue = e.defaultValue)
		}

		function D(e, t, n, i) {
			t = fe.apply([], t);
			var o, r, a, l, u, c, d = 0,
				p = e.length,
				f = p - 1,
				h = t[0],
				g = ke(h);
			if (g || p > 1 && "string" == typeof h && !xe.checkClone && ct.test(h)) return e.each(function(o) {
				var r = e.eq(o);
				g && (t[0] = h.call(this, o, r.html())), D(r, t, n, i)
			});
			if (p && (o = _(t, e[0].ownerDocument, !1, e, i), r = o.firstChild, 1 === o.childNodes.length && (o = r), r || i)) {
				for (a = Se.map(S(o, "script"), j), l = a.length; d < p; d++) u = o, d !== f && (u = Se.clone(u, !0, !0), l && Se.merge(a, S(u, "script"))), n.call(e[d], u, d);
				if (l)
					for (c = a[a.length - 1].ownerDocument, Se.map(a, q), d = 0; d < l; d++) u = a[d], tt.test(u.type || "") && !Fe.access(u, "globalEval") && Se.contains(c, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? Se._evalUrl && Se._evalUrl(u.src) : s(u.textContent.replace(dt, ""), c, u))
			}
			return e
		}

		function M(e, t, n) {
			for (var i, o = t ? Se.filter(t, e) : e, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || Se.cleanData(S(i)), i.parentNode && (n && Se.contains(i.ownerDocument, i) && E(S(i, "script")), i.parentNode.removeChild(i));
			return e
		}

		function I(e, t, n) {
			var i, o, r, s, a = e.style;
			return n = n || ft(e), n && (s = n.getPropertyValue(t) || n[t], "" !== s || Se.contains(e.ownerDocument, e) || (s = Se.style(e, t)), !xe.pixelBoxStyles() && pt.test(s) && ht.test(t) && (i = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = o, a.maxWidth = r)), void 0 !== s ? s + "" : s
		}

		function B(e, t) {
			return {
				get: function() {
					return e() ? void delete this.get : (this.get = t).apply(this, arguments)
				}
			}
		}

		function z(e) {
			if (e in bt) return e;
			for (var t = e[0].toUpperCase() + e.slice(1), n = wt.length; n--;)
				if ((e = wt[n] + t) in bt) return e
		}

		function V(e) {
			var t = Se.cssProps[e];
			return t || (t = Se.cssProps[e] = z(e) || e), t
		}

		function F(e, t, n) {
			var i = Ye.exec(t);
			return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
		}

		function R(e, t, n, i, o, r) {
			var s = "width" === t ? 1 : 0,
				a = 0,
				l = 0;
			if (n === (i ? "border" : "content")) return 0;
			for (; s < 4; s += 2) "margin" === n && (l += Se.css(e, n + Ge[s], !0, o)), i ? ("content" === n && (l -= Se.css(e, "padding" + Ge[s], !0, o)), "margin" !== n && (l -= Se.css(e, "border" + Ge[s] + "Width", !0, o))) : (l += Se.css(e, "padding" + Ge[s], !0, o), "padding" !== n ? l += Se.css(e, "border" + Ge[s] + "Width", !0, o) : a += Se.css(e, "border" + Ge[s] + "Width", !0, o));
			return !i && r >= 0 && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - .5))), l
		}

		function W(e, t, n) {
			var i = ft(e),
				o = I(e, t, i),
				r = "border-box" === Se.css(e, "boxSizing", !1, i),
				s = r;
			if (pt.test(o)) {
				if (!n) return o;
				o = "auto"
			}
			return s = s && (xe.boxSizingReliable() || o === e.style[t]), ("auto" === o || !parseFloat(o) && "inline" === Se.css(e, "display", !1, i)) && (o = e["offset" + t[0].toUpperCase() + t.slice(1)], s = !0), (o = parseFloat(o) || 0) + R(e, t, n || (r ? "border" : "content"), s, i, o) + "px"
		}

		function U(e, t, n, i, o) {
			return new U.prototype.init(e, t, n, i, o)
		}

		function X() {
			kt && (!1 === ce.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(X) : n.setTimeout(X, Se.fx.interval), Se.fx.tick())
		}

		function Y() {
			return n.setTimeout(function() {
				xt = void 0
			}), xt = Date.now()
		}

		function G(e, t) {
			var n, i = 0,
				o = {
					height: e
				};
			for (t = t ? 1 : 0; i < 4; i += 2 - t) n = Ge[i], o["margin" + n] = o["padding" + n] = e;
			return t && (o.opacity = o.width = e), o
		}

		function Q(e, t, n) {
			for (var i, o = (K.tweeners[t] || []).concat(K.tweeners["*"]), r = 0, s = o.length; r < s; r++)
				if (i = o[r].call(n, t, e)) return i
		}

		function J(e, t, n) {
			var i, o, r, s, a, l, u, c, d = "width" in t || "height" in t,
				p = this,
				f = {},
				h = e.style,
				g = e.nodeType && Qe(e),
				m = Fe.get(e, "fxshow");
			n.queue || (s = Se._queueHooks(e, "fx"), null == s.unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function() {
				s.unqueued || a()
			}), s.unqueued++, p.always(function() {
				p.always(function() {
					s.unqueued--, Se.queue(e, "fx").length || s.empty.fire()
				})
			}));
			for (i in t)
				if (o = t[i], Ct.test(o)) {
					if (delete t[i], r = r || "toggle" === o, o === (g ? "hide" : "show")) {
						if ("show" !== o || !m || void 0 === m[i]) continue;
						g = !0
					}
					f[i] = m && m[i] || Se.style(e, i)
				}
			if ((l = !Se.isEmptyObject(t)) || !Se.isEmptyObject(f)) {
				d && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], u = m && m.display, null == u && (u = Fe.get(e, "display")), c = Se.css(e, "display"), "none" === c && (u ? c = u : (T([e], !0), u = e.style.display || u, c = Se.css(e, "display"), T([e]))), ("inline" === c || "inline-block" === c && null != u) && "none" === Se.css(e, "float") && (l || (p.done(function() {
					h.display = u
				}), null == u && (c = h.display, u = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function() {
					h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
				})), l = !1;
				for (i in f) l || (m ? "hidden" in m && (g = m.hidden) : m = Fe.access(e, "fxshow", {
					display: u
				}), r && (m.hidden = !g), g && T([e], !0), p.done(function() {
					g || T([e]), Fe.remove(e, "fxshow");
					for (i in f) Se.style(e, i, f[i])
				})), l = Q(g ? m[i] : 0, i, p), i in m || (m[i] = l.start, g && (l.end = l.start, l.start = 0))
			}
		}

		function Z(e, t) {
			var n, i, o, r, s;
			for (n in e)
				if (i = y(n), o = t[i], r = e[n], Array.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), (s = Se.cssHooks[i]) && "expand" in s) {
					r = s.expand(r), delete e[i];
					for (n in r) n in e || (e[n] = r[n], t[n] = o)
				} else t[i] = o
		}

		function K(e, t, n) {
			var i, o, r = 0,
				s = K.prefilters.length,
				a = Se.Deferred().always(function() {
					delete l.elem
				}),
				l = function() {
					if (o) return !1;
					for (var t = xt || Y(), n = Math.max(0, u.startTime + u.duration - t), i = n / u.duration || 0, r = 1 - i, s = 0, l = u.tweens.length; s < l; s++) u.tweens[s].run(r);
					return a.notifyWith(e, [u, r, n]), r < 1 && l ? n : (l || a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u]), !1)
				},
				u = a.promise({
					elem: e,
					props: Se.extend({}, t),
					opts: Se.extend(!0, {
						specialEasing: {},
						easing: Se.easing._default
					}, n),
					originalProperties: t,
					originalOptions: n,
					startTime: xt || Y(),
					duration: n.duration,
					tweens: [],
					createTween: function(t, n) {
						var i = Se.Tween(e, u.opts, t, n, u.opts.specialEasing[t] || u.opts.easing);
						return u.tweens.push(i), i
					},
					stop: function(t) {
						var n = 0,
							i = t ? u.tweens.length : 0;
						if (o) return this;
						for (o = !0; n < i; n++) u.tweens[n].run(1);
						return t ? (a.notifyWith(e, [u, 1, 0]), a.resolveWith(e, [u, t])) : a.rejectWith(e, [u, t]), this
					}
				}),
				c = u.props;
			for (Z(c, u.opts.specialEasing); r < s; r++)
				if (i = K.prefilters[r].call(u, e, c, u.opts)) return ke(i.stop) && (Se._queueHooks(u.elem, u.opts.queue).stop = i.stop.bind(i)), i;
			return Se.map(c, Q, u), ke(u.opts.start) && u.opts.start.call(e, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), Se.fx.timer(Se.extend(l, {
				elem: e,
				anim: u,
				queue: u.opts.queue
			})), u
		}

		function ee(e) {
			return (e.match(Oe) || []).join(" ")
		}

		function te(e) {
			return e.getAttribute && e.getAttribute("class") || ""
		}

		function ne(e) {
			return Array.isArray(e) ? e : "string" == typeof e ? e.match(Oe) || [] : []
		}

		function ie(e, t, n, i) {
			var o;
			if (Array.isArray(t)) Se.each(t, function(t, o) {
				n || Ht.test(e) ? i(e, o) : ie(e + "[" + ("object" == typeof o && null != o ? t : "") + "]", o, n, i)
			});
			else if (n || "object" !== a(t)) i(e, t);
			else
				for (o in t) ie(e + "[" + o + "]", t[o], n, i)
		}

		function oe(e) {
			return function(t, n) {
				"string" != typeof t && (n = t, t = "*");
				var i, o = 0,
					r = t.toLowerCase().match(Oe) || [];
				if (ke(n))
					for (; i = r[o++];) "+" === i[0] ? (i = i.slice(1) || "*", (e[i] = e[i] || []).unshift(n)) : (e[i] = e[i] || []).push(n)
			}
		}

		function re(e, t, n, i) {
			function o(a) {
				var l;
				return r[a] = !0, Se.each(e[a] || [], function(e, a) {
					var u = a(t, n, i);
					return "string" != typeof u || s || r[u] ? s ? !(l = u) : void 0 : (t.dataTypes.unshift(u), o(u), !1)
				}), l
			}
			var r = {},
				s = e === Xt;
			return o(t.dataTypes[0]) || !r["*"] && o("*")
		}

		function se(e, t) {
			var n, i, o = Se.ajaxSettings.flatOptions || {};
			for (n in t) void 0 !== t[n] && ((o[n] ? e : i || (i = {}))[n] = t[n]);
			return i && Se.extend(!0, e, i), e
		}

		function ae(e, t, n) {
			for (var i, o, r, s, a = e.contents, l = e.dataTypes;
				"*" === l[0];) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
			if (i)
				for (o in a)
					if (a[o] && a[o].test(i)) {
						l.unshift(o);
						break
					}
			if (l[0] in n) r = l[0];
			else {
				for (o in n) {
					if (!l[0] || e.converters[o + " " + l[0]]) {
						r = o;
						break
					}
					s || (s = o)
				}
				r = r || s
			}
			if (r) return r !== l[0] && l.unshift(r), n[r]
		}

		function le(e, t, n, i) {
			var o, r, s, a, l, u = {},
				c = e.dataTypes.slice();
			if (c[1])
				for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
			for (r = c.shift(); r;)
				if (e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = c.shift())
					if ("*" === r) r = l;
					else if ("*" !== l && l !== r) {
				if (!(s = u[l + " " + r] || u["* " + r]))
					for (o in u)
						if (a = o.split(" "), a[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
							!0 === s ? s = u[o] : !0 !== u[o] && (r = a[0], c.unshift(a[1]));
							break
						}
				if (!0 !== s)
					if (s && e.throws) t = s(t);
					else try {
						t = s(t)
					} catch (e) {
						return {
							state: "parsererror",
							error: s ? e : "No conversion from " + l + " to " + r
						}
					}
			}
			return {
				state: "success",
				data: t
			}
		}
		var ue = [],
			ce = n.document,
			de = Object.getPrototypeOf,
			pe = ue.slice,
			fe = ue.concat,
			he = ue.push,
			ge = ue.indexOf,
			me = {},
			ve = me.toString,
			ye = me.hasOwnProperty,
			we = ye.toString,
			be = we.call(Object),
			xe = {},
			ke = function(e) {
				return "function" == typeof e && "number" != typeof e.nodeType
			},
			Ce = function(e) {
				return null != e && e === e.window
			},
			Te = {
				type: !0,
				src: !0,
				noModule: !0
			},
			Se = function(e, t) {
				return new Se.fn.init(e, t)
			},
			Ee = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
		Se.fn = Se.prototype = {
			jquery: "3.3.1",
			constructor: Se,
			length: 0,
			toArray: function() {
				return pe.call(this)
			},
			get: function(e) {
				return null == e ? pe.call(this) : e < 0 ? this[e + this.length] : this[e]
			},
			pushStack: function(e) {
				var t = Se.merge(this.constructor(), e);
				return t.prevObject = this, t
			},
			each: function(e) {
				return Se.each(this, e)
			},
			map: function(e) {
				return this.pushStack(Se.map(this, function(t, n) {
					return e.call(t, n, t)
				}))
			},
			slice: function() {
				return this.pushStack(pe.apply(this, arguments))
			},
			first: function() {
				return this.eq(0)
			},
			last: function() {
				return this.eq(-1)
			},
			eq: function(e) {
				var t = this.length,
					n = +e + (e < 0 ? t : 0);
				return this.pushStack(n >= 0 && n < t ? [this[n]] : [])
			},
			end: function() {
				return this.prevObject || this.constructor()
			},
			push: he,
			sort: ue.sort,
			splice: ue.splice
		}, Se.extend = Se.fn.extend = function() {
			var e, t, n, i, o, r, s = arguments[0] || {},
				a = 1,
				l = arguments.length,
				u = !1;
			for ("boolean" == typeof s && (u = s, s = arguments[a] || {}, a++), "object" == typeof s || ke(s) || (s = {}), a === l && (s = this, a--); a < l; a++)
				if (null != (e = arguments[a]))
					for (t in e) n = s[t], i = e[t], s !== i && (u && i && (Se.isPlainObject(i) || (o = Array.isArray(i))) ? (o ? (o = !1, r = n && Array.isArray(n) ? n : []) : r = n && Se.isPlainObject(n) ? n : {}, s[t] = Se.extend(u, r, i)) : void 0 !== i && (s[t] = i));
			return s
		}, Se.extend({
			expando: "jQuery" + ("3.3.1" + Math.random()).replace(/\D/g, ""),
			isReady: !0,
			error: function(e) {
				throw new Error(e)
			},
			noop: function() {},
			isPlainObject: function(e) {
				var t, n;
				return !(!e || "[object Object]" !== ve.call(e)) && (!(t = de(e)) || "function" == typeof(n = ye.call(t, "constructor") && t.constructor) && we.call(n) === be)
			},
			isEmptyObject: function(e) {
				var t;
				for (t in e) return !1;
				return !0
			},
			globalEval: function(e) {
				s(e)
			},
			each: function(e, t) {
				var n, i = 0;
				if (l(e))
					for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
				else
					for (i in e)
						if (!1 === t.call(e[i], i, e[i])) break;
				return e
			},
			trim: function(e) {
				return null == e ? "" : (e + "").replace(Ee, "")
			},
			makeArray: function(e, t) {
				var n = t || [];
				return null != e && (l(Object(e)) ? Se.merge(n, "string" == typeof e ? [e] : e) : he.call(n, e)), n
			},
			inArray: function(e, t, n) {
				return null == t ? -1 : ge.call(t, e, n)
			},
			merge: function(e, t) {
				for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
				return e.length = o, e
			},
			grep: function(e, t, n) {
				for (var i = [], o = 0, r = e.length, s = !n; o < r; o++) !t(e[o], o) !== s && i.push(e[o]);
				return i
			},
			map: function(e, t, n) {
				var i, o, r = 0,
					s = [];
				if (l(e))
					for (i = e.length; r < i; r++) null != (o = t(e[r], r, n)) && s.push(o);
				else
					for (r in e) null != (o = t(e[r], r, n)) && s.push(o);
				return fe.apply([], s)
			},
			guid: 1,
			support: xe
		}), "function" == typeof Symbol && (Se.fn[Symbol.iterator] = ue[Symbol.iterator]), Se.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
			me["[object " + t + "]"] = t.toLowerCase()
		});
		var _e = function(e) {
			function t(e, t, n, i) {
				var o, r, s, a, l, c, p, f = t && t.ownerDocument,
					h = t ? t.nodeType : 9;
				if (n = n || [], "string" != typeof e || !e || 1 !== h && 9 !== h && 11 !== h) return n;
				if (!i && ((t ? t.ownerDocument || t : I) !== L && P(t), t = t || L, j)) {
					if (11 !== h && (l = ge.exec(e)))
						if (o = l[1]) {
							if (9 === h) {
								if (!(s = t.getElementById(o))) return n;
								if (s.id === o) return n.push(s), n
							} else if (f && (s = f.getElementById(o)) && D(t, s) && s.id === o) return n.push(s), n
						} else {
							if (l[2]) return Q.apply(n, t.getElementsByTagName(e)), n;
							if ((o = l[3]) && b.getElementsByClassName && t.getElementsByClassName) return Q.apply(n, t.getElementsByClassName(o)), n
						}
					if (b.qsa && !R[e + " "] && (!q || !q.test(e))) {
						if (1 !== h) f = t, p = e;
						else if ("object" !== t.nodeName.toLowerCase()) {
							for ((a = t.getAttribute("id")) ? a = a.replace(we, be) : t.setAttribute("id", a = M), c = T(e), r = c.length; r--;) c[r] = "#" + a + " " + d(c[r]);
							p = c.join(","), f = me.test(e) && u(t.parentNode) || t
						}
						if (p) try {
							return Q.apply(n, f.querySelectorAll(p)), n
						} catch (e) {} finally {
							a === M && t.removeAttribute("id")
						}
					}
				}
				return E(e.replace(re, "$1"), t, n, i)
			}

			function n() {
				function e(n, i) {
					return t.push(n + " ") > x.cacheLength && delete e[t.shift()], e[n + " "] = i
				}
				var t = [];
				return e
			}

			function i(e) {
				return e[M] = !0, e
			}

			function o(e) {
				var t = L.createElement("fieldset");
				try {
					return !!e(t)
				} catch (e) {
					return !1
				} finally {
					t.parentNode && t.parentNode.removeChild(t), t = null
				}
			}

			function r(e, t) {
				for (var n = e.split("|"), i = n.length; i--;) x.attrHandle[n[i]] = t
			}

			function s(e, t) {
				var n = t && e,
					i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
				if (i) return i;
				if (n)
					for (; n = n.nextSibling;)
						if (n === t) return -1;
				return e ? 1 : -1
			}

			function a(e) {
				return function(t) {
					return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ke(t) === e : t.disabled === e : "label" in t && t.disabled === e
				}
			}

			function l(e) {
				return i(function(t) {
					return t = +t, i(function(n, i) {
						for (var o, r = e([], n.length, t), s = r.length; s--;) n[o = r[s]] && (n[o] = !(i[o] = n[o]))
					})
				})
			}

			function u(e) {
				return e && void 0 !== e.getElementsByTagName && e
			}

			function c() {}

			function d(e) {
				for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
				return i
			}

			function p(e, t, n) {
				var i = t.dir,
					o = t.next,
					r = o || i,
					s = n && "parentNode" === r,
					a = z++;
				return t.first ? function(t, n, o) {
					for (; t = t[i];)
						if (1 === t.nodeType || s) return e(t, n, o);
					return !1
				} : function(t, n, l) {
					var u, c, d, p = [B, a];
					if (l) {
						for (; t = t[i];)
							if ((1 === t.nodeType || s) && e(t, n, l)) return !0
					} else
						for (; t = t[i];)
							if (1 === t.nodeType || s)
								if (d = t[M] || (t[M] = {}), c = d[t.uniqueID] || (d[t.uniqueID] = {}), o && o === t.nodeName.toLowerCase()) t = t[i] || t;
								else {
									if ((u = c[r]) && u[0] === B && u[1] === a) return p[2] = u[2];
									if (c[r] = p, p[2] = e(t, n, l)) return !0
								} return !1
				}
			}

			function f(e) {
				return e.length > 1 ? function(t, n, i) {
					for (var o = e.length; o--;)
						if (!e[o](t, n, i)) return !1;
					return !0
				} : e[0]
			}

			function h(e, n, i) {
				for (var o = 0, r = n.length; o < r; o++) t(e, n[o], i);
				return i
			}

			function g(e, t, n, i, o) {
				for (var r, s = [], a = 0, l = e.length, u = null != t; a < l; a++)(r = e[a]) && (n && !n(r, i, o) || (s.push(r), u && t.push(a)));
				return s
			}

			function m(e, t, n, o, r, s) {
				return o && !o[M] && (o = m(o)), r && !r[M] && (r = m(r, s)), i(function(i, s, a, l) {
					var u, c, d, p = [],
						f = [],
						m = s.length,
						v = i || h(t || "*", a.nodeType ? [a] : a, []),
						y = !e || !i && t ? v : g(v, p, e, a, l),
						w = n ? r || (i ? e : m || o) ? [] : s : y;
					if (n && n(y, w, a, l), o)
						for (u = g(w, f), o(u, [], a, l), c = u.length; c--;)(d = u[c]) && (w[f[c]] = !(y[f[c]] = d));
					if (i) {
						if (r || e) {
							if (r) {
								for (u = [], c = w.length; c--;)(d = w[c]) && u.push(y[c] = d);
								r(null, w = [], u, l)
							}
							for (c = w.length; c--;)(d = w[c]) && (u = r ? Z(i, d) : p[c]) > -1 && (i[u] = !(s[u] = d))
						}
					} else w = g(w === s ? w.splice(m, w.length) : w), r ? r(null, s, w, l) : Q.apply(s, w)
				})
			}

			function v(e) {
				for (var t, n, i, o = e.length, r = x.relative[e[0].type], s = r || x.relative[" "], a = r ? 1 : 0, l = p(function(e) {
						return e === t
					}, s, !0), u = p(function(e) {
						return Z(t, e) > -1
					}, s, !0), c = [function(e, n, i) {
						var o = !r && (i || n !== _) || ((t = n).nodeType ? l(e, n, i) : u(e, n, i));
						return t = null, o
					}]; a < o; a++)
					if (n = x.relative[e[a].type]) c = [p(f(c), n)];
					else {
						if (n = x.filter[e[a].type].apply(null, e[a].matches), n[M]) {
							for (i = ++a; i < o && !x.relative[e[i].type]; i++);
							return m(a > 1 && f(c), a > 1 && d(e.slice(0, a - 1).concat({
								value: " " === e[a - 2].type ? "*" : ""
							})).replace(re, "$1"), n, a < i && v(e.slice(a, i)), i < o && v(e = e.slice(i)), i < o && d(e))
						}
						c.push(n)
					}
				return f(c)
			}

			function y(e, n) {
				var o = n.length > 0,
					r = e.length > 0,
					s = function(i, s, a, l, u) {
						var c, d, p, f = 0,
							h = "0",
							m = i && [],
							v = [],
							y = _,
							w = i || r && x.find.TAG("*", u),
							b = B += null == y ? 1 : Math.random() || .1,
							k = w.length;
						for (u && (_ = s === L || s || u); h !== k && null != (c = w[h]); h++) {
							if (r && c) {
								for (d = 0, s || c.ownerDocument === L || (P(c), a = !j); p = e[d++];)
									if (p(c, s || L, a)) {
										l.push(c);
										break
									}
								u && (B = b)
							}
							o && ((c = !p && c) && f--, i && m.push(c))
						}
						if (f += h, o && h !== f) {
							for (d = 0; p = n[d++];) p(m, v, s, a);
							if (i) {
								if (f > 0)
									for (; h--;) m[h] || v[h] || (v[h] = Y.call(l));
								v = g(v)
							}
							Q.apply(l, v), u && !i && v.length > 0 && f + n.length > 1 && t.uniqueSort(l)
						}
						return u && (B = b, _ = y), m
					};
				return o ? i(s) : s
			}
			var w, b, x, k, C, T, S, E, _, A, $, P, L, N, j, q, H, O, D, M = "sizzle" + 1 * new Date,
				I = e.document,
				B = 0,
				z = 0,
				V = n(),
				F = n(),
				R = n(),
				W = function(e, t) {
					return e === t && ($ = !0), 0
				},
				U = {}.hasOwnProperty,
				X = [],
				Y = X.pop,
				G = X.push,
				Q = X.push,
				J = X.slice,
				Z = function(e, t) {
					for (var n = 0, i = e.length; n < i; n++)
						if (e[n] === t) return n;
					return -1
				},
				K = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
				ee = "[\\x20\\t\\r\\n\\f]",
				te = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
				ne = "\\[" + ee + "*(" + te + ")(?:" + ee + "*([*^$|!~]?=)" + ee + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + te + "))|)" + ee + "*\\]",
				ie = ":(" + te + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ne + ")*)|.*)\\)|)",
				oe = new RegExp(ee + "+", "g"),
				re = new RegExp("^" + ee + "+|((?:^|[^\\\\])(?:\\\\.)*)" + ee + "+$", "g"),
				se = new RegExp("^" + ee + "*," + ee + "*"),
				ae = new RegExp("^" + ee + "*([>+~]|" + ee + ")" + ee + "*"),
				le = new RegExp("=" + ee + "*([^\\]'\"]*?)" + ee + "*\\]", "g"),
				ue = new RegExp(ie),
				ce = new RegExp("^" + te + "$"),
				de = {
					ID: new RegExp("^#(" + te + ")"),
					CLASS: new RegExp("^\\.(" + te + ")"),
					TAG: new RegExp("^(" + te + "|[*])"),
					ATTR: new RegExp("^" + ne),
					PSEUDO: new RegExp("^" + ie),
					CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + ee + "*(even|odd|(([+-]|)(\\d*)n|)" + ee + "*(?:([+-]|)" + ee + "*(\\d+)|))" + ee + "*\\)|)", "i"),
					bool: new RegExp("^(?:" + K + ")$", "i"),
					needsContext: new RegExp("^" + ee + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + ee + "*((?:-\\d)?\\d*)" + ee + "*\\)|)(?=[^-]|$)", "i")
				},
				pe = /^(?:input|select|textarea|button)$/i,
				fe = /^h\d$/i,
				he = /^[^{]+\{\s*\[native \w/,
				ge = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
				me = /[+~]/,
				ve = new RegExp("\\\\([\\da-f]{1,6}" + ee + "?|(" + ee + ")|.)", "ig"),
				ye = function(e, t, n) {
					var i = "0x" + t - 65536;
					return i !== i || n ? t : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
				},
				we = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
				be = function(e, t) {
					return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
				},
				xe = function() {
					P()
				},
				ke = p(function(e) {
					return !0 === e.disabled && ("form" in e || "label" in e)
				}, {
					dir: "parentNode",
					next: "legend"
				});
			try {
				Q.apply(X = J.call(I.childNodes), I.childNodes), X[I.childNodes.length].nodeType
			} catch (e) {
				Q = {
					apply: X.length ? function(e, t) {
						G.apply(e, J.call(t))
					} : function(e, t) {
						for (var n = e.length, i = 0; e[n++] = t[i++];);
						e.length = n - 1
					}
				}
			}
			b = t.support = {}, C = t.isXML = function(e) {
				var t = e && (e.ownerDocument || e).documentElement;
				return !!t && "HTML" !== t.nodeName
			}, P = t.setDocument = function(e) {
				var t, n, i = e ? e.ownerDocument || e : I;
				return i !== L && 9 === i.nodeType && i.documentElement ? (L = i, N = L.documentElement, j = !C(L), I !== L && (n = L.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", xe, !1) : n.attachEvent && n.attachEvent("onunload", xe)), b.attributes = o(function(e) {
					return e.className = "i", !e.getAttribute("className")
				}), b.getElementsByTagName = o(function(e) {
					return e.appendChild(L.createComment("")), !e.getElementsByTagName("*").length
				}), b.getElementsByClassName = he.test(L.getElementsByClassName), b.getById = o(function(e) {
					return N.appendChild(e).id = M, !L.getElementsByName || !L.getElementsByName(M).length
				}), b.getById ? (x.filter.ID = function(e) {
					var t = e.replace(ve, ye);
					return function(e) {
						return e.getAttribute("id") === t
					}
				}, x.find.ID = function(e, t) {
					if (void 0 !== t.getElementById && j) {
						var n = t.getElementById(e);
						return n ? [n] : []
					}
				}) : (x.filter.ID = function(e) {
					var t = e.replace(ve, ye);
					return function(e) {
						var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
						return n && n.value === t
					}
				}, x.find.ID = function(e, t) {
					if (void 0 !== t.getElementById && j) {
						var n, i, o, r = t.getElementById(e);
						if (r) {
							if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
							for (o = t.getElementsByName(e), i = 0; r = o[i++];)
								if ((n = r.getAttributeNode("id")) && n.value === e) return [r]
						}
						return []
					}
				}), x.find.TAG = b.getElementsByTagName ? function(e, t) {
					return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : b.qsa ? t.querySelectorAll(e) : void 0
				} : function(e, t) {
					var n, i = [],
						o = 0,
						r = t.getElementsByTagName(e);
					if ("*" === e) {
						for (; n = r[o++];) 1 === n.nodeType && i.push(n);
						return i
					}
					return r
				}, x.find.CLASS = b.getElementsByClassName && function(e, t) {
					if (void 0 !== t.getElementsByClassName && j) return t.getElementsByClassName(e)
				}, H = [], q = [], (b.qsa = he.test(L.querySelectorAll)) && (o(function(e) {
					N.appendChild(e).innerHTML = "<a id='" + M + "'></a><select id='" + M + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && q.push("[*^$]=" + ee + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || q.push("\\[" + ee + "*(?:value|" + K + ")"), e.querySelectorAll("[id~=" + M + "-]").length || q.push("~="), e.querySelectorAll(":checked").length || q.push(":checked"), e.querySelectorAll("a#" + M + "+*").length || q.push(".#.+[+~]")
				}), o(function(e) {
					e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
					var t = L.createElement("input");
					t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && q.push("name" + ee + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && q.push(":enabled", ":disabled"), N.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && q.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), q.push(",.*:")
				})), (b.matchesSelector = he.test(O = N.matches || N.webkitMatchesSelector || N.mozMatchesSelector || N.oMatchesSelector || N.msMatchesSelector)) && o(function(e) {
					b.disconnectedMatch = O.call(e, "*"), O.call(e, "[s!='']:x"), H.push("!=", ie)
				}), q = q.length && new RegExp(q.join("|")), H = H.length && new RegExp(H.join("|")), t = he.test(N.compareDocumentPosition), D = t || he.test(N.contains) ? function(e, t) {
					var n = 9 === e.nodeType ? e.documentElement : e,
						i = t && t.parentNode;
					return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
				} : function(e, t) {
					if (t)
						for (; t = t.parentNode;)
							if (t === e) return !0;
					return !1
				}, W = t ? function(e, t) {
					if (e === t) return $ = !0, 0;
					var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
					return n || (n = (e.ownerDocument || e) === (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1, 1 & n || !b.sortDetached && t.compareDocumentPosition(e) === n ? e === L || e.ownerDocument === I && D(I, e) ? -1 : t === L || t.ownerDocument === I && D(I, t) ? 1 : A ? Z(A, e) - Z(A, t) : 0 : 4 & n ? -1 : 1)
				} : function(e, t) {
					if (e === t) return $ = !0, 0;
					var n, i = 0,
						o = e.parentNode,
						r = t.parentNode,
						a = [e],
						l = [t];
					if (!o || !r) return e === L ? -1 : t === L ? 1 : o ? -1 : r ? 1 : A ? Z(A, e) - Z(A, t) : 0;
					if (o === r) return s(e, t);
					for (n = e; n = n.parentNode;) a.unshift(n);
					for (n = t; n = n.parentNode;) l.unshift(n);
					for (; a[i] === l[i];) i++;
					return i ? s(a[i], l[i]) : a[i] === I ? -1 : l[i] === I ? 1 : 0
				}, L) : L
			}, t.matches = function(e, n) {
				return t(e, null, null, n)
			}, t.matchesSelector = function(e, n) {
				if ((e.ownerDocument || e) !== L && P(e), n = n.replace(le, "='$1']"), b.matchesSelector && j && !R[n + " "] && (!H || !H.test(n)) && (!q || !q.test(n))) try {
					var i = O.call(e, n);
					if (i || b.disconnectedMatch || e.document && 11 !== e.document.nodeType) return i
				} catch (e) {}
				return t(n, L, null, [e]).length > 0
			}, t.contains = function(e, t) {
				return (e.ownerDocument || e) !== L && P(e), D(e, t)
			}, t.attr = function(e, t) {
				(e.ownerDocument || e) !== L && P(e);
				var n = x.attrHandle[t.toLowerCase()],
					i = n && U.call(x.attrHandle, t.toLowerCase()) ? n(e, t, !j) : void 0;
				return void 0 !== i ? i : b.attributes || !j ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
			}, t.escape = function(e) {
				return (e + "").replace(we, be)
			}, t.error = function(e) {
				throw new Error("Syntax error, unrecognized expression: " + e)
			}, t.uniqueSort = function(e) {
				var t, n = [],
					i = 0,
					o = 0;
				if ($ = !b.detectDuplicates, A = !b.sortStable && e.slice(0), e.sort(W), $) {
					for (; t = e[o++];) t === e[o] && (i = n.push(o));
					for (; i--;) e.splice(n[i], 1)
				}
				return A = null, e
			}, k = t.getText = function(e) {
				var t, n = "",
					i = 0,
					o = e.nodeType;
				if (o) {
					if (1 === o || 9 === o || 11 === o) {
						if ("string" == typeof e.textContent) return e.textContent;
						for (e = e.firstChild; e; e = e.nextSibling) n += k(e)
					} else if (3 === o || 4 === o) return e.nodeValue
				} else
					for (; t = e[i++];) n += k(t);
				return n
			}, x = t.selectors = {
				cacheLength: 50,
				createPseudo: i,
				match: de,
				attrHandle: {},
				find: {},
				relative: {
					">": {
						dir: "parentNode",
						first: !0
					},
					" ": {
						dir: "parentNode"
					},
					"+": {
						dir: "previousSibling",
						first: !0
					},
					"~": {
						dir: "previousSibling"
					}
				},
				preFilter: {
					ATTR: function(e) {
						return e[1] = e[1].replace(ve, ye), e[3] = (e[3] || e[4] || e[5] || "").replace(ve, ye), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
					},
					CHILD: function(e) {
						return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || t.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && t.error(e[0]), e
					},
					PSEUDO: function(e) {
						var t, n = !e[6] && e[2];
						return de.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && ue.test(n) && (t = T(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
					}
				},
				filter: {
					TAG: function(e) {
						var t = e.replace(ve, ye).toLowerCase();
						return "*" === e ? function() {
							return !0
						} : function(e) {
							return e.nodeName && e.nodeName.toLowerCase() === t
						}
					},
					CLASS: function(e) {
						var t = V[e + " "];
						return t || (t = new RegExp("(^|" + ee + ")" + e + "(" + ee + "|$)")) && V(e, function(e) {
							return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
						})
					},
					ATTR: function(e, n, i) {
						return function(o) {
							var r = t.attr(o, e);
							return null == r ? "!=" === n : !n || (r += "", "=" === n ? r === i : "!=" === n ? r !== i : "^=" === n ? i && 0 === r.indexOf(i) : "*=" === n ? i && r.indexOf(i) > -1 : "$=" === n ? i && r.slice(-i.length) === i : "~=" === n ? (" " + r.replace(oe, " ") + " ").indexOf(i) > -1 : "|=" === n && (r === i || r.slice(0, i.length + 1) === i + "-"))
						}
					},
					CHILD: function(e, t, n, i, o) {
						var r = "nth" !== e.slice(0, 3),
							s = "last" !== e.slice(-4),
							a = "of-type" === t;
						return 1 === i && 0 === o ? function(e) {
							return !!e.parentNode
						} : function(t, n, l) {
							var u, c, d, p, f, h, g = r !== s ? "nextSibling" : "previousSibling",
								m = t.parentNode,
								v = a && t.nodeName.toLowerCase(),
								y = !l && !a,
								w = !1;
							if (m) {
								if (r) {
									for (; g;) {
										for (p = t; p = p[g];)
											if (a ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
										h = g = "only" === e && !h && "nextSibling"
									}
									return !0
								}
								if (h = [s ? m.firstChild : m.lastChild], s && y) {
									for (p = m, d = p[M] || (p[M] = {}), c = d[p.uniqueID] || (d[p.uniqueID] = {}), u = c[e] || [], f = u[0] === B && u[1], w = f && u[2], p = f && m.childNodes[f]; p = ++f && p && p[g] || (w = f = 0) || h.pop();)
										if (1 === p.nodeType && ++w && p === t) {
											c[e] = [B, f, w];
											break
										}
								} else if (y && (p = t, d = p[M] || (p[M] = {}), c = d[p.uniqueID] || (d[p.uniqueID] = {}), u = c[e] || [], f = u[0] === B && u[1], w = f), !1 === w)
									for (;
										(p = ++f && p && p[g] || (w = f = 0) || h.pop()) && ((a ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++w || (y && (d = p[M] || (p[M] = {}), c = d[p.uniqueID] || (d[p.uniqueID] = {}), c[e] = [B, w]), p !== t)););
								return (w -= o) === i || w % i == 0 && w / i >= 0
							}
						}
					},
					PSEUDO: function(e, n) {
						var o, r = x.pseudos[e] || x.setFilters[e.toLowerCase()] || t.error("unsupported pseudo: " + e);
						return r[M] ? r(n) : r.length > 1 ? (o = [e, e, "", n], x.setFilters.hasOwnProperty(e.toLowerCase()) ? i(function(e, t) {
							for (var i, o = r(e, n), s = o.length; s--;) i = Z(e, o[s]), e[i] = !(t[i] = o[s])
						}) : function(e) {
							return r(e, 0, o)
						}) : r
					}
				},
				pseudos: {
					not: i(function(e) {
						var t = [],
							n = [],
							o = S(e.replace(re, "$1"));
						return o[M] ? i(function(e, t, n, i) {
							for (var r, s = o(e, null, i, []), a = e.length; a--;)(r = s[a]) && (e[a] = !(t[a] = r))
						}) : function(e, i, r) {
							return t[0] = e, o(t, null, r, n), t[0] = null, !n.pop()
						}
					}),
					has: i(function(e) {
						return function(n) {
							return t(e, n).length > 0
						}
					}),
					contains: i(function(e) {
						return e = e.replace(ve, ye),
							function(t) {
								return (t.textContent || t.innerText || k(t)).indexOf(e) > -1
							}
					}),
					lang: i(function(e) {
						return ce.test(e || "") || t.error("unsupported lang: " + e), e = e.replace(ve, ye).toLowerCase(),
							function(t) {
								var n;
								do {
									if (n = j ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-")
								} while ((t = t.parentNode) && 1 === t.nodeType);
								return !1
							}
					}),
					target: function(t) {
						var n = e.location && e.location.hash;
						return n && n.slice(1) === t.id
					},
					root: function(e) {
						return e === N
					},
					focus: function(e) {
						return e === L.activeElement && (!L.hasFocus || L.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
					},
					enabled: a(!1),
					disabled: a(!0),
					checked: function(e) {
						var t = e.nodeName.toLowerCase();
						return "input" === t && !!e.checked || "option" === t && !!e.selected
					},
					selected: function(e) {
						return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
					},
					empty: function(e) {
						for (e = e.firstChild; e; e = e.nextSibling)
							if (e.nodeType < 6) return !1;
						return !0
					},
					parent: function(e) {
						return !x.pseudos.empty(e)
					},
					header: function(e) {
						return fe.test(e.nodeName)
					},
					input: function(e) {
						return pe.test(e.nodeName)
					},
					button: function(e) {
						var t = e.nodeName.toLowerCase();
						return "input" === t && "button" === e.type || "button" === t
					},
					text: function(e) {
						var t;
						return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
					},
					first: l(function() {
						return [0]
					}),
					last: l(function(e, t) {
						return [t - 1]
					}),
					eq: l(function(e, t, n) {
						return [n < 0 ? n + t : n]
					}),
					even: l(function(e, t) {
						for (var n = 0; n < t; n += 2) e.push(n);
						return e
					}),
					odd: l(function(e, t) {
						for (var n = 1; n < t; n += 2) e.push(n);
						return e
					}),
					lt: l(function(e, t, n) {
						for (var i = n < 0 ? n + t : n; --i >= 0;) e.push(i);
						return e
					}),
					gt: l(function(e, t, n) {
						for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
						return e
					})
				}
			}, x.pseudos.nth = x.pseudos.eq;
			for (w in {
					radio: !0,
					checkbox: !0,
					file: !0,
					password: !0,
					image: !0
				}) x.pseudos[w] = function(e) {
				return function(t) {
					return "input" === t.nodeName.toLowerCase() && t.type === e
				}
			}(w);
			for (w in {
					submit: !0,
					reset: !0
				}) x.pseudos[w] = function(e) {
				return function(t) {
					var n = t.nodeName.toLowerCase();
					return ("input" === n || "button" === n) && t.type === e
				}
			}(w);
			return c.prototype = x.filters = x.pseudos, x.setFilters = new c, T = t.tokenize = function(e, n) {
				var i, o, r, s, a, l, u, c = F[e + " "];
				if (c) return n ? 0 : c.slice(0);
				for (a = e, l = [], u = x.preFilter; a;) {
					i && !(o = se.exec(a)) || (o && (a = a.slice(o[0].length) || a), l.push(r = [])), i = !1, (o = ae.exec(a)) && (i = o.shift(), r.push({
						value: i,
						type: o[0].replace(re, " ")
					}), a = a.slice(i.length));
					for (s in x.filter) !(o = de[s].exec(a)) || u[s] && !(o = u[s](o)) || (i = o.shift(), r.push({
						value: i,
						type: s,
						matches: o
					}), a = a.slice(i.length));
					if (!i) break
				}
				return n ? a.length : a ? t.error(e) : F(e, l).slice(0)
			}, S = t.compile = function(e, t) {
				var n, i = [],
					o = [],
					r = R[e + " "];
				if (!r) {
					for (t || (t = T(e)), n = t.length; n--;) r = v(t[n]), r[M] ? i.push(r) : o.push(r);
					r = R(e, y(o, i)), r.selector = e
				}
				return r
			}, E = t.select = function(e, t, n, i) {
				var o, r, s, a, l, c = "function" == typeof e && e,
					p = !i && T(e = c.selector || e);
				if (n = n || [], 1 === p.length) {
					if (r = p[0] = p[0].slice(0), r.length > 2 && "ID" === (s = r[0]).type && 9 === t.nodeType && j && x.relative[r[1].type]) {
						if (!(t = (x.find.ID(s.matches[0].replace(ve, ye), t) || [])[0])) return n;
						c && (t = t.parentNode), e = e.slice(r.shift().value.length)
					}
					for (o = de.needsContext.test(e) ? 0 : r.length; o-- && (s = r[o], !x.relative[a = s.type]);)
						if ((l = x.find[a]) && (i = l(s.matches[0].replace(ve, ye), me.test(r[0].type) && u(t.parentNode) || t))) {
							if (r.splice(o, 1), !(e = i.length && d(r))) return Q.apply(n, i), n;
							break
						}
				}
				return (c || S(e, p))(i, t, !j, n, !t || me.test(e) && u(t.parentNode) || t), n
			}, b.sortStable = M.split("").sort(W).join("") === M, b.detectDuplicates = !!$, P(), b.sortDetached = o(function(e) {
				return 1 & e.compareDocumentPosition(L.createElement("fieldset"))
			}), o(function(e) {
				return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
			}) || r("type|href|height|width", function(e, t, n) {
				if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
			}), b.attributes && o(function(e) {
				return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
			}) || r("value", function(e, t, n) {
				if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
			}), o(function(e) {
				return null == e.getAttribute("disabled")
			}) || r(K, function(e, t, n) {
				var i;
				if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
			}), t
		}(n);
		Se.find = _e, Se.expr = _e.selectors, Se.expr[":"] = Se.expr.pseudos, Se.uniqueSort = Se.unique = _e.uniqueSort, Se.text = _e.getText, Se.isXMLDoc = _e.isXML, Se.contains = _e.contains, Se.escapeSelector = _e.escape;
		var Ae = function(e, t, n) {
				for (var i = [], o = void 0 !== n;
					(e = e[t]) && 9 !== e.nodeType;)
					if (1 === e.nodeType) {
						if (o && Se(e).is(n)) break;
						i.push(e)
					}
				return i
			},
			$e = function(e, t) {
				for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
				return n
			},
			Pe = Se.expr.match.needsContext,
			Le = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
		Se.filter = function(e, t, n) {
			var i = t[0];
			return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? Se.find.matchesSelector(i, e) ? [i] : [] : Se.find.matches(e, Se.grep(t, function(e) {
				return 1 === e.nodeType
			}))
		}, Se.fn.extend({
			find: function(e) {
				var t, n, i = this.length,
					o = this;
				if ("string" != typeof e) return this.pushStack(Se(e).filter(function() {
					for (t = 0; t < i; t++)
						if (Se.contains(o[t], this)) return !0
				}));
				for (n = this.pushStack([]), t = 0; t < i; t++) Se.find(e, o[t], n);
				return i > 1 ? Se.uniqueSort(n) : n
			},
			filter: function(e) {
				return this.pushStack(c(this, e || [], !1))
			},
			not: function(e) {
				return this.pushStack(c(this, e || [], !0))
			},
			is: function(e) {
				return !!c(this, "string" == typeof e && Pe.test(e) ? Se(e) : e || [], !1).length
			}
		});
		var Ne, je = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
		(Se.fn.init = function(e, t, n) {
			var i, o;
			if (!e) return this;
			if (n = n || Ne, "string" == typeof e) {
				if (!(i = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : je.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
				if (i[1]) {
					if (t = t instanceof Se ? t[0] : t, Se.merge(this, Se.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : ce, !0)), Le.test(i[1]) && Se.isPlainObject(t))
						for (i in t) ke(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
					return this
				}
				return o = ce.getElementById(i[2]), o && (this[0] = o, this.length = 1), this
			}
			return e.nodeType ? (this[0] = e, this.length = 1, this) : ke(e) ? void 0 !== n.ready ? n.ready(e) : e(Se) : Se.makeArray(e, this)
		}).prototype = Se.fn, Ne = Se(ce);
		var qe = /^(?:parents|prev(?:Until|All))/,
			He = {
				children: !0,
				contents: !0,
				next: !0,
				prev: !0
			};
		Se.fn.extend({
			has: function(e) {
				var t = Se(e, this),
					n = t.length;
				return this.filter(function() {
					for (var e = 0; e < n; e++)
						if (Se.contains(this, t[e])) return !0
				})
			},
			closest: function(e, t) {
				var n, i = 0,
					o = this.length,
					r = [],
					s = "string" != typeof e && Se(e);
				if (!Pe.test(e))
					for (; i < o; i++)
						for (n = this[i]; n && n !== t; n = n.parentNode)
							if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && Se.find.matchesSelector(n, e))) {
								r.push(n);
								break
							}
				return this.pushStack(r.length > 1 ? Se.uniqueSort(r) : r)
			},
			index: function(e) {
				return e ? "string" == typeof e ? ge.call(Se(e), this[0]) : ge.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
			},
			add: function(e, t) {
				return this.pushStack(Se.uniqueSort(Se.merge(this.get(), Se(e, t))))
			},
			addBack: function(e) {
				return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
			}
		}), Se.each({
			parent: function(e) {
				var t = e.parentNode;
				return t && 11 !== t.nodeType ? t : null
			},
			parents: function(e) {
				return Ae(e, "parentNode")
			},
			parentsUntil: function(e, t, n) {
				return Ae(e, "parentNode", n)
			},
			next: function(e) {
				return d(e, "nextSibling")
			},
			prev: function(e) {
				return d(e, "previousSibling")
			},
			nextAll: function(e) {
				return Ae(e, "nextSibling")
			},
			prevAll: function(e) {
				return Ae(e, "previousSibling")
			},
			nextUntil: function(e, t, n) {
				return Ae(e, "nextSibling", n)
			},
			prevUntil: function(e, t, n) {
				return Ae(e, "previousSibling", n)
			},
			siblings: function(e) {
				return $e((e.parentNode || {}).firstChild, e)
			},
			children: function(e) {
				return $e(e.firstChild)
			},
			contents: function(e) {
				return u(e, "iframe") ? e.contentDocument : (u(e, "template") && (e = e.content || e), Se.merge([], e.childNodes))
			}
		}, function(e, t) {
			Se.fn[e] = function(n, i) {
				var o = Se.map(this, t, n);
				return "Until" !== e.slice(-5) && (i = n), i && "string" == typeof i && (o = Se.filter(i, o)), this.length > 1 && (He[e] || Se.uniqueSort(o), qe.test(e) && o.reverse()), this.pushStack(o)
			}
		});
		var Oe = /[^\x20\t\r\n\f]+/g;
		Se.Callbacks = function(e) {
			e = "string" == typeof e ? p(e) : Se.extend({}, e);
			var t, n, i, o, r = [],
				s = [],
				l = -1,
				u = function() {
					for (o = o || e.once, i = t = !0; s.length; l = -1)
						for (n = s.shift(); ++l < r.length;) !1 === r[l].apply(n[0], n[1]) && e.stopOnFalse && (l = r.length, n = !1);
					e.memory || (n = !1), t = !1, o && (r = n ? [] : "")
				},
				c = {
					add: function() {
						return r && (n && !t && (l = r.length - 1, s.push(n)), function t(n) {
							Se.each(n, function(n, i) {
								ke(i) ? e.unique && c.has(i) || r.push(i) : i && i.length && "string" !== a(i) && t(i)
							})
						}(arguments), n && !t && u()), this
					},
					remove: function() {
						return Se.each(arguments, function(e, t) {
							for (var n;
								(n = Se.inArray(t, r, n)) > -1;) r.splice(n, 1), n <= l && l--
						}), this
					},
					has: function(e) {
						return e ? Se.inArray(e, r) > -1 : r.length > 0
					},
					empty: function() {
						return r && (r = []), this
					},
					disable: function() {
						return o = s = [], r = n = "", this
					},
					disabled: function() {
						return !r
					},
					lock: function() {
						return o = s = [], n || t || (r = n = ""), this
					},
					locked: function() {
						return !!o
					},
					fireWith: function(e, n) {
						return o || (n = n || [], n = [e, n.slice ? n.slice() : n], s.push(n), t || u()), this
					},
					fire: function() {
						return c.fireWith(this, arguments), this
					},
					fired: function() {
						return !!i
					}
				};
			return c
		}, Se.extend({
			Deferred: function(e) {
				var t = [
						["notify", "progress", Se.Callbacks("memory"), Se.Callbacks("memory"), 2],
						["resolve", "done", Se.Callbacks("once memory"), Se.Callbacks("once memory"), 0, "resolved"],
						["reject", "fail", Se.Callbacks("once memory"), Se.Callbacks("once memory"), 1, "rejected"]
					],
					i = "pending",
					o = {
						state: function() {
							return i
						},
						always: function() {
							return r.done(arguments).fail(arguments), this
						},
						catch: function(e) {
							return o.then(null, e)
						},
						pipe: function() {
							var e = arguments;
							return Se.Deferred(function(n) {
								Se.each(t, function(t, i) {
									var o = ke(e[i[4]]) && e[i[4]];
									r[i[1]](function() {
										var e = o && o.apply(this, arguments);
										e && ke(e.promise) ? e.promise().progress(n.notify).done(n.resolve).fail(n.reject) : n[i[0] + "With"](this, o ? [e] : arguments)
									})
								}), e = null
							}).promise()
						},
						then: function(e, i, o) {
							function r(e, t, i, o) {
								return function() {
									var a = this,
										l = arguments,
										u = function() {
											var n, u;
											if (!(e < s)) {
												if ((n = i.apply(a, l)) === t.promise()) throw new TypeError("Thenable self-resolution");
												u = n && ("object" == typeof n || "function" == typeof n) && n.then, ke(u) ? o ? u.call(n, r(s, t, f, o), r(s, t, h, o)) : (s++, u.call(n, r(s, t, f, o), r(s, t, h, o), r(s, t, f, t.notifyWith))) : (i !== f && (a = void 0, l = [n]), (o || t.resolveWith)(a, l))
											}
										},
										c = o ? u : function() {
											try {
												u()
											} catch (n) {
												Se.Deferred.exceptionHook && Se.Deferred.exceptionHook(n, c.stackTrace), e + 1 >= s && (i !== h && (a = void 0, l = [n]), t.rejectWith(a, l))
											}
										};
									e ? c() : (Se.Deferred.getStackHook && (c.stackTrace = Se.Deferred.getStackHook()), n.setTimeout(c))
								}
							}
							var s = 0;
							return Se.Deferred(function(n) {
								t[0][3].add(r(0, n, ke(o) ? o : f, n.notifyWith)), t[1][3].add(r(0, n, ke(e) ? e : f)), t[2][3].add(r(0, n, ke(i) ? i : h))
							}).promise()
						},
						promise: function(e) {
							return null != e ? Se.extend(e, o) : o
						}
					},
					r = {};
				return Se.each(t, function(e, n) {
					var s = n[2],
						a = n[5];
					o[n[1]] = s.add, a && s.add(function() {
						i = a
					}, t[3 - e][2].disable, t[3 - e][3].disable, t[0][2].lock, t[0][3].lock), s.add(n[3].fire), r[n[0]] = function() {
						return r[n[0] + "With"](this === r ? void 0 : this, arguments), this
					}, r[n[0] + "With"] = s.fireWith
				}), o.promise(r), e && e.call(r, r), r
			},
			when: function(e) {
				var t = arguments.length,
					n = t,
					i = Array(n),
					o = pe.call(arguments),
					r = Se.Deferred(),
					s = function(e) {
						return function(n) {
							i[e] = this, o[e] = arguments.length > 1 ? pe.call(arguments) : n, --t || r.resolveWith(i, o)
						}
					};
				if (t <= 1 && (g(e, r.done(s(n)).resolve, r.reject, !t), "pending" === r.state() || ke(o[n] && o[n].then))) return r.then();
				for (; n--;) g(o[n], s(n), r.reject);
				return r.promise()
			}
		});
		var De = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
		Se.Deferred.exceptionHook = function(e, t) {
			n.console && n.console.warn && e && De.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
		}, Se.readyException = function(e) {
			n.setTimeout(function() {
				throw e
			})
		};
		var Me = Se.Deferred();
		Se.fn.ready = function(e) {
			return Me.then(e).catch(function(e) {
				Se.readyException(e)
			}), this
		}, Se.extend({
			isReady: !1,
			readyWait: 1,
			ready: function(e) {
				(!0 === e ? --Se.readyWait : Se.isReady) || (Se.isReady = !0, !0 !== e && --Se.readyWait > 0 || Me.resolveWith(ce, [Se]))
			}
		}), Se.ready.then = Me.then, "complete" === ce.readyState || "loading" !== ce.readyState && !ce.documentElement.doScroll ? n.setTimeout(Se.ready) : (ce.addEventListener("DOMContentLoaded", m), n.addEventListener("load", m));
		var Ie = function(e, t, n, i, o, r, s) {
				var l = 0,
					u = e.length,
					c = null == n;
				if ("object" === a(n)) {
					o = !0;
					for (l in n) Ie(e, t, l, n[l], !0, r, s)
				} else if (void 0 !== i && (o = !0, ke(i) || (s = !0), c && (s ? (t.call(e, i), t = null) : (c = t, t = function(e, t, n) {
						return c.call(Se(e), n)
					})), t))
					for (; l < u; l++) t(e[l], n, s ? i : i.call(e[l], l, t(e[l], n)));
				return o ? e : c ? t.call(e) : u ? t(e[0], n) : r
			},
			Be = /^-ms-/,
			ze = /-([a-z])/g,
			Ve = function(e) {
				return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
			};
		w.uid = 1, w.prototype = {
			cache: function(e) {
				var t = e[this.expando];
				return t || (t = {}, Ve(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
					value: t,
					configurable: !0
				}))), t
			},
			set: function(e, t, n) {
				var i, o = this.cache(e);
				if ("string" == typeof t) o[y(t)] = n;
				else
					for (i in t) o[y(i)] = t[i];
				return o
			},
			get: function(e, t) {
				return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][y(t)]
			},
			access: function(e, t, n) {
				return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t)
			},
			remove: function(e, t) {
				var n, i = e[this.expando];
				if (void 0 !== i) {
					if (void 0 !== t) {
						Array.isArray(t) ? t = t.map(y) : (t = y(t), t = t in i ? [t] : t.match(Oe) || []), n = t.length;
						for (; n--;) delete i[t[n]]
					}(void 0 === t || Se.isEmptyObject(i)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
				}
			},
			hasData: function(e) {
				var t = e[this.expando];
				return void 0 !== t && !Se.isEmptyObject(t)
			}
		};
		var Fe = new w,
			Re = new w,
			We = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
			Ue = /[A-Z]/g;
		Se.extend({
			hasData: function(e) {
				return Re.hasData(e) || Fe.hasData(e)
			},
			data: function(e, t, n) {
				return Re.access(e, t, n)
			},
			removeData: function(e, t) {
				Re.remove(e, t)
			},
			_data: function(e, t, n) {
				return Fe.access(e, t, n)
			},
			_removeData: function(e, t) {
				Fe.remove(e, t)
			}
		}), Se.fn.extend({
			data: function(e, t) {
				var n, i, o, r = this[0],
					s = r && r.attributes;
				if (void 0 === e) {
					if (this.length && (o = Re.get(r), 1 === r.nodeType && !Fe.get(r, "hasDataAttrs"))) {
						for (n = s.length; n--;) s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = y(i.slice(5)), x(r, i, o[i])));
						Fe.set(r, "hasDataAttrs", !0)
					}
					return o
				}
				return "object" == typeof e ? this.each(function() {
					Re.set(this, e)
				}) : Ie(this, function(t) {
					var n;
					if (r && void 0 === t) {
						if (void 0 !== (n = Re.get(r, e))) return n;
						if (void 0 !== (n = x(r, e))) return n
					} else this.each(function() {
						Re.set(this, e, t)
					})
				}, null, t, arguments.length > 1, null, !0)
			},
			removeData: function(e) {
				return this.each(function() {
					Re.remove(this, e)
				})
			}
		}), Se.extend({
			queue: function(e, t, n) {
				var i;
				if (e) return t = (t || "fx") + "queue", i = Fe.get(e, t), n && (!i || Array.isArray(n) ? i = Fe.access(e, t, Se.makeArray(n)) : i.push(n)), i || []
			},
			dequeue: function(e, t) {
				t = t || "fx";
				var n = Se.queue(e, t),
					i = n.length,
					o = n.shift(),
					r = Se._queueHooks(e, t),
					s = function() {
						Se.dequeue(e, t)
					};
				"inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, s, r)), !i && r && r.empty.fire()
			},
			_queueHooks: function(e, t) {
				var n = t + "queueHooks";
				return Fe.get(e, n) || Fe.access(e, n, {
					empty: Se.Callbacks("once memory").add(function() {
						Fe.remove(e, [t + "queue", n])
					})
				})
			}
		}), Se.fn.extend({
			queue: function(e, t) {
				var n = 2;
				return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? Se.queue(this[0], e) : void 0 === t ? this : this.each(function() {
					var n = Se.queue(this, e, t);
					Se._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && Se.dequeue(this, e)
				})
			},
			dequeue: function(e) {
				return this.each(function() {
					Se.dequeue(this, e)
				})
			},
			clearQueue: function(e) {
				return this.queue(e || "fx", [])
			},
			promise: function(e, t) {
				var n, i = 1,
					o = Se.Deferred(),
					r = this,
					s = this.length,
					a = function() {
						--i || o.resolveWith(r, [r])
					};
				for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; s--;)(n = Fe.get(r[s], e + "queueHooks")) && n.empty && (i++, n.empty.add(a));
				return a(), o.promise(t)
			}
		});
		var Xe = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
			Ye = new RegExp("^(?:([+-])=|)(" + Xe + ")([a-z%]*)$", "i"),
			Ge = ["Top", "Right", "Bottom", "Left"],
			Qe = function(e, t) {
				return e = t || e, "none" === e.style.display || "" === e.style.display && Se.contains(e.ownerDocument, e) && "none" === Se.css(e, "display")
			},
			Je = function(e, t, n, i) {
				var o, r, s = {};
				for (r in t) s[r] = e.style[r], e.style[r] = t[r];
				o = n.apply(e, i || []);
				for (r in t) e.style[r] = s[r];
				return o
			},
			Ze = {};
		Se.fn.extend({
			show: function() {
				return T(this, !0)
			},
			hide: function() {
				return T(this)
			},
			toggle: function(e) {
				return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
					Qe(this) ? Se(this).show() : Se(this).hide()
				})
			}
		});
		var Ke = /^(?:checkbox|radio)$/i,
			et = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i,
			tt = /^$|^module$|\/(?:java|ecma)script/i,
			nt = {
				option: [1, "<select multiple='multiple'>", "</select>"],
				thead: [1, "<table>", "</table>"],
				col: [2, "<table><colgroup>", "</colgroup></table>"],
				tr: [2, "<table><tbody>", "</tbody></table>"],
				td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
				_default: [0, "", ""]
			};
		nt.optgroup = nt.option, nt.tbody = nt.tfoot = nt.colgroup = nt.caption = nt.thead, nt.th = nt.td;
		var it = /<|&#?\w+;/;
		! function() {
			var e = ce.createDocumentFragment(),
				t = e.appendChild(ce.createElement("div")),
				n = ce.createElement("input");
			n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), t.appendChild(n), xe.checkClone = t.cloneNode(!0).cloneNode(!0).lastChild.checked, t.innerHTML = "<textarea>x</textarea>", xe.noCloneChecked = !!t.cloneNode(!0).lastChild.defaultValue
		}();
		var ot = ce.documentElement,
			rt = /^key/,
			st = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
			at = /^([^.]*)(?:\.(.+)|)/;
		Se.event = {
			global: {},
			add: function(e, t, n, i, o) {
				var r, s, a, l, u, c, d, p, f, h, g, m = Fe.get(e);
				if (m)
					for (n.handler && (r = n, n = r.handler, o = r.selector), o && Se.find.matchesSelector(ot, o), n.guid || (n.guid = Se.guid++), (l = m.events) || (l = m.events = {}), (s = m.handle) || (s = m.handle = function(t) {
							return void 0 !== Se && Se.event.triggered !== t.type ? Se.event.dispatch.apply(e, arguments) : void 0
						}), t = (t || "").match(Oe) || [""], u = t.length; u--;) a = at.exec(t[u]) || [], f = g = a[1], h = (a[2] || "").split(".").sort(), f && (d = Se.event.special[f] || {}, f = (o ? d.delegateType : d.bindType) || f, d = Se.event.special[f] || {}, c = Se.extend({
						type: f,
						origType: g,
						data: i,
						handler: n,
						guid: n.guid,
						selector: o,
						needsContext: o && Se.expr.match.needsContext.test(o),
						namespace: h.join(".")
					}, r), (p = l[f]) || (p = l[f] = [], p.delegateCount = 0, d.setup && !1 !== d.setup.call(e, i, h, s) || e.addEventListener && e.addEventListener(f, s)), d.add && (d.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, c) : p.push(c), Se.event.global[f] = !0)
			},
			remove: function(e, t, n, i, o) {
				var r, s, a, l, u, c, d, p, f, h, g, m = Fe.hasData(e) && Fe.get(e);
				if (m && (l = m.events)) {
					for (t = (t || "").match(Oe) || [""], u = t.length; u--;)
						if (a = at.exec(t[u]) || [], f = g = a[1], h = (a[2] || "").split(".").sort(), f) {
							for (d = Se.event.special[f] || {}, f = (i ? d.delegateType : d.bindType) || f, p = l[f] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) c = p[r], !o && g !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (p.splice(r, 1), c.selector && p.delegateCount--, d.remove && d.remove.call(e, c));
							s && !p.length && (d.teardown && !1 !== d.teardown.call(e, h, m.handle) || Se.removeEvent(e, f, m.handle), delete l[f])
						} else
							for (f in l) Se.event.remove(e, f + t[u], n, i, !0);
					Se.isEmptyObject(l) && Fe.remove(e, "handle events")
				}
			},
			dispatch: function(e) {
				var t, n, i, o, r, s, a = Se.event.fix(e),
					l = new Array(arguments.length),
					u = (Fe.get(this, "events") || {})[a.type] || [],
					c = Se.event.special[a.type] || {};
				for (l[0] = a, t = 1; t < arguments.length; t++) l[t] = arguments[t];
				if (a.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, a)) {
					for (s = Se.event.handlers.call(this, a, u), t = 0;
						(o = s[t++]) && !a.isPropagationStopped();)
						for (a.currentTarget = o.elem, n = 0;
							(r = o.handlers[n++]) && !a.isImmediatePropagationStopped();) a.rnamespace && !a.rnamespace.test(r.namespace) || (a.handleObj = r, a.data = r.data, void 0 !== (i = ((Se.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, l)) && !1 === (a.result = i) && (a.preventDefault(), a.stopPropagation()));
					return c.postDispatch && c.postDispatch.call(this, a), a.result
				}
			},
			handlers: function(e, t) {
				var n, i, o, r, s, a = [],
					l = t.delegateCount,
					u = e.target;
				if (l && u.nodeType && !("click" === e.type && e.button >= 1))
					for (; u !== this; u = u.parentNode || this)
						if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
							for (r = [], s = {}, n = 0; n < l; n++) i = t[n], o = i.selector + " ", void 0 === s[o] && (s[o] = i.needsContext ? Se(o, this).index(u) > -1 : Se.find(o, this, null, [u]).length), s[o] && r.push(i);
							r.length && a.push({
								elem: u,
								handlers: r
							})
						}
				return u = this, l < t.length && a.push({
					elem: u,
					handlers: t.slice(l)
				}), a
			},
			addProp: function(e, t) {
				Object.defineProperty(Se.Event.prototype, e, {
					enumerable: !0,
					configurable: !0,
					get: ke(t) ? function() {
						if (this.originalEvent) return t(this.originalEvent)
					} : function() {
						if (this.originalEvent) return this.originalEvent[e]
					},
					set: function(t) {
						Object.defineProperty(this, e, {
							enumerable: !0,
							configurable: !0,
							writable: !0,
							value: t
						})
					}
				})
			},
			fix: function(e) {
				return e[Se.expando] ? e : new Se.Event(e)
			},
			special: {
				load: {
					noBubble: !0
				},
				focus: {
					trigger: function() {
						if (this !== P() && this.focus) return this.focus(), !1
					},
					delegateType: "focusin"
				},
				blur: {
					trigger: function() {
						if (this === P() && this.blur) return this.blur(), !1
					},
					delegateType: "focusout"
				},
				click: {
					trigger: function() {
						if ("checkbox" === this.type && this.click && u(this, "input")) return this.click(), !1
					},
					_default: function(e) {
						return u(e.target, "a")
					}
				},
				beforeunload: {
					postDispatch: function(e) {
						void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
					}
				}
			}
		}, Se.removeEvent = function(e, t, n) {
			e.removeEventListener && e.removeEventListener(t, n)
		}, Se.Event = function(e, t) {
			if (!(this instanceof Se.Event)) return new Se.Event(e, t);
			e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? A : $, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && Se.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[Se.expando] = !0
		}, Se.Event.prototype = {
			constructor: Se.Event,
			isDefaultPrevented: $,
			isPropagationStopped: $,
			isImmediatePropagationStopped: $,
			isSimulated: !1,
			preventDefault: function() {
				var e = this.originalEvent;
				this.isDefaultPrevented = A, e && !this.isSimulated && e.preventDefault()
			},
			stopPropagation: function() {
				var e = this.originalEvent;
				this.isPropagationStopped = A, e && !this.isSimulated && e.stopPropagation()
			},
			stopImmediatePropagation: function() {
				var e = this.originalEvent;
				this.isImmediatePropagationStopped = A, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
			}
		}, Se.each({
			altKey: !0,
			bubbles: !0,
			cancelable: !0,
			changedTouches: !0,
			ctrlKey: !0,
			detail: !0,
			eventPhase: !0,
			metaKey: !0,
			pageX: !0,
			pageY: !0,
			shiftKey: !0,
			view: !0,
			char: !0,
			charCode: !0,
			key: !0,
			keyCode: !0,
			button: !0,
			buttons: !0,
			clientX: !0,
			clientY: !0,
			offsetX: !0,
			offsetY: !0,
			pointerId: !0,
			pointerType: !0,
			screenX: !0,
			screenY: !0,
			targetTouches: !0,
			toElement: !0,
			touches: !0,
			which: function(e) {
				var t = e.button;
				return null == e.which && rt.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && st.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
			}
		}, Se.event.addProp), Se.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function(e, t) {
			Se.event.special[e] = {
				delegateType: t,
				bindType: t,
				handle: function(e) {
					var n, i = this,
						o = e.relatedTarget,
						r = e.handleObj;
					return o && (o === i || Se.contains(i, o)) || (e.type = r.origType, n = r.handler.apply(this, arguments), e.type = t), n
				}
			}
		}), Se.fn.extend({
			on: function(e, t, n, i) {
				return L(this, e, t, n, i)
			},
			one: function(e, t, n, i) {
				return L(this, e, t, n, i, 1)
			},
			off: function(e, t, n) {
				var i, o;
				if (e && e.preventDefault && e.handleObj) return i = e.handleObj, Se(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
				if ("object" == typeof e) {
					for (o in e) this.off(o, t, e[o]);
					return this
				}
				return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = $), this.each(function() {
					Se.event.remove(this, e, n, t)
				})
			}
		});
		var lt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
			ut = /<script|<style|<link/i,
			ct = /checked\s*(?:[^=]|=\s*.checked.)/i,
			dt = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
		Se.extend({
			htmlPrefilter: function(e) {
				return e.replace(lt, "<$1></$2>")
			},
			clone: function(e, t, n) {
				var i, o, r, s, a = e.cloneNode(!0),
					l = Se.contains(e.ownerDocument, e);
				if (!(xe.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || Se.isXMLDoc(e)))
					for (s = S(a), r = S(e), i = 0, o = r.length; i < o; i++) O(r[i], s[i]);
				if (t)
					if (n)
						for (r = r || S(e), s = s || S(a), i = 0, o = r.length; i < o; i++) H(r[i], s[i]);
					else H(e, a);
				return s = S(a, "script"), s.length > 0 && E(s, !l && S(e, "script")), a
			},
			cleanData: function(e) {
				for (var t, n, i, o = Se.event.special, r = 0; void 0 !== (n = e[r]); r++)
					if (Ve(n)) {
						if (t = n[Fe.expando]) {
							if (t.events)
								for (i in t.events) o[i] ? Se.event.remove(n, i) : Se.removeEvent(n, i, t.handle);
							n[Fe.expando] = void 0
						}
						n[Re.expando] && (n[Re.expando] = void 0)
					}
			}
		}), Se.fn.extend({
			detach: function(e) {
				return M(this, e, !0)
			},
			remove: function(e) {
				return M(this, e)
			},
			text: function(e) {
				return Ie(this, function(e) {
					return void 0 === e ? Se.text(this) : this.empty().each(function() {
						1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
					})
				}, null, e, arguments.length)
			},
			append: function() {
				return D(this, arguments, function(e) {
					if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
						N(this, e).appendChild(e)
					}
				})
			},
			prepend: function() {
				return D(this, arguments, function(e) {
					if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
						var t = N(this, e);
						t.insertBefore(e, t.firstChild)
					}
				})
			},
			before: function() {
				return D(this, arguments, function(e) {
					this.parentNode && this.parentNode.insertBefore(e, this)
				})
			},
			after: function() {
				return D(this, arguments, function(e) {
					this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
				})
			},
			empty: function() {
				for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (Se.cleanData(S(e, !1)), e.textContent = "");
				return this
			},
			clone: function(e, t) {
				return e = null != e && e, t = null == t ? e : t, this.map(function() {
					return Se.clone(this, e, t)
				})
			},
			html: function(e) {
				return Ie(this, function(e) {
					var t = this[0] || {},
						n = 0,
						i = this.length;
					if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
					if ("string" == typeof e && !ut.test(e) && !nt[(et.exec(e) || ["", ""])[1].toLowerCase()]) {
						e = Se.htmlPrefilter(e);
						try {
							for (; n < i; n++) t = this[n] || {}, 1 === t.nodeType && (Se.cleanData(S(t, !1)), t.innerHTML = e);
							t = 0
						} catch (e) {}
					}
					t && this.empty().append(e)
				}, null, e, arguments.length)
			},
			replaceWith: function() {
				var e = [];
				return D(this, arguments, function(t) {
					var n = this.parentNode;
					Se.inArray(this, e) < 0 && (Se.cleanData(S(this)), n && n.replaceChild(t, this))
				}, e)
			}
		}), Se.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function(e, t) {
			Se.fn[e] = function(e) {
				for (var n, i = [], o = Se(e), r = o.length - 1, s = 0; s <= r; s++) n = s === r ? this : this.clone(!0), Se(o[s])[t](n), he.apply(i, n.get());
				return this.pushStack(i)
			}
		});
		var pt = new RegExp("^(" + Xe + ")(?!px)[a-z%]+$", "i"),
			ft = function(e) {
				var t = e.ownerDocument.defaultView;
				return t && t.opener || (t = n), t.getComputedStyle(e)
			},
			ht = new RegExp(Ge.join("|"), "i");
		! function() {
			function e() {
				if (u) {
					l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", u.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ot.appendChild(l).appendChild(u);
					var e = n.getComputedStyle(u);
					i = "1%" !== e.top, a = 12 === t(e.marginLeft), u.style.right = "60%", s = 36 === t(e.right), o = 36 === t(e.width), u.style.position = "absolute", r = 36 === u.offsetWidth || "absolute", ot.removeChild(l), u = null
				}
			}

			function t(e) {
				return Math.round(parseFloat(e))
			}
			var i, o, r, s, a, l = ce.createElement("div"),
				u = ce.createElement("div");
			u.style && (u.style.backgroundClip = "content-box", u.cloneNode(!0).style.backgroundClip = "", xe.clearCloneStyle = "content-box" === u.style.backgroundClip, Se.extend(xe, {
				boxSizingReliable: function() {
					return e(), o
				},
				pixelBoxStyles: function() {
					return e(), s
				},
				pixelPosition: function() {
					return e(), i
				},
				reliableMarginLeft: function() {
					return e(), a
				},
				scrollboxSize: function() {
					return e(), r
				}
			}))
		}();
		var gt = /^(none|table(?!-c[ea]).+)/,
			mt = /^--/,
			vt = {
				position: "absolute",
				visibility: "hidden",
				display: "block"
			},
			yt = {
				letterSpacing: "0",
				fontWeight: "400"
			},
			wt = ["Webkit", "Moz", "ms"],
			bt = ce.createElement("div").style;
		Se.extend({
			cssHooks: {
				opacity: {
					get: function(e, t) {
						if (t) {
							var n = I(e, "opacity");
							return "" === n ? "1" : n
						}
					}
				}
			},
			cssNumber: {
				animationIterationCount: !0,
				columnCount: !0,
				fillOpacity: !0,
				flexGrow: !0,
				flexShrink: !0,
				fontWeight: !0,
				lineHeight: !0,
				opacity: !0,
				order: !0,
				orphans: !0,
				widows: !0,
				zIndex: !0,
				zoom: !0
			},
			cssProps: {},
			style: function(e, t, n, i) {
				if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
					var o, r, s, a = y(t),
						l = mt.test(t),
						u = e.style;
					if (l || (t = V(a)), s = Se.cssHooks[t] || Se.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : u[t];
					r = typeof n, "string" === r && (o = Ye.exec(n)) && o[1] && (n = k(e, t, o), r = "number"), null != n && n === n && ("number" === r && (n += o && o[3] || (Se.cssNumber[a] ? "" : "px")), xe.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (u[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, i)) || (l ? u.setProperty(t, n) : u[t] = n))
				}
			},
			css: function(e, t, n, i) {
				var o, r, s, a = y(t);
				return mt.test(t) || (t = V(a)), s = Se.cssHooks[t] || Se.cssHooks[a], s && "get" in s && (o = s.get(e, !0, n)), void 0 === o && (o = I(e, t, i)), "normal" === o && t in yt && (o = yt[t]), "" === n || n ? (r = parseFloat(o), !0 === n || isFinite(r) ? r || 0 : o) : o
			}
		}), Se.each(["height", "width"], function(e, t) {
			Se.cssHooks[t] = {
				get: function(e, n, i) {
					if (n) return !gt.test(Se.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? W(e, t, i) : Je(e, vt, function() {
						return W(e, t, i)
					})
				},
				set: function(e, n, i) {
					var o, r = ft(e),
						s = "border-box" === Se.css(e, "boxSizing", !1, r),
						a = i && R(e, t, i, s, r);
					return s && xe.scrollboxSize() === r.position && (a -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(r[t]) - R(e, t, "border", !1, r) - .5)), a && (o = Ye.exec(n)) && "px" !== (o[3] || "px") && (e.style[t] = n, n = Se.css(e, t)), F(e, n, a)
				}
			}
		}), Se.cssHooks.marginLeft = B(xe.reliableMarginLeft, function(e, t) {
			if (t) return (parseFloat(I(e, "marginLeft")) || e.getBoundingClientRect().left - Je(e, {
				marginLeft: 0
			}, function() {
				return e.getBoundingClientRect().left
			})) + "px"
		}), Se.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function(e, t) {
			Se.cssHooks[e + t] = {
				expand: function(n) {
					for (var i = 0, o = {}, r = "string" == typeof n ? n.split(" ") : [n]; i < 4; i++) o[e + Ge[i] + t] = r[i] || r[i - 2] || r[0];
					return o
				}
			}, "margin" !== e && (Se.cssHooks[e + t].set = F)
		}), Se.fn.extend({
			css: function(e, t) {
				return Ie(this, function(e, t, n) {
					var i, o, r = {},
						s = 0;
					if (Array.isArray(t)) {
						for (i = ft(e), o = t.length; s < o; s++) r[t[s]] = Se.css(e, t[s], !1, i);
						return r
					}
					return void 0 !== n ? Se.style(e, t, n) : Se.css(e, t)
				}, e, t, arguments.length > 1)
			}
		}), Se.Tween = U, U.prototype = {
			constructor: U,
			init: function(e, t, n, i, o, r) {
				this.elem = e, this.prop = n, this.easing = o || Se.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (Se.cssNumber[n] ? "" : "px")
			},
			cur: function() {
				var e = U.propHooks[this.prop];
				return e && e.get ? e.get(this) : U.propHooks._default.get(this)
			},
			run: function(e) {
				var t, n = U.propHooks[this.prop];
				return this.options.duration ? this.pos = t = Se.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : U.propHooks._default.set(this), this
			}
		}, U.prototype.init.prototype = U.prototype, U.propHooks = {
			_default: {
				get: function(e) {
					var t;
					return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = Se.css(e.elem, e.prop, ""), t && "auto" !== t ? t : 0)
				},
				set: function(e) {
					Se.fx.step[e.prop] ? Se.fx.step[e.prop](e) : 1 !== e.elem.nodeType || null == e.elem.style[Se.cssProps[e.prop]] && !Se.cssHooks[e.prop] ? e.elem[e.prop] = e.now : Se.style(e.elem, e.prop, e.now + e.unit)
				}
			}
		}, U.propHooks.scrollTop = U.propHooks.scrollLeft = {
			set: function(e) {
				e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
			}
		}, Se.easing = {
			linear: function(e) {
				return e
			},
			swing: function(e) {
				return .5 - Math.cos(e * Math.PI) / 2
			},
			_default: "swing"
		}, Se.fx = U.prototype.init, Se.fx.step = {};
		var xt, kt, Ct = /^(?:toggle|show|hide)$/,
			Tt = /queueHooks$/;
		Se.Animation = Se.extend(K, {
				tweeners: {
					"*": [function(e, t) {
						var n = this.createTween(e, t);
						return k(n.elem, e, Ye.exec(t), n), n
					}]
				},
				tweener: function(e, t) {
					ke(e) ? (t = e, e = ["*"]) : e = e.match(Oe);
					for (var n, i = 0, o = e.length; i < o; i++) n = e[i], K.tweeners[n] = K.tweeners[n] || [], K.tweeners[n].unshift(t)
				},
				prefilters: [J],
				prefilter: function(e, t) {
					t ? K.prefilters.unshift(e) : K.prefilters.push(e)
				}
			}), Se.speed = function(e, t, n) {
				var i = e && "object" == typeof e ? Se.extend({}, e) : {
					complete: n || !n && t || ke(e) && e,
					duration: e,
					easing: n && t || t && !ke(t) && t
				};
				return Se.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in Se.fx.speeds ? i.duration = Se.fx.speeds[i.duration] : i.duration = Se.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
					ke(i.old) && i.old.call(this), i.queue && Se.dequeue(this, i.queue)
				}, i
			}, Se.fn.extend({
				fadeTo: function(e, t, n, i) {
					return this.filter(Qe).css("opacity", 0).show().end().animate({
						opacity: t
					}, e, n, i)
				},
				animate: function(e, t, n, i) {
					var o = Se.isEmptyObject(e),
						r = Se.speed(t, n, i),
						s = function() {
							var t = K(this, Se.extend({}, e), r);
							(o || Fe.get(this, "finish")) && t.stop(!0)
						};
					return s.finish = s, o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
				},
				stop: function(e, t, n) {
					var i = function(e) {
						var t = e.stop;
						delete e.stop, t(n)
					};
					return "string" != typeof e && (n = t, t = e, e = void 0), t && !1 !== e && this.queue(e || "fx", []), this.each(function() {
						var t = !0,
							o = null != e && e + "queueHooks",
							r = Se.timers,
							s = Fe.get(this);
						if (o) s[o] && s[o].stop && i(s[o]);
						else
							for (o in s) s[o] && s[o].stop && Tt.test(o) && i(s[o]);
						for (o = r.length; o--;) r[o].elem !== this || null != e && r[o].queue !== e || (r[o].anim.stop(n), t = !1, r.splice(o, 1));
						!t && n || Se.dequeue(this, e)
					})
				},
				finish: function(e) {
					return !1 !== e && (e = e || "fx"), this.each(function() {
						var t, n = Fe.get(this),
							i = n[e + "queue"],
							o = n[e + "queueHooks"],
							r = Se.timers,
							s = i ? i.length : 0;
						for (n.finish = !0, Se.queue(this, e, []), o && o.stop && o.stop.call(this, !0), t = r.length; t--;) r[t].elem === this && r[t].queue === e && (r[t].anim.stop(!0), r.splice(t, 1));
						for (t = 0; t < s; t++) i[t] && i[t].finish && i[t].finish.call(this);
						delete n.finish
					})
				}
			}), Se.each(["toggle", "show", "hide"], function(e, t) {
				var n = Se.fn[t];
				Se.fn[t] = function(e, i, o) {
					return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(G(t, !0), e, i, o)
				}
			}), Se.each({
				slideDown: G("show"),
				slideUp: G("hide"),
				slideToggle: G("toggle"),
				fadeIn: {
					opacity: "show"
				},
				fadeOut: {
					opacity: "hide"
				},
				fadeToggle: {
					opacity: "toggle"
				}
			}, function(e, t) {
				Se.fn[e] = function(e, n, i) {
					return this.animate(t, e, n, i)
				}
			}), Se.timers = [], Se.fx.tick = function() {
				var e, t = 0,
					n = Se.timers;
				for (xt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
				n.length || Se.fx.stop(), xt = void 0
			}, Se.fx.timer = function(e) {
				Se.timers.push(e), Se.fx.start()
			}, Se.fx.interval = 13, Se.fx.start = function() {
				kt || (kt = !0, X())
			}, Se.fx.stop = function() {
				kt = null
			}, Se.fx.speeds = {
				slow: 600,
				fast: 200,
				_default: 400
			}, Se.fn.delay = function(e, t) {
				return e = Se.fx ? Se.fx.speeds[e] || e : e, t = t || "fx", this.queue(t, function(t, i) {
					var o = n.setTimeout(t, e);
					i.stop = function() {
						n.clearTimeout(o)
					}
				})
			},
			function() {
				var e = ce.createElement("input"),
					t = ce.createElement("select"),
					n = t.appendChild(ce.createElement("option"));
				e.type = "checkbox", xe.checkOn = "" !== e.value, xe.optSelected = n.selected, e = ce.createElement("input"), e.value = "t", e.type = "radio", xe.radioValue = "t" === e.value
			}();
		var St, Et = Se.expr.attrHandle;
		Se.fn.extend({
			attr: function(e, t) {
				return Ie(this, Se.attr, e, t, arguments.length > 1)
			},
			removeAttr: function(e) {
				return this.each(function() {
					Se.removeAttr(this, e)
				})
			}
		}), Se.extend({
			attr: function(e, t, n) {
				var i, o, r = e.nodeType;
				if (3 !== r && 8 !== r && 2 !== r) return void 0 === e.getAttribute ? Se.prop(e, t, n) : (1 === r && Se.isXMLDoc(e) || (o = Se.attrHooks[t.toLowerCase()] || (Se.expr.match.bool.test(t) ? St : void 0)), void 0 !== n ? null === n ? void Se.removeAttr(e, t) : o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : o && "get" in o && null !== (i = o.get(e, t)) ? i : (i = Se.find.attr(e, t), null == i ? void 0 : i))
			},
			attrHooks: {
				type: {
					set: function(e, t) {
						if (!xe.radioValue && "radio" === t && u(e, "input")) {
							var n = e.value;
							return e.setAttribute("type", t), n && (e.value = n), t
						}
					}
				}
			},
			removeAttr: function(e, t) {
				var n, i = 0,
					o = t && t.match(Oe);
				if (o && 1 === e.nodeType)
					for (; n = o[i++];) e.removeAttribute(n)
			}
		}), St = {
			set: function(e, t, n) {
				return !1 === t ? Se.removeAttr(e, n) : e.setAttribute(n, n), n
			}
		}, Se.each(Se.expr.match.bool.source.match(/\w+/g), function(e, t) {
			var n = Et[t] || Se.find.attr;
			Et[t] = function(e, t, i) {
				var o, r, s = t.toLowerCase();
				return i || (r = Et[s], Et[s] = o, o = null != n(e, t, i) ? s : null, Et[s] = r), o
			}
		});
		var _t = /^(?:input|select|textarea|button)$/i,
			At = /^(?:a|area)$/i;
		Se.fn.extend({
			prop: function(e, t) {
				return Ie(this, Se.prop, e, t, arguments.length > 1)
			},
			removeProp: function(e) {
				return this.each(function() {
					delete this[Se.propFix[e] || e]
				})
			}
		}), Se.extend({
			prop: function(e, t, n) {
				var i, o, r = e.nodeType;
				if (3 !== r && 8 !== r && 2 !== r) return 1 === r && Se.isXMLDoc(e) || (t = Se.propFix[t] || t, o = Se.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
			},
			propHooks: {
				tabIndex: {
					get: function(e) {
						var t = Se.find.attr(e, "tabindex");
						return t ? parseInt(t, 10) : _t.test(e.nodeName) || At.test(e.nodeName) && e.href ? 0 : -1
					}
				}
			},
			propFix: {
				for: "htmlFor",
				class: "className"
			}
		}), xe.optSelected || (Se.propHooks.selected = {
			get: function(e) {
				var t = e.parentNode;
				return t && t.parentNode && t.parentNode.selectedIndex, null
			},
			set: function(e) {
				var t = e.parentNode;
				t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
			}
		}), Se.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
			Se.propFix[this.toLowerCase()] = this
		}), Se.fn.extend({
			addClass: function(e) {
				var t, n, i, o, r, s, a, l = 0;
				if (ke(e)) return this.each(function(t) {
					Se(this).addClass(e.call(this, t, te(this)))
				});
				if (t = ne(e), t.length)
					for (; n = this[l++];)
						if (o = te(n), i = 1 === n.nodeType && " " + ee(o) + " ") {
							for (s = 0; r = t[s++];) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
							a = ee(i), o !== a && n.setAttribute("class", a)
						}
				return this
			},
			removeClass: function(e) {
				var t, n, i, o, r, s, a, l = 0;
				if (ke(e)) return this.each(function(t) {
					Se(this).removeClass(e.call(this, t, te(this)))
				});
				if (!arguments.length) return this.attr("class", "");
				if (t = ne(e), t.length)
					for (; n = this[l++];)
						if (o = te(n), i = 1 === n.nodeType && " " + ee(o) + " ") {
							for (s = 0; r = t[s++];)
								for (; i.indexOf(" " + r + " ") > -1;) i = i.replace(" " + r + " ", " ");
							a = ee(i), o !== a && n.setAttribute("class", a)
						}
				return this
			},
			toggleClass: function(e, t) {
				var n = typeof e,
					i = "string" === n || Array.isArray(e);
				return "boolean" == typeof t && i ? t ? this.addClass(e) : this.removeClass(e) : ke(e) ? this.each(function(n) {
					Se(this).toggleClass(e.call(this, n, te(this), t), t)
				}) : this.each(function() {
					var t, o, r, s;
					if (i)
						for (o = 0, r = Se(this), s = ne(e); t = s[o++];) r.hasClass(t) ? r.removeClass(t) : r.addClass(t);
					else void 0 !== e && "boolean" !== n || (t = te(this), t && Fe.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Fe.get(this, "__className__") || ""))
				})
			},
			hasClass: function(e) {
				var t, n, i = 0;
				for (t = " " + e + " "; n = this[i++];)
					if (1 === n.nodeType && (" " + ee(te(n)) + " ").indexOf(t) > -1) return !0;
				return !1
			}
		});
		var $t = /\r/g;
		Se.fn.extend({
			val: function(e) {
				var t, n, i, o = this[0]; {
					if (arguments.length) return i = ke(e), this.each(function(n) {
						var o;
						1 === this.nodeType && (o = i ? e.call(this, n, Se(this).val()) : e, null == o ? o = "" : "number" == typeof o ? o += "" : Array.isArray(o) && (o = Se.map(o, function(e) {
							return null == e ? "" : e + ""
						})), (t = Se.valHooks[this.type] || Se.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, o, "value") || (this.value = o))
					});
					if (o) return (t = Se.valHooks[o.type] || Se.valHooks[o.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(o, "value")) ? n : (n = o.value, "string" == typeof n ? n.replace($t, "") : null == n ? "" : n)
				}
			}
		}), Se.extend({
			valHooks: {
				option: {
					get: function(e) {
						var t = Se.find.attr(e, "value");
						return null != t ? t : ee(Se.text(e))
					}
				},
				select: {
					get: function(e) {
						var t, n, i, o = e.options,
							r = e.selectedIndex,
							s = "select-one" === e.type,
							a = s ? null : [],
							l = s ? r + 1 : o.length;
						for (i = r < 0 ? l : s ? r : 0; i < l; i++)
							if (n = o[i], (n.selected || i === r) && !n.disabled && (!n.parentNode.disabled || !u(n.parentNode, "optgroup"))) {
								if (t = Se(n).val(), s) return t;
								a.push(t)
							}
						return a
					},
					set: function(e, t) {
						for (var n, i, o = e.options, r = Se.makeArray(t), s = o.length; s--;) i = o[s], (i.selected = Se.inArray(Se.valHooks.option.get(i), r) > -1) && (n = !0);
						return n || (e.selectedIndex = -1), r
					}
				}
			}
		}), Se.each(["radio", "checkbox"], function() {
			Se.valHooks[this] = {
				set: function(e, t) {
					if (Array.isArray(t)) return e.checked = Se.inArray(Se(e).val(), t) > -1
				}
			}, xe.checkOn || (Se.valHooks[this].get = function(e) {
				return null === e.getAttribute("value") ? "on" : e.value
			})
		}), xe.focusin = "onfocusin" in n;
		var Pt = /^(?:focusinfocus|focusoutblur)$/,
			Lt = function(e) {
				e.stopPropagation()
			};
		Se.extend(Se.event, {
			trigger: function(e, t, i, o) {
				var r, s, a, l, u, c, d, p, f = [i || ce],
					h = ye.call(e, "type") ? e.type : e,
					g = ye.call(e, "namespace") ? e.namespace.split(".") : [];
				if (s = p = a = i = i || ce, 3 !== i.nodeType && 8 !== i.nodeType && !Pt.test(h + Se.event.triggered) && (h.indexOf(".") > -1 && (g = h.split("."), h = g.shift(), g.sort()), u = h.indexOf(":") < 0 && "on" + h, e = e[Se.expando] ? e : new Se.Event(h, "object" == typeof e && e), e.isTrigger = o ? 2 : 3, e.namespace = g.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), t = null == t ? [e] : Se.makeArray(t, [e]), d = Se.event.special[h] || {}, o || !d.trigger || !1 !== d.trigger.apply(i, t))) {
					if (!o && !d.noBubble && !Ce(i)) {
						for (l = d.delegateType || h, Pt.test(l + h) || (s = s.parentNode); s; s = s.parentNode) f.push(s), a = s;
						a === (i.ownerDocument || ce) && f.push(a.defaultView || a.parentWindow || n)
					}
					for (r = 0;
						(s = f[r++]) && !e.isPropagationStopped();) p = s, e.type = r > 1 ? l : d.bindType || h, c = (Fe.get(s, "events") || {})[e.type] && Fe.get(s, "handle"), c && c.apply(s, t), (c = u && s[u]) && c.apply && Ve(s) && (e.result = c.apply(s, t), !1 === e.result && e.preventDefault());
					return e.type = h, o || e.isDefaultPrevented() || d._default && !1 !== d._default.apply(f.pop(), t) || !Ve(i) || u && ke(i[h]) && !Ce(i) && (a = i[u], a && (i[u] = null), Se.event.triggered = h, e.isPropagationStopped() && p.addEventListener(h, Lt), i[h](), e.isPropagationStopped() && p.removeEventListener(h, Lt), Se.event.triggered = void 0, a && (i[u] = a)), e.result
				}
			},
			simulate: function(e, t, n) {
				var i = Se.extend(new Se.Event, n, {
					type: e,
					isSimulated: !0
				});
				Se.event.trigger(i, null, t)
			}
		}), Se.fn.extend({
			trigger: function(e, t) {
				return this.each(function() {
					Se.event.trigger(e, t, this)
				})
			},
			triggerHandler: function(e, t) {
				var n = this[0];
				if (n) return Se.event.trigger(e, t, n, !0)
			}
		}), xe.focusin || Se.each({
			focus: "focusin",
			blur: "focusout"
		}, function(e, t) {
			var n = function(e) {
				Se.event.simulate(t, e.target, Se.event.fix(e))
			};
			Se.event.special[t] = {
				setup: function() {
					var i = this.ownerDocument || this,
						o = Fe.access(i, t);
					o || i.addEventListener(e, n, !0), Fe.access(i, t, (o || 0) + 1)
				},
				teardown: function() {
					var i = this.ownerDocument || this,
						o = Fe.access(i, t) - 1;
					o ? Fe.access(i, t, o) : (i.removeEventListener(e, n, !0), Fe.remove(i, t))
				}
			}
		});
		var Nt = n.location,
			jt = Date.now(),
			qt = /\?/;
		Se.parseXML = function(e) {
			var t;
			if (!e || "string" != typeof e) return null;
			try {
				t = (new n.DOMParser).parseFromString(e, "text/xml")
			} catch (e) {
				t = void 0
			}
			return t && !t.getElementsByTagName("parsererror").length || Se.error("Invalid XML: " + e), t
		};
		var Ht = /\[\]$/,
			Ot = /\r?\n/g,
			Dt = /^(?:submit|button|image|reset|file)$/i,
			Mt = /^(?:input|select|textarea|keygen)/i;
		Se.param = function(e, t) {
			var n, i = [],
				o = function(e, t) {
					var n = ke(t) ? t() : t;
					i[i.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
				};
			if (Array.isArray(e) || e.jquery && !Se.isPlainObject(e)) Se.each(e, function() {
				o(this.name, this.value)
			});
			else
				for (n in e) ie(n, e[n], t, o);
			return i.join("&")
		}, Se.fn.extend({
			serialize: function() {
				return Se.param(this.serializeArray())
			},
			serializeArray: function() {
				return this.map(function() {
					var e = Se.prop(this, "elements");
					return e ? Se.makeArray(e) : this
				}).filter(function() {
					var e = this.type;
					return this.name && !Se(this).is(":disabled") && Mt.test(this.nodeName) && !Dt.test(e) && (this.checked || !Ke.test(e))
				}).map(function(e, t) {
					var n = Se(this).val();
					return null == n ? null : Array.isArray(n) ? Se.map(n, function(e) {
						return {
							name: t.name,
							value: e.replace(Ot, "\r\n")
						}
					}) : {
						name: t.name,
						value: n.replace(Ot, "\r\n")
					}
				}).get()
			}
		});
		var It = /%20/g,
			Bt = /#.*$/,
			zt = /([?&])_=[^&]*/,
			Vt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
			Ft = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
			Rt = /^(?:GET|HEAD)$/,
			Wt = /^\/\//,
			Ut = {},
			Xt = {},
			Yt = "*/".concat("*"),
			Gt = ce.createElement("a");
		Gt.href = Nt.href, Se.extend({
			active: 0,
			lastModified: {},
			etag: {},
			ajaxSettings: {
				url: Nt.href,
				type: "GET",
				isLocal: Ft.test(Nt.protocol),
				global: !0,
				processData: !0,
				async: !0,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",
				accepts: {
					"*": Yt,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},
				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},
				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},
				converters: {
					"* text": String,
					"text html": !0,
					"text json": JSON.parse,
					"text xml": Se.parseXML
				},
				flatOptions: {
					url: !0,
					context: !0
				}
			},
			ajaxSetup: function(e, t) {
				return t ? se(se(e, Se.ajaxSettings), t) : se(Se.ajaxSettings, e)
			},
			ajaxPrefilter: oe(Ut),
			ajaxTransport: oe(Xt),
			ajax: function(e, t) {
				function i(e, t, i, a) {
					var u, p, f, b, x, k = t;
					c || (c = !0, l && n.clearTimeout(l), o = void 0, s = a || "", C.readyState = e > 0 ? 4 : 0, u = e >= 200 && e < 300 || 304 === e, i && (b = ae(h, C, i)), b = le(h, b, C, u), u ? (h.ifModified && (x = C.getResponseHeader("Last-Modified"), x && (Se.lastModified[r] = x), (x = C.getResponseHeader("etag")) && (Se.etag[r] = x)), 204 === e || "HEAD" === h.type ? k = "nocontent" : 304 === e ? k = "notmodified" : (k = b.state, p = b.data, f = b.error, u = !f)) : (f = k, !e && k || (k = "error", e < 0 && (e = 0))), C.status = e, C.statusText = (t || k) + "", u ? v.resolveWith(g, [p, k, C]) : v.rejectWith(g, [C, k, f]), C.statusCode(w), w = void 0, d && m.trigger(u ? "ajaxSuccess" : "ajaxError", [C, h, u ? p : f]), y.fireWith(g, [C, k]), d && (m.trigger("ajaxComplete", [C, h]), --Se.active || Se.event.trigger("ajaxStop")))
				}
				"object" == typeof e && (t = e, e = void 0), t = t || {};
				var o, r, s, a, l, u, c, d, p, f, h = Se.ajaxSetup({}, t),
					g = h.context || h,
					m = h.context && (g.nodeType || g.jquery) ? Se(g) : Se.event,
					v = Se.Deferred(),
					y = Se.Callbacks("once memory"),
					w = h.statusCode || {},
					b = {},
					x = {},
					k = "canceled",
					C = {
						readyState: 0,
						getResponseHeader: function(e) {
							var t;
							if (c) {
								if (!a)
									for (a = {}; t = Vt.exec(s);) a[t[1].toLowerCase()] = t[2];
								t = a[e.toLowerCase()]
							}
							return null == t ? null : t
						},
						getAllResponseHeaders: function() {
							return c ? s : null
						},
						setRequestHeader: function(e, t) {
							return null == c && (e = x[e.toLowerCase()] = x[e.toLowerCase()] || e, b[e] = t), this
						},
						overrideMimeType: function(e) {
							return null == c && (h.mimeType = e), this
						},
						statusCode: function(e) {
							var t;
							if (e)
								if (c) C.always(e[C.status]);
								else
									for (t in e) w[t] = [w[t], e[t]];
							return this
						},
						abort: function(e) {
							var t = e || k;
							return o && o.abort(t), i(0, t), this
						}
					};
				if (v.promise(C), h.url = ((e || h.url || Nt.href) + "").replace(Wt, Nt.protocol + "//"), h.type = t.method || t.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(Oe) || [""], null == h.crossDomain) {
					u = ce.createElement("a");
					try {
						u.href = h.url, u.href = u.href, h.crossDomain = Gt.protocol + "//" + Gt.host != u.protocol + "//" + u.host
					} catch (e) {
						h.crossDomain = !0
					}
				}
				if (h.data && h.processData && "string" != typeof h.data && (h.data = Se.param(h.data, h.traditional)), re(Ut, h, t, C), c) return C;
				d = Se.event && h.global, d && 0 == Se.active++ && Se.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Rt.test(h.type), r = h.url.replace(Bt, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(It, "+")) : (f = h.url.slice(r.length), h.data && (h.processData || "string" == typeof h.data) && (r += (qt.test(r) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (r = r.replace(zt, "$1"), f = (qt.test(r) ? "&" : "?") + "_=" + jt++ + f), h.url = r + f), h.ifModified && (Se.lastModified[r] && C.setRequestHeader("If-Modified-Since", Se.lastModified[r]), Se.etag[r] && C.setRequestHeader("If-None-Match", Se.etag[r])), (h.data && h.hasContent && !1 !== h.contentType || t.contentType) && C.setRequestHeader("Content-Type", h.contentType), C.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + Yt + "; q=0.01" : "") : h.accepts["*"]);
				for (p in h.headers) C.setRequestHeader(p, h.headers[p]);
				if (h.beforeSend && (!1 === h.beforeSend.call(g, C, h) || c)) return C.abort();
				if (k = "abort", y.add(h.complete), C.done(h.success), C.fail(h.error), o = re(Xt, h, t, C)) {
					if (C.readyState = 1, d && m.trigger("ajaxSend", [C, h]), c) return C;
					h.async && h.timeout > 0 && (l = n.setTimeout(function() {
						C.abort("timeout")
					}, h.timeout));
					try {
						c = !1, o.send(b, i)
					} catch (e) {
						if (c) throw e;
						i(-1, e)
					}
				} else i(-1, "No Transport");
				return C
			},
			getJSON: function(e, t, n) {
				return Se.get(e, t, n, "json")
			},
			getScript: function(e, t) {
				return Se.get(e, void 0, t, "script")
			}
		}), Se.each(["get", "post"], function(e, t) {
			Se[t] = function(e, n, i, o) {
				return ke(n) && (o = o || i, i = n, n = void 0), Se.ajax(Se.extend({
					url: e,
					type: t,
					dataType: o,
					data: n,
					success: i
				}, Se.isPlainObject(e) && e))
			}
		}), Se._evalUrl = function(e) {
			return Se.ajax({
				url: e,
				type: "GET",
				dataType: "script",
				cache: !0,
				async: !1,
				global: !1,
				throws: !0
			})
		}, Se.fn.extend({
			wrapAll: function(e) {
				var t;
				return this[0] && (ke(e) && (e = e.call(this[0])), t = Se(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
					for (var e = this; e.firstElementChild;) e = e.firstElementChild;
					return e
				}).append(this)), this
			},
			wrapInner: function(e) {
				return ke(e) ? this.each(function(t) {
					Se(this).wrapInner(e.call(this, t))
				}) : this.each(function() {
					var t = Se(this),
						n = t.contents();
					n.length ? n.wrapAll(e) : t.append(e)
				})
			},
			wrap: function(e) {
				var t = ke(e);
				return this.each(function(n) {
					Se(this).wrapAll(t ? e.call(this, n) : e)
				})
			},
			unwrap: function(e) {
				return this.parent(e).not("body").each(function() {
					Se(this).replaceWith(this.childNodes)
				}), this
			}
		}), Se.expr.pseudos.hidden = function(e) {
			return !Se.expr.pseudos.visible(e)
		}, Se.expr.pseudos.visible = function(e) {
			return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
		}, Se.ajaxSettings.xhr = function() {
			try {
				return new n.XMLHttpRequest
			} catch (e) {}
		};
		var Qt = {
				0: 200,
				1223: 204
			},
			Jt = Se.ajaxSettings.xhr();
		xe.cors = !!Jt && "withCredentials" in Jt, xe.ajax = Jt = !!Jt, Se.ajaxTransport(function(e) {
			var t, i;
			if (xe.cors || Jt && !e.crossDomain) return {
				send: function(o, r) {
					var s, a = e.xhr();
					if (a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
						for (s in e.xhrFields) a[s] = e.xhrFields[s];
					e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest");
					for (s in o) a.setRequestHeader(s, o[s]);
					t = function(e) {
						return function() {
							t && (t = i = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null, "abort" === e ? a.abort() : "error" === e ? "number" != typeof a.status ? r(0, "error") : r(a.status, a.statusText) : r(Qt[a.status] || a.status, a.statusText, "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? {
								binary: a.response
							} : {
								text: a.responseText
							}, a.getAllResponseHeaders()))
						}
					}, a.onload = t(), i = a.onerror = a.ontimeout = t("error"), void 0 !== a.onabort ? a.onabort = i : a.onreadystatechange = function() {
						4 === a.readyState && n.setTimeout(function() {
							t && i()
						})
					}, t = t("abort");
					try {
						a.send(e.hasContent && e.data || null)
					} catch (e) {
						if (t) throw e
					}
				},
				abort: function() {
					t && t()
				}
			}
		}), Se.ajaxPrefilter(function(e) {
			e.crossDomain && (e.contents.script = !1)
		}), Se.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function(e) {
					return Se.globalEval(e), e
				}
			}
		}), Se.ajaxPrefilter("script", function(e) {
			void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
		}), Se.ajaxTransport("script", function(e) {
			if (e.crossDomain) {
				var t, n;
				return {
					send: function(i, o) {
						t = Se("<script>").prop({
							charset: e.scriptCharset,
							src: e.url
						}).on("load error", n = function(e) {
							t.remove(), n = null, e && o("error" === e.type ? 404 : 200, e.type)
						}), ce.head.appendChild(t[0])
					},
					abort: function() {
						n && n()
					}
				}
			}
		});
		var Zt = [],
			Kt = /(=)\?(?=&|$)|\?\?/;
		Se.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function() {
				var e = Zt.pop() || Se.expando + "_" + jt++;
				return this[e] = !0, e
			}
		}), Se.ajaxPrefilter("json jsonp", function(e, t, i) {
			var o, r, s, a = !1 !== e.jsonp && (Kt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Kt.test(e.data) && "data");
			if (a || "jsonp" === e.dataTypes[0]) return o = e.jsonpCallback = ke(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Kt, "$1" + o) : !1 !== e.jsonp && (e.url += (qt.test(e.url) ? "&" : "?") + e.jsonp + "=" + o), e.converters["script json"] = function() {
				return s || Se.error(o + " was not called"), s[0]
			}, e.dataTypes[0] = "json", r = n[o], n[o] = function() {
				s = arguments
			}, i.always(function() {
				void 0 === r ? Se(n).removeProp(o) : n[o] = r, e[o] && (e.jsonpCallback = t.jsonpCallback, Zt.push(o)), s && ke(r) && r(s[0]), s = r = void 0
			}), "script"
		}), xe.createHTMLDocument = function() {
			var e = ce.implementation.createHTMLDocument("").body;
			return e.innerHTML = "<form></form><form></form>", 2 === e.childNodes.length
		}(), Se.parseHTML = function(e, t, n) {
			if ("string" != typeof e) return [];
			"boolean" == typeof t && (n = t, t = !1);
			var i, o, r;
			return t || (xe.createHTMLDocument ? (t = ce.implementation.createHTMLDocument(""), i = t.createElement("base"), i.href = ce.location.href, t.head.appendChild(i)) : t = ce), o = Le.exec(e), r = !n && [], o ? [t.createElement(o[1])] : (o = _([e], t, r), r && r.length && Se(r).remove(), Se.merge([], o.childNodes))
		}, Se.fn.load = function(e, t, n) {
			var i, o, r, s = this,
				a = e.indexOf(" ");
			return a > -1 && (i = ee(e.slice(a)), e = e.slice(0, a)), ke(t) ? (n = t, t = void 0) : t && "object" == typeof t && (o = "POST"), s.length > 0 && Se.ajax({
				url: e,
				type: o || "GET",
				dataType: "html",
				data: t
			}).done(function(e) {
				r = arguments, s.html(i ? Se("<div>").append(Se.parseHTML(e)).find(i) : e)
			}).always(n && function(e, t) {
				s.each(function() {
					n.apply(this, r || [e.responseText, t, e])
				})
			}), this
		}, Se.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
			Se.fn[t] = function(e) {
				return this.on(t, e)
			}
		}), Se.expr.pseudos.animated = function(e) {
			return Se.grep(Se.timers, function(t) {
				return e === t.elem
			}).length
		}, Se.offset = {
			setOffset: function(e, t, n) {
				var i, o, r, s, a, l, u, c = Se.css(e, "position"),
					d = Se(e),
					p = {};
				"static" === c && (e.style.position = "relative"), a = d.offset(), r = Se.css(e, "top"), l = Se.css(e, "left"), u = ("absolute" === c || "fixed" === c) && (r + l).indexOf("auto") > -1, u ? (i = d.position(), s = i.top, o = i.left) : (s = parseFloat(r) || 0, o = parseFloat(l) || 0), ke(t) && (t = t.call(e, n, Se.extend({}, a))), null != t.top && (p.top = t.top - a.top + s), null != t.left && (p.left = t.left - a.left + o), "using" in t ? t.using.call(e, p) : d.css(p)
			}
		}, Se.fn.extend({
			offset: function(e) {
				if (arguments.length) return void 0 === e ? this : this.each(function(t) {
					Se.offset.setOffset(this, e, t)
				});
				var t, n, i = this[0];
				if (i) return i.getClientRects().length ? (t = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
					top: t.top + n.pageYOffset,
					left: t.left + n.pageXOffset
				}) : {
					top: 0,
					left: 0
				}
			},
			position: function() {
				if (this[0]) {
					var e, t, n, i = this[0],
						o = {
							top: 0,
							left: 0
						};
					if ("fixed" === Se.css(i, "position")) t = i.getBoundingClientRect();
					else {
						for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === Se.css(e, "position");) e = e.parentNode;
						e && e !== i && 1 === e.nodeType && (o = Se(e).offset(), o.top += Se.css(e, "borderTopWidth", !0), o.left += Se.css(e, "borderLeftWidth", !0))
					}
					return {
						top: t.top - o.top - Se.css(i, "marginTop", !0),
						left: t.left - o.left - Se.css(i, "marginLeft", !0)
					}
				}
			},
			offsetParent: function() {
				return this.map(function() {
					for (var e = this.offsetParent; e && "static" === Se.css(e, "position");) e = e.offsetParent;
					return e || ot
				})
			}
		}), Se.each({
			scrollLeft: "pageXOffset",
			scrollTop: "pageYOffset"
		}, function(e, t) {
			var n = "pageYOffset" === t;
			Se.fn[e] = function(i) {
				return Ie(this, function(e, i, o) {
					var r;
					if (Ce(e) ? r = e : 9 === e.nodeType && (r = e.defaultView), void 0 === o) return r ? r[t] : e[i];
					r ? r.scrollTo(n ? r.pageXOffset : o, n ? o : r.pageYOffset) : e[i] = o
				}, e, i, arguments.length)
			}
		}), Se.each(["top", "left"], function(e, t) {
			Se.cssHooks[t] = B(xe.pixelPosition, function(e, n) {
				if (n) return n = I(e, t), pt.test(n) ? Se(e).position()[t] + "px" : n
			})
		}), Se.each({
			Height: "height",
			Width: "width"
		}, function(e, t) {
			Se.each({
				padding: "inner" + e,
				content: t,
				"": "outer" + e
			}, function(n, i) {
				Se.fn[i] = function(o, r) {
					var s = arguments.length && (n || "boolean" != typeof o),
						a = n || (!0 === o || !0 === r ? "margin" : "border");
					return Ie(this, function(t, n, o) {
						var r;
						return Ce(t) ? 0 === i.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (r = t.documentElement, Math.max(t.body["scroll" + e], r["scroll" + e], t.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === o ? Se.css(t, n, a) : Se.style(t, n, o, a)
					}, t, s ? o : void 0, s)
				}
			})
		}), Se.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
			Se.fn[t] = function(e, n) {
				return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t)
			}
		}), Se.fn.extend({
			hover: function(e, t) {
				return this.mouseenter(e).mouseleave(t || e)
			}
		}), Se.fn.extend({
			bind: function(e, t, n) {
				return this.on(e, null, t, n)
			},
			unbind: function(e, t) {
				return this.off(e, null, t)
			},
			delegate: function(e, t, n, i) {
				return this.on(t, e, n, i)
			},
			undelegate: function(e, t, n) {
				return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
			}
		}), Se.proxy = function(e, t) {
			var n, i, o;
			if ("string" == typeof t && (n = e[t], t = e, e = n), ke(e)) return i = pe.call(arguments, 2), o = function() {
				return e.apply(t || this, i.concat(pe.call(arguments)))
			}, o.guid = e.guid = e.guid || Se.guid++, o
		}, Se.holdReady = function(e) {
			e ? Se.readyWait++ : Se.ready(!0)
		}, Se.isArray = Array.isArray, Se.parseJSON = JSON.parse, Se.nodeName = u, Se.isFunction = ke, Se.isWindow = Ce, Se.camelCase = y, Se.type = a, Se.now = Date.now, Se.isNumeric = function(e) {
			var t = Se.type(e);
			return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
		}, i = [], void 0 !== (o = function() {
			return Se
		}.apply(t, i)) && (e.exports = o);
		var en = n.jQuery,
			tn = n.$;
		return Se.noConflict = function(e) {
			return n.$ === Se && (n.$ = tn), e && n.jQuery === Se && (n.jQuery = en), Se
		}, r || (n.jQuery = n.$ = Se), Se
	})
}, function(e, t, n) {
	var i, o, r;
	! function(s) {
		"use strict";
		o = [n(0)], i = s, void 0 !== (r = "function" == typeof i ? i.apply(t, o) : i) && (e.exports = r)
	}(function(e) {
		"use strict";
		var t = window.Slick || {};
		t = function() {
			function t(t, i) {
				var o, r = this;
				r.defaults = {
					accessibility: !0,
					adaptiveHeight: !1,
					appendArrows: e(t),
					appendDots: e(t),
					arrows: !0,
					asNavFor: null,
					prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
					nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
					autoplay: !1,
					autoplaySpeed: 3e3,
					centerMode: !1,
					centerPadding: "50px",
					cssEase: "ease",
					customPaging: function(t, n) {
						return e('<button type="button" />').text(n + 1)
					},
					dots: !1,
					dotsClass: "slick-dots",
					draggable: !0,
					easing: "linear",
					edgeFriction: .35,
					fade: !1,
					focusOnSelect: !1,
					focusOnChange: !1,
					infinite: !0,
					initialSlide: 0,
					lazyLoad: "ondemand",
					mobileFirst: !1,
					pauseOnHover: !0,
					pauseOnFocus: !0,
					pauseOnDotsHover: !1,
					respondTo: "window",
					responsive: null,
					rows: 1,
					rtl: !1,
					slide: "",
					slidesPerRow: 1,
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 500,
					swipe: !0,
					swipeToSlide: !1,
					touchMove: !0,
					touchThreshold: 5,
					useCSS: !0,
					useTransform: !0,
					variableWidth: !1,
					vertical: !1,
					verticalSwiping: !1,
					waitForAnimate: !0,
					zIndex: 1e3
				}, r.initials = {
					animating: !1,
					dragging: !1,
					autoPlayTimer: null,
					currentDirection: 0,
					currentLeft: null,
					currentSlide: 0,
					direction: 1,
					$dots: null,
					listWidth: null,
					listHeight: null,
					loadIndex: 0,
					$nextArrow: null,
					$prevArrow: null,
					scrolling: !1,
					slideCount: null,
					slideWidth: null,
					$slideTrack: null,
					$slides: null,
					sliding: !1,
					slideOffset: 0,
					swipeLeft: null,
					swiping: !1,
					$list: null,
					touchObject: {},
					transformsEnabled: !1,
					unslicked: !1
				}, e.extend(r, r.initials), r.activeBreakpoint = null, r.animType = null, r.animProp = null, r.breakpoints = [], r.breakpointSettings = [], r.cssTransitions = !1, r.focussed = !1, r.interrupted = !1, r.hidden = "hidden", r.paused = !0, r.positionProp = null, r.respondTo = null, r.rowCount = 1, r.shouldClick = !0, r.$slider = e(t), r.$slidesCache = null, r.transformType = null, r.transitionType = null, r.visibilityChange = "visibilitychange", r.windowWidth = 0, r.windowTimer = null, o = e(t).data("slick") || {}, r.options = e.extend({}, r.defaults, i, o), r.currentSlide = r.options.initialSlide, r.originalSettings = r.options, void 0 !== document.mozHidden ? (r.hidden = "mozHidden", r.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (r.hidden = "webkitHidden", r.visibilityChange = "webkitvisibilitychange"), r.autoPlay = e.proxy(r.autoPlay, r), r.autoPlayClear = e.proxy(r.autoPlayClear, r), r.autoPlayIterator = e.proxy(r.autoPlayIterator, r), r.changeSlide = e.proxy(r.changeSlide, r), r.clickHandler = e.proxy(r.clickHandler, r), r.selectHandler = e.proxy(r.selectHandler, r), r.setPosition = e.proxy(r.setPosition, r), r.swipeHandler = e.proxy(r.swipeHandler, r), r.dragHandler = e.proxy(r.dragHandler, r), r.keyHandler = e.proxy(r.keyHandler, r), r.instanceUid = n++, r.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, r.registerBreakpoints(), r.init(!0)
			}
			var n = 0;
			return t
		}(), t.prototype.activateADA = function() {
			this.$slideTrack.find(".slick-active").attr({
				"aria-hidden": "false"
			}).find("a, input, button, select").attr({
				tabindex: "0"
			})
		}, t.prototype.addSlide = t.prototype.slickAdd = function(t, n, i) {
			var o = this;
			if ("boolean" == typeof n) i = n, n = null;
			else if (n < 0 || n >= o.slideCount) return !1;
			o.unload(), "number" == typeof n ? 0 === n && 0 === o.$slides.length ? e(t).appendTo(o.$slideTrack) : i ? e(t).insertBefore(o.$slides.eq(n)) : e(t).insertAfter(o.$slides.eq(n)) : !0 === i ? e(t).prependTo(o.$slideTrack) : e(t).appendTo(o.$slideTrack), o.$slides = o.$slideTrack.children(this.options.slide), o.$slideTrack.children(this.options.slide).detach(), o.$slideTrack.append(o.$slides), o.$slides.each(function(t, n) {
				e(n).attr("data-slick-index", t)
			}), o.$slidesCache = o.$slides, o.reinit()
		}, t.prototype.animateHeight = function() {
			var e = this;
			if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
				var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
				e.$list.animate({
					height: t
				}, e.options.speed)
			}
		}, t.prototype.animateSlide = function(t, n) {
			var i = {},
				o = this;
			o.animateHeight(), !0 === o.options.rtl && !1 === o.options.vertical && (t = -t), !1 === o.transformsEnabled ? !1 === o.options.vertical ? o.$slideTrack.animate({
				left: t
			}, o.options.speed, o.options.easing, n) : o.$slideTrack.animate({
				top: t
			}, o.options.speed, o.options.easing, n) : !1 === o.cssTransitions ? (!0 === o.options.rtl && (o.currentLeft = -o.currentLeft), e({
				animStart: o.currentLeft
			}).animate({
				animStart: t
			}, {
				duration: o.options.speed,
				easing: o.options.easing,
				step: function(e) {
					e = Math.ceil(e), !1 === o.options.vertical ? (i[o.animType] = "translate(" + e + "px, 0px)", o.$slideTrack.css(i)) : (i[o.animType] = "translate(0px," + e + "px)", o.$slideTrack.css(i))
				},
				complete: function() {
					n && n.call()
				}
			})) : (o.applyTransition(), t = Math.ceil(t), !1 === o.options.vertical ? i[o.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[o.animType] = "translate3d(0px," + t + "px, 0px)", o.$slideTrack.css(i), n && setTimeout(function() {
				o.disableTransition(), n.call()
			}, o.options.speed))
		}, t.prototype.getNavTarget = function() {
			var t = this,
				n = t.options.asNavFor;
			return n && null !== n && (n = e(n).not(t.$slider)), n
		}, t.prototype.asNavFor = function(t) {
			var n = this,
				i = n.getNavTarget();
			null !== i && "object" == typeof i && i.each(function() {
				var n = e(this).slick("getSlick");
				n.unslicked || n.slideHandler(t, !0)
			})
		}, t.prototype.applyTransition = function(e) {
			var t = this,
				n = {};
			!1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
		}, t.prototype.autoPlay = function() {
			var e = this;
			e.autoPlayClear(), e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
		}, t.prototype.autoPlayClear = function() {
			var e = this;
			e.autoPlayTimer && clearInterval(e.autoPlayTimer)
		}, t.prototype.autoPlayIterator = function() {
			var e = this,
				t = e.currentSlide + e.options.slidesToScroll;
			e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
		}, t.prototype.buildArrows = function() {
			var t = this;
			!0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
				"aria-disabled": "true",
				tabindex: "-1"
			}))
		}, t.prototype.buildDots = function() {
			var t, n, i = this;
			if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
				for (i.$slider.addClass("slick-dotted"), n = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1) n.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
				i.$dots = n.appendTo(i.options.appendDots), i.$dots.find("li").first().addClass("slick-active")
			}
		}, t.prototype.buildOut = function() {
			var t = this;
			t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), t.slideCount = t.$slides.length, t.$slides.each(function(t, n) {
				e(n).attr("data-slick-index", t).data("originalStyling", e(n).attr("style") || "")
			}), t.$slider.addClass("slick-slider"), t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(), t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(), t.$slideTrack.css("opacity", 0), !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1), e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"), t.setupInfinite(), t.buildArrows(), t.buildDots(), t.updateDots(), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), !0 === t.options.draggable && t.$list.addClass("draggable")
		}, t.prototype.buildRows = function() {
			var e, t, n, i, o, r, s, a = this;
			if (i = document.createDocumentFragment(), r = a.$slider.children(), a.options.rows > 0) {
				for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
					var l = document.createElement("div");
					for (t = 0; t < a.options.rows; t++) {
						var u = document.createElement("div");
						for (n = 0; n < a.options.slidesPerRow; n++) {
							var c = e * s + (t * a.options.slidesPerRow + n);
							r.get(c) && u.appendChild(r.get(c))
						}
						l.appendChild(u)
					}
					i.appendChild(l)
				}
				a.$slider.empty().append(i), a.$slider.children().children().children().css({
					width: 100 / a.options.slidesPerRow + "%",
					display: "inline-block"
				})
			}
		}, t.prototype.checkResponsive = function(t, n) {
			var i, o, r, s = this,
				a = !1,
				l = s.$slider.width(),
				u = window.innerWidth || e(window).width();
			if ("window" === s.respondTo ? r = u : "slider" === s.respondTo ? r = l : "min" === s.respondTo && (r = Math.min(u, l)), s.options.responsive && s.options.responsive.length && null !== s.options.responsive) {
				o = null;
				for (i in s.breakpoints) s.breakpoints.hasOwnProperty(i) && (!1 === s.originalSettings.mobileFirst ? r < s.breakpoints[i] && (o = s.breakpoints[i]) : r > s.breakpoints[i] && (o = s.breakpoints[i]));
				null !== o ? null !== s.activeBreakpoint ? (o !== s.activeBreakpoint || n) && (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : (s.activeBreakpoint = o, "unslick" === s.breakpointSettings[o] ? s.unslick(o) : (s.options = e.extend({}, s.originalSettings, s.breakpointSettings[o]), !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t)), a = o) : null !== s.activeBreakpoint && (s.activeBreakpoint = null, s.options = s.originalSettings, !0 === t && (s.currentSlide = s.options.initialSlide), s.refresh(t), a = o), t || !1 === a || s.$slider.trigger("breakpoint", [s, a])
			}
		}, t.prototype.changeSlide = function(t, n) {
			var i, o, r, s = this,
				a = e(t.currentTarget);
			switch (a.is("a") && t.preventDefault(), a.is("li") || (a = a.closest("li")), r = s.slideCount % s.options.slidesToScroll != 0, i = r ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, t.data.message) {
				case "previous":
					o = 0 === i ? s.options.slidesToScroll : s.options.slidesToShow - i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - o, !1, n);
					break;
				case "next":
					o = 0 === i ? s.options.slidesToScroll : i, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + o, !1, n);
					break;
				case "index":
					var l = 0 === t.data.index ? 0 : t.data.index || a.index() * s.options.slidesToScroll;
					s.slideHandler(s.checkNavigable(l), !1, n), a.children().trigger("focus");
					break;
				default:
					return
			}
		}, t.prototype.checkNavigable = function(e) {
			var t, n, i = this;
			if (t = i.getNavigableIndexes(), n = 0, e > t[t.length - 1]) e = t[t.length - 1];
			else
				for (var o in t) {
					if (e < t[o]) {
						e = n;
						break
					}
					n = t[o]
				}
			return e
		}, t.prototype.cleanUpEvents = function() {
			var t = this;
			t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)), t.$slider.off("focus.slick blur.slick"), !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))), t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler), t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler), t.$list.off("touchend.slick mouseup.slick", t.swipeHandler), t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler), t.$list.off("click.slick", t.clickHandler), e(document).off(t.visibilityChange, t.visibility), t.cleanUpSlideEvents(), !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler), e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange), e(window).off("resize.slick.slick-" + t.instanceUid, t.resize), e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault), e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
		}, t.prototype.cleanUpSlideEvents = function() {
			var t = this;
			t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1))
		}, t.prototype.cleanUpRows = function() {
			var e, t = this;
			t.options.rows > 0 && (e = t.$slides.children().children(), e.removeAttr("style"), t.$slider.empty().append(e))
		}, t.prototype.clickHandler = function(e) {
			!1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
		}, t.prototype.destroy = function(t) {
			var n = this;
			n.autoPlayClear(), n.touchObject = {}, n.cleanUpEvents(), e(".slick-cloned", n.$slider).detach(), n.$dots && n.$dots.remove(), n.$prevArrow && n.$prevArrow.length && (n.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.prevArrow) && n.$prevArrow.remove()), n.$nextArrow && n.$nextArrow.length && (n.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), n.htmlExpr.test(n.options.nextArrow) && n.$nextArrow.remove()), n.$slides && (n.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
				e(this).attr("style", e(this).data("originalStyling"))
			}), n.$slideTrack.children(this.options.slide).detach(), n.$slideTrack.detach(), n.$list.detach(), n.$slider.append(n.$slides)), n.cleanUpRows(), n.$slider.removeClass("slick-slider"), n.$slider.removeClass("slick-initialized"), n.$slider.removeClass("slick-dotted"), n.unslicked = !0, t || n.$slider.trigger("destroy", [n])
		}, t.prototype.disableTransition = function(e) {
			var t = this,
				n = {};
			n[t.transitionType] = "", !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
		}, t.prototype.fadeSlide = function(e, t) {
			var n = this;
			!1 === n.cssTransitions ? (n.$slides.eq(e).css({
				zIndex: n.options.zIndex
			}), n.$slides.eq(e).animate({
				opacity: 1
			}, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({
				opacity: 1,
				zIndex: n.options.zIndex
			}), t && setTimeout(function() {
				n.disableTransition(e), t.call()
			}, n.options.speed))
		}, t.prototype.fadeSlideOut = function(e) {
			var t = this;
			!1 === t.cssTransitions ? t.$slides.eq(e).animate({
				opacity: 0,
				zIndex: t.options.zIndex - 2
			}, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
				opacity: 0,
				zIndex: t.options.zIndex - 2
			}))
		}, t.prototype.filterSlides = t.prototype.slickFilter = function(e) {
			var t = this;
			null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
		}, t.prototype.focusHandler = function() {
			var t = this;
			t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", function(n) {
				n.stopImmediatePropagation();
				var i = e(this);
				setTimeout(function() {
					t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay())
				}, 0)
			})
		}, t.prototype.getCurrent = t.prototype.slickCurrentSlide = function() {
			return this.currentSlide
		}, t.prototype.getDotCount = function() {
			var e = this,
				t = 0,
				n = 0,
				i = 0;
			if (!0 === e.options.infinite)
				if (e.slideCount <= e.options.slidesToShow) ++i;
				else
					for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
			else if (!0 === e.options.centerMode) i = e.slideCount;
			else if (e.options.asNavFor)
				for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
			else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
			return i - 1
		}, t.prototype.getLeft = function(e) {
			var t, n, i, o, r = this,
				s = 0;
			return r.slideOffset = 0, n = r.$slides.first().outerHeight(!0), !0 === r.options.infinite ? (r.slideCount > r.options.slidesToShow && (r.slideOffset = r.slideWidth * r.options.slidesToShow * -1, o = -1, !0 === r.options.vertical && !0 === r.options.centerMode && (2 === r.options.slidesToShow ? o = -1.5 : 1 === r.options.slidesToShow && (o = -2)), s = n * r.options.slidesToShow * o), r.slideCount % r.options.slidesToScroll != 0 && e + r.options.slidesToScroll > r.slideCount && r.slideCount > r.options.slidesToShow && (e > r.slideCount ? (r.slideOffset = (r.options.slidesToShow - (e - r.slideCount)) * r.slideWidth * -1, s = (r.options.slidesToShow - (e - r.slideCount)) * n * -1) : (r.slideOffset = r.slideCount % r.options.slidesToScroll * r.slideWidth * -1, s = r.slideCount % r.options.slidesToScroll * n * -1))) : e + r.options.slidesToShow > r.slideCount && (r.slideOffset = (e + r.options.slidesToShow - r.slideCount) * r.slideWidth, s = (e + r.options.slidesToShow - r.slideCount) * n), r.slideCount <= r.options.slidesToShow && (r.slideOffset = 0, s = 0), !0 === r.options.centerMode && r.slideCount <= r.options.slidesToShow ? r.slideOffset = r.slideWidth * Math.floor(r.options.slidesToShow) / 2 - r.slideWidth * r.slideCount / 2 : !0 === r.options.centerMode && !0 === r.options.infinite ? r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2) - r.slideWidth : !0 === r.options.centerMode && (r.slideOffset = 0, r.slideOffset += r.slideWidth * Math.floor(r.options.slidesToShow / 2)), t = !1 === r.options.vertical ? e * r.slideWidth * -1 + r.slideOffset : e * n * -1 + s, !0 === r.options.variableWidth && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === r.options.centerMode && (i = r.slideCount <= r.options.slidesToShow || !1 === r.options.infinite ? r.$slideTrack.children(".slick-slide").eq(e) : r.$slideTrack.children(".slick-slide").eq(e + r.options.slidesToShow + 1), t = !0 === r.options.rtl ? i[0] ? -1 * (r.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (r.$list.width() - i.outerWidth()) / 2)), t
		}, t.prototype.getOption = t.prototype.slickGetOption = function(e) {
			return this.options[e]
		}, t.prototype.getNavigableIndexes = function() {
			var e, t = this,
				n = 0,
				i = 0,
				o = [];
			for (!1 === t.options.infinite ? e = t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); n < e;) o.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
			return o
		}, t.prototype.getSlick = function() {
			return this
		}, t.prototype.getSlideCount = function() {
			var t, n, i = this;
			return n = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each(function(o, r) {
				if (r.offsetLeft - n + e(r).outerWidth() / 2 > -1 * i.swipeLeft) return t = r, !1
			}), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
		}, t.prototype.goTo = t.prototype.slickGoTo = function(e, t) {
			this.changeSlide({
				data: {
					message: "index",
					index: parseInt(e)
				}
			}, t)
		}, t.prototype.init = function(t) {
			var n = this;
			e(n.$slider).hasClass("slick-initialized") || (e(n.$slider).addClass("slick-initialized"), n.buildRows(), n.buildOut(), n.setProps(), n.startLoad(), n.loadSlider(), n.initializeEvents(), n.updateArrows(), n.updateDots(), n.checkResponsive(!0), n.focusHandler()), t && n.$slider.trigger("init", [n]), !0 === n.options.accessibility && n.initADA(), n.options.autoplay && (n.paused = !1, n.autoPlay())
		}, t.prototype.initADA = function() {
			var t = this,
				n = Math.ceil(t.slideCount / t.options.slidesToShow),
				i = t.getNavigableIndexes().filter(function(e) {
					return e >= 0 && e < t.slideCount
				});
			t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
				"aria-hidden": "true",
				tabindex: "-1"
			}).find("a, input, button, select").attr({
				tabindex: "-1"
			}), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(n) {
				var o = i.indexOf(n);
				if (e(this).attr({
						role: "tabpanel",
						id: "slick-slide" + t.instanceUid + n,
						tabindex: -1
					}), -1 !== o) {
					var r = "slick-slide-control" + t.instanceUid + o;
					e("#" + r).length && e(this).attr({
						"aria-describedby": r
					})
				}
			}), t.$dots.attr("role", "tablist").find("li").each(function(o) {
				var r = i[o];
				e(this).attr({
					role: "presentation"
				}), e(this).find("button").first().attr({
					role: "tab",
					id: "slick-slide-control" + t.instanceUid + o,
					"aria-controls": "slick-slide" + t.instanceUid + r,
					"aria-label": o + 1 + " of " + n,
					"aria-selected": null,
					tabindex: "-1"
				})
			}).eq(t.currentSlide).find("button").attr({
				"aria-selected": "true",
				tabindex: "0"
			}).end());
			for (var o = t.currentSlide, r = o + t.options.slidesToShow; o < r; o++) t.options.focusOnChange ? t.$slides.eq(o).attr({
				tabindex: "0"
			}) : t.$slides.eq(o).removeAttr("tabindex");
			t.activateADA()
		}, t.prototype.initArrowEvents = function() {
			var e = this;
			!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
				message: "previous"
			}, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
				message: "next"
			}, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
		}, t.prototype.initDotEvents = function() {
			var t = this;
			!0 === t.options.dots && t.slideCount > t.options.slidesToShow && (e("li", t.$dots).on("click.slick", {
				message: "index"
			}, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)), !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && t.slideCount > t.options.slidesToShow && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1))
		}, t.prototype.initSlideEvents = function() {
			var t = this;
			t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)))
		}, t.prototype.initializeEvents = function() {
			var t = this;
			t.initArrowEvents(), t.initDotEvents(), t.initSlideEvents(), t.$list.on("touchstart.slick mousedown.slick", {
				action: "start"
			}, t.swipeHandler), t.$list.on("touchmove.slick mousemove.slick", {
				action: "move"
			}, t.swipeHandler), t.$list.on("touchend.slick mouseup.slick", {
				action: "end"
			}, t.swipeHandler), t.$list.on("touchcancel.slick mouseleave.slick", {
				action: "end"
			}, t.swipeHandler), t.$list.on("click.slick", t.clickHandler), e(document).on(t.visibilityChange, e.proxy(t.visibility, t)), !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)), e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)), e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault), e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition), e(t.setPosition)
		}, t.prototype.initUI = function() {
			var e = this;
			!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
		}, t.prototype.keyHandler = function(e) {
			var t = this;
			e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
				data: {
					message: !0 === t.options.rtl ? "next" : "previous"
				}
			}) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
				data: {
					message: !0 === t.options.rtl ? "previous" : "next"
				}
			}))
		}, t.prototype.lazyLoad = function() {
			function t(t) {
				e("img[data-lazy]", t).each(function() {
					var t = e(this),
						n = e(this).attr("data-lazy"),
						i = e(this).attr("data-srcset"),
						o = e(this).attr("data-sizes") || s.$slider.attr("data-sizes"),
						r = document.createElement("img");
					r.onload = function() {
						t.animate({
							opacity: 0
						}, 100, function() {
							i && (t.attr("srcset", i), o && t.attr("sizes", o)), t.attr("src", n).animate({
								opacity: 1
							}, 200, function() {
								t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
							}), s.$slider.trigger("lazyLoaded", [s, t, n])
						})
					}, r.onerror = function() {
						t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, t, n])
					}, r.src = n
				})
			}
			var n, i, o, r, s = this;
			if (!0 === s.options.centerMode ? !0 === s.options.infinite ? (o = s.currentSlide + (s.options.slidesToShow / 2 + 1), r = o + s.options.slidesToShow + 2) : (o = Math.max(0, s.currentSlide - (s.options.slidesToShow / 2 + 1)), r = s.options.slidesToShow / 2 + 1 + 2 + s.currentSlide) : (o = s.options.infinite ? s.options.slidesToShow + s.currentSlide : s.currentSlide, r = Math.ceil(o + s.options.slidesToShow), !0 === s.options.fade && (o > 0 && o--, r <= s.slideCount && r++)), n = s.$slider.find(".slick-slide").slice(o, r), "anticipated" === s.options.lazyLoad)
				for (var a = o - 1, l = r, u = s.$slider.find(".slick-slide"), c = 0; c < s.options.slidesToScroll; c++) a < 0 && (a = s.slideCount - 1), n = n.add(u.eq(a)), n = n.add(u.eq(l)), a--, l++;
			t(n), s.slideCount <= s.options.slidesToShow ? (i = s.$slider.find(".slick-slide"), t(i)) : s.currentSlide >= s.slideCount - s.options.slidesToShow ? (i = s.$slider.find(".slick-cloned").slice(0, s.options.slidesToShow), t(i)) : 0 === s.currentSlide && (i = s.$slider.find(".slick-cloned").slice(-1 * s.options.slidesToShow), t(i))
		}, t.prototype.loadSlider = function() {
			var e = this;
			e.setPosition(), e.$slideTrack.css({
				opacity: 1
			}), e.$slider.removeClass("slick-loading"), e.initUI(), "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
		}, t.prototype.next = t.prototype.slickNext = function() {
			this.changeSlide({
				data: {
					message: "next"
				}
			})
		}, t.prototype.orientationChange = function() {
			var e = this;
			e.checkResponsive(), e.setPosition()
		}, t.prototype.pause = t.prototype.slickPause = function() {
			var e = this;
			e.autoPlayClear(), e.paused = !0
		}, t.prototype.play = t.prototype.slickPlay = function() {
			var e = this;
			e.autoPlay(), e.options.autoplay = !0, e.paused = !1, e.focussed = !1, e.interrupted = !1
		}, t.prototype.postSlide = function(t) {
			var n = this;
			if (!n.unslicked && (n.$slider.trigger("afterChange", [n, t]), n.animating = !1, n.slideCount > n.options.slidesToShow && n.setPosition(), n.swipeLeft = null, n.options.autoplay && n.autoPlay(), !0 === n.options.accessibility && (n.initADA(), n.options.focusOnChange))) {
				e(n.$slides.get(n.currentSlide)).attr("tabindex", 0).focus()
			}
		}, t.prototype.prev = t.prototype.slickPrev = function() {
			this.changeSlide({
				data: {
					message: "previous"
				}
			})
		}, t.prototype.preventDefault = function(e) {
			e.preventDefault()
		}, t.prototype.progressiveLazyLoad = function(t) {
			t = t || 1;
			var n, i, o, r, s, a = this,
				l = e("img[data-lazy]", a.$slider);
			l.length ? (n = l.first(), i = n.attr("data-lazy"), o = n.attr("data-srcset"), r = n.attr("data-sizes") || a.$slider.attr("data-sizes"), s = document.createElement("img"), s.onload = function() {
				o && (n.attr("srcset", o), r && n.attr("sizes", r)), n.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === a.options.adaptiveHeight && a.setPosition(), a.$slider.trigger("lazyLoaded", [a, n, i]), a.progressiveLazyLoad()
			}, s.onerror = function() {
				t < 3 ? setTimeout(function() {
					a.progressiveLazyLoad(t + 1)
				}, 500) : (n.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), a.$slider.trigger("lazyLoadError", [a, n, i]), a.progressiveLazyLoad())
			}, s.src = i) : a.$slider.trigger("allImagesLoaded", [a])
		}, t.prototype.refresh = function(t) {
			var n, i, o = this;
			i = o.slideCount - o.options.slidesToShow, !o.options.infinite && o.currentSlide > i && (o.currentSlide = i), o.slideCount <= o.options.slidesToShow && (o.currentSlide = 0), n = o.currentSlide, o.destroy(!0), e.extend(o, o.initials, {
				currentSlide: n
			}), o.init(), t || o.changeSlide({
				data: {
					message: "index",
					index: n
				}
			}, !1)
		}, t.prototype.registerBreakpoints = function() {
			var t, n, i, o = this,
				r = o.options.responsive || null;
			if ("array" === e.type(r) && r.length) {
				o.respondTo = o.options.respondTo || "window";
				for (t in r)
					if (i = o.breakpoints.length - 1, r.hasOwnProperty(t)) {
						for (n = r[t].breakpoint; i >= 0;) o.breakpoints[i] && o.breakpoints[i] === n && o.breakpoints.splice(i, 1), i--;
						o.breakpoints.push(n), o.breakpointSettings[n] = r[t].settings
					}
				o.breakpoints.sort(function(e, t) {
					return o.options.mobileFirst ? e - t : t - e
				})
			}
		}, t.prototype.reinit = function() {
			var t = this;
			t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"), t.slideCount = t.$slides.length, t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll), t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0), t.registerBreakpoints(), t.setProps(), t.setupInfinite(), t.buildArrows(), t.updateArrows(), t.initArrowEvents(), t.buildDots(), t.updateDots(), t.initDotEvents(), t.cleanUpSlideEvents(), t.initSlideEvents(), t.checkResponsive(!1, !0), !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler), t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0), t.setPosition(), t.focusHandler(), t.paused = !t.options.autoplay, t.autoPlay(), t.$slider.trigger("reInit", [t])
		}, t.prototype.resize = function() {
			var t = this;
			e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout(function() {
				t.windowWidth = e(window).width(), t.checkResponsive(), t.unslicked || t.setPosition()
			}, 50))
		}, t.prototype.removeSlide = t.prototype.slickRemove = function(e, t, n) {
			var i = this;
			if ("boolean" == typeof e ? (t = e, e = !0 === t ? 0 : i.slideCount - 1) : e = !0 === t ? --e : e, i.slideCount < 1 || e < 0 || e > i.slideCount - 1) return !1;
			i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, i.reinit()
		}, t.prototype.setCSS = function(e) {
			var t, n, i = this,
				o = {};
			!0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", o[i.positionProp] = e, !1 === i.transformsEnabled ? i.$slideTrack.css(o) : (o = {}, !1 === i.cssTransitions ? (o[i.animType] = "translate(" + t + ", " + n + ")", i.$slideTrack.css(o)) : (o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)", i.$slideTrack.css(o)))
		}, t.prototype.setDimensions = function() {
			var e = this;
			!1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
				padding: "0px " + e.options.centerPadding
			}) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
				padding: e.options.centerPadding + " 0px"
			})), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
			var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
			!1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
		}, t.prototype.setFade = function() {
			var t, n = this;
			n.$slides.each(function(i, o) {
				t = n.slideWidth * i * -1, !0 === n.options.rtl ? e(o).css({
					position: "relative",
					right: t,
					top: 0,
					zIndex: n.options.zIndex - 2,
					opacity: 0
				}) : e(o).css({
					position: "relative",
					left: t,
					top: 0,
					zIndex: n.options.zIndex - 2,
					opacity: 0
				})
			}), n.$slides.eq(n.currentSlide).css({
				zIndex: n.options.zIndex - 1,
				opacity: 1
			})
		}, t.prototype.setHeight = function() {
			var e = this;
			if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
				var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
				e.$list.css("height", t)
			}
		}, t.prototype.setOption = t.prototype.slickSetOption = function() {
			var t, n, i, o, r, s = this,
				a = !1;
			if ("object" === e.type(arguments[0]) ? (i = arguments[0], a = arguments[1], r = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], o = arguments[1], a = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? r = "responsive" : void 0 !== arguments[1] && (r = "single")), "single" === r) s.options[i] = o;
			else if ("multiple" === r) e.each(i, function(e, t) {
				s.options[e] = t
			});
			else if ("responsive" === r)
				for (n in o)
					if ("array" !== e.type(s.options.responsive)) s.options.responsive = [o[n]];
					else {
						for (t = s.options.responsive.length - 1; t >= 0;) s.options.responsive[t].breakpoint === o[n].breakpoint && s.options.responsive.splice(t, 1), t--;
						s.options.responsive.push(o[n])
					}
			a && (s.unload(), s.reinit())
		}, t.prototype.setPosition = function() {
			var e = this;
			e.setDimensions(), e.setHeight(), !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(), e.$slider.trigger("setPosition", [e])
		}, t.prototype.setProps = function() {
			var e = this,
				t = document.body.style;
			e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
		}, t.prototype.setSlideClasses = function(e) {
			var t, n, i, o, r = this;
			if (n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode) {
				var s = r.options.slidesToShow % 2 == 0 ? 1 : 0;
				t = Math.floor(r.options.slidesToShow / 2), !0 === r.options.infinite && (e >= t && e <= r.slideCount - 1 - t ? r.$slides.slice(e - t + s, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = r.options.slidesToShow + e, n.slice(i - t + 1 + s, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(e).addClass("slick-center")
			} else e >= 0 && e <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(e, e + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= r.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (o = r.slideCount % r.options.slidesToShow, i = !0 === r.options.infinite ? r.options.slidesToShow + e : e, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow ? n.slice(i - (r.options.slidesToShow - o), i + o).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
			"ondemand" !== r.options.lazyLoad && "anticipated" !== r.options.lazyLoad || r.lazyLoad()
		}, t.prototype.setupInfinite = function() {
			var t, n, i, o = this;
			if (!0 === o.options.fade && (o.options.centerMode = !1), !0 === o.options.infinite && !1 === o.options.fade && (n = null, o.slideCount > o.options.slidesToShow)) {
				for (i = !0 === o.options.centerMode ? o.options.slidesToShow + 1 : o.options.slidesToShow, t = o.slideCount; t > o.slideCount - i; t -= 1) n = t - 1, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n - o.slideCount).prependTo(o.$slideTrack).addClass("slick-cloned");
				for (t = 0; t < i + o.slideCount; t += 1) n = t, e(o.$slides[n]).clone(!0).attr("id", "").attr("data-slick-index", n + o.slideCount).appendTo(o.$slideTrack).addClass("slick-cloned");
				o.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
					e(this).attr("id", "")
				})
			}
		}, t.prototype.interrupt = function(e) {
			var t = this;
			e || t.autoPlay(), t.interrupted = e
		}, t.prototype.selectHandler = function(t) {
			var n = this,
				i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
				o = parseInt(i.attr("data-slick-index"));
			if (o || (o = 0), n.slideCount <= n.options.slidesToShow) return void n.slideHandler(o, !1, !0);
			n.slideHandler(o)
		}, t.prototype.slideHandler = function(e, t, n) {
			var i, o, r, s, a, l = null,
				u = this;
			if (t = t || !1, !(!0 === u.animating && !0 === u.options.waitForAnimate || !0 === u.options.fade && u.currentSlide === e)) {
				if (!1 === t && u.asNavFor(e), i = e, l = u.getLeft(i), s = u.getLeft(u.currentSlide), u.currentLeft = null === u.swipeLeft ? s : u.swipeLeft, !1 === u.options.infinite && !1 === u.options.centerMode && (e < 0 || e > u.getDotCount() * u.options.slidesToScroll)) return void(!1 === u.options.fade && (i = u.currentSlide, !0 !== n && u.slideCount > u.options.slidesToShow ? u.animateSlide(s, function() {
					u.postSlide(i)
				}) : u.postSlide(i)));
				if (!1 === u.options.infinite && !0 === u.options.centerMode && (e < 0 || e > u.slideCount - u.options.slidesToScroll)) return void(!1 === u.options.fade && (i = u.currentSlide, !0 !== n && u.slideCount > u.options.slidesToShow ? u.animateSlide(s, function() {
					u.postSlide(i)
				}) : u.postSlide(i)));
				if (u.options.autoplay && clearInterval(u.autoPlayTimer), o = i < 0 ? u.slideCount % u.options.slidesToScroll != 0 ? u.slideCount - u.slideCount % u.options.slidesToScroll : u.slideCount + i : i >= u.slideCount ? u.slideCount % u.options.slidesToScroll != 0 ? 0 : i - u.slideCount : i, u.animating = !0, u.$slider.trigger("beforeChange", [u, u.currentSlide, o]), r = u.currentSlide, u.currentSlide = o, u.setSlideClasses(u.currentSlide), u.options.asNavFor && (a = u.getNavTarget(), a = a.slick("getSlick"), a.slideCount <= a.options.slidesToShow && a.setSlideClasses(u.currentSlide)), u.updateDots(), u.updateArrows(), !0 === u.options.fade) return !0 !== n ? (u.fadeSlideOut(r), u.fadeSlide(o, function() {
					u.postSlide(o)
				})) : u.postSlide(o), void u.animateHeight();
				!0 !== n && u.slideCount > u.options.slidesToShow ? u.animateSlide(l, function() {
					u.postSlide(o)
				}) : u.postSlide(o)
			}
		}, t.prototype.startLoad = function() {
			var e = this;
			!0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
		}, t.prototype.swipeDirection = function() {
			var e, t, n, i, o = this;
			return e = o.touchObject.startX - o.touchObject.curX, t = o.touchObject.startY - o.touchObject.curY, n = Math.atan2(t, e), i = Math.round(180 * n / Math.PI), i < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 ? !1 === o.options.rtl ? "left" : "right" : i <= 360 && i >= 315 ? !1 === o.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === o.options.rtl ? "right" : "left" : !0 === o.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical"
		}, t.prototype.swipeEnd = function(e) {
			var t, n, i = this;
			if (i.dragging = !1, i.swiping = !1, i.scrolling) return i.scrolling = !1, !1;
			if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX) return !1;
			if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
				switch (n = i.swipeDirection()) {
					case "left":
					case "down":
						t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
						break;
					case "right":
					case "up":
						t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
				}
				"vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
			} else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
		}, t.prototype.swipeHandler = function(e) {
			var t = this;
			if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
				case "start":
					t.swipeStart(e);
					break;
				case "move":
					t.swipeMove(e);
					break;
				case "end":
					t.swipeEnd(e)
			}
		}, t.prototype.swipeMove = function(e) {
			var t, n, i, o, r, s, a = this;
			return r = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!a.dragging || a.scrolling || r && 1 !== r.length) && (t = a.getLeft(a.currentSlide), a.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX, a.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY, a.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(a.touchObject.curX - a.touchObject.startX, 2))), s = Math.round(Math.sqrt(Math.pow(a.touchObject.curY - a.touchObject.startY, 2))), !a.options.verticalSwiping && !a.swiping && s > 4 ? (a.scrolling = !0, !1) : (!0 === a.options.verticalSwiping && (a.touchObject.swipeLength = s), n = a.swipeDirection(), void 0 !== e.originalEvent && a.touchObject.swipeLength > 4 && (a.swiping = !0, e.preventDefault()), o = (!1 === a.options.rtl ? 1 : -1) * (a.touchObject.curX > a.touchObject.startX ? 1 : -1), !0 === a.options.verticalSwiping && (o = a.touchObject.curY > a.touchObject.startY ? 1 : -1), i = a.touchObject.swipeLength, a.touchObject.edgeHit = !1, !1 === a.options.infinite && (0 === a.currentSlide && "right" === n || a.currentSlide >= a.getDotCount() && "left" === n) && (i = a.touchObject.swipeLength * a.options.edgeFriction, a.touchObject.edgeHit = !0), !1 === a.options.vertical ? a.swipeLeft = t + i * o : a.swipeLeft = t + i * (a.$list.height() / a.listWidth) * o, !0 === a.options.verticalSwiping && (a.swipeLeft = t + i * o), !0 !== a.options.fade && !1 !== a.options.touchMove && (!0 === a.animating ? (a.swipeLeft = null, !1) : void a.setCSS(a.swipeLeft))))
		}, t.prototype.swipeStart = function(e) {
			var t, n = this;
			if (n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow) return n.touchObject = {}, !1;
			void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, n.dragging = !0
		}, t.prototype.unfilterSlides = t.prototype.slickUnfilter = function() {
			var e = this;
			null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
		}, t.prototype.unload = function() {
			var t = this;
			e(".slick-cloned", t.$slider).remove(), t.$dots && t.$dots.remove(), t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(), t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(), t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
		}, t.prototype.unslick = function(e) {
			var t = this;
			t.$slider.trigger("unslick", [t, e]), t.destroy()
		}, t.prototype.updateArrows = function() {
			var e = this;
			Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode ? (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
		}, t.prototype.updateDots = function() {
			var e = this;
			null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
		}, t.prototype.visibility = function() {
			var e = this;
			e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
		}, e.fn.slick = function() {
			var e, n, i = this,
				o = arguments[0],
				r = Array.prototype.slice.call(arguments, 1),
				s = i.length;
			for (e = 0; e < s; e++)
				if ("object" == typeof o || void 0 === o ? i[e].slick = new t(i[e], o) : n = i[e].slick[o].apply(i[e].slick, r), void 0 !== n) return n;
			return i
		}
	})
}, function(e, t, n) {
	"use strict";
	rivets.formatters.currency = {
		read: function(e) {
			return (e / 100).toFixed(2)
		},
		publish: function(e) {
			return Math.round(100 * parseFloat(e))
		}
	}, rivets.formatters.product_variant_id = function(e) {
		return e[0].id
	}, rivets.formatters.product_title = function(e) {
		var t = flow(replace(/\(([^)]+)\)/g, ""), trim, split(":"))(e);
		return t.length > 1 ? _initial(t).join(" ") : t[0]
	}, rivets.formatters.product_url = function(e, t) {
		var n = "";
		return null !== t && (n = "?variant=" + t), "/products/" + e + n
	}, rivets.formatters.replace = function(e, t, n) {
		return e.replace(t, n)
	}, rivets.formatters.remove = function(e, t) {
		return e.replace(t, "")
	}, rivets.formatters.without_spaces_and_trailing_zeros = function(e) {
		return e.replace(/\.00|\s/g, "")
	}, rivets.formatters.size = function(e) {
		return e.length
	}, rivets.binders.addclass = function(e, t) {
		var n = $(e);
		"" !== t && (n.hasClass(t) || n.addClass(t))
	}, rivets.formatters.remove = function(e, t) {
		return "string" != typeof e && (e = e.toString()), e.replace(t, "")
	}, rivets.formatters.is_apparel = function(e) {
		return -1 !== e.indexOf("Apparel")
	}, rivets.formatters.is_subscription = function(e) {
		return -1 !== e.indexOf("Subscription")
	}, rivets.formatters.is_default = function(e) {
		return -1 !== e.indexOf("Default Title")
	}
}, function(e, t, n) {
	"use strict";

	function i(e, t) {
		if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
	}
	Object.defineProperty(t, "__esModule", {
		value: !0
	}), t.Util = void 0;
	var o = function() {
			function e(e, t) {
				for (var n = 0; n < t.length; n++) {
					var i = t[n];
					i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
				}
			}
			return function(t, n, i) {
				return n && e(t.prototype, n), i && e(t, i), t
			}
		}(),
		r = n(17),
		s = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(r),
		a = function() {
			function e() {
				i(this, e), this.checkTouch(), this.checkBrowser()
			}
			return o(e, [{
				key: "debounce",
				value: function(e, t) {
					var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this,
						i = null,
						o = null,
						r = function() {
							return e.apply(n, o)
						};
					return function() {
						for (var e = arguments.length, n = Array(e), s = 0; s < e; s++) n[s] = arguments[s];
						o = n, clearTimeout(i), i = setTimeout(r, t)
					}
				}
			}, {
				key: "getChildren",
				value: function(e, t) {
					for (var n = []; e; e = e.nextSibling) 1 == e.nodeType && e != t && n.push(e);
					return n
				}
			}, {
				key: "getSiblings",
				value: function(e) {
					return this.getChildren(e.parentNode.firstChild, e)
				}
			}, {
				key: "getCookie",
				value: function(e) {
					if (document.cookie.length > 0) {
						var t = document.cookie.indexOf(e + "=");
						if (-1 != t) {
							t = t + e.length + 1;
							var n = document.cookie.indexOf(";", t);
							return -1 == n && (n = document.cookie.length), unescape(document.cookie.substring(t, n))
						}
					}
					return ""
				}
			}, {
				key: "createCookie",
				value: function(e, t, n) {
					var i;
					if (n) {
						var o = new Date;
						o.setTime(o.getTime() + 24 * n * 60 * 60 * 1e3), i = "; expires=" + o.toGMTString()
					} else i = "";
					document.cookie = e + "=" + t + i + "; path=/"
				}
			}, {
				key: "checkTouch",
				value: function() {
					s.default.touchevents ? this.hasTouch = !0 : this.hasTouch = !1
				}
			}, {
				key: "checkBrowser",
				value: function() {
					s.default.addTest("ie", function() {
						return /MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent)
					}), this.isIe = s.default.ie, this.isIe && document.documentElement.classList.add("ie")
				}
			}]), e
		}();
	t.default = a;
	t.Util = new a
}, function(module, exports, __webpack_require__) {
	"use strict";

	function _interopRequireDefault(e) {
		return e && e.__esModule ? e : {
			default: e
		}
	}

	function minicart() {
		(0, _jquery2.default)(".minicart__overlay").addClass("open"), (0, _jquery2.default)(".minicart").addClass("open"), (0, _jquery2.default)("html").css("overflow-y", "hidden"), setTimeout(function() {
			(0, _jquery2.default)(".minicart__main").addClass("fadeIn")
		}, 300), setTimeout(function() {
			(0, _jquery2.default)(".btn-container").addClass("fadeIn")
		}, 500), setTimeout(function() {
			(0, _jquery2.default)(".btn-container").addClass("slideUp")
		}, 700), setTimeout(function() {
			(0, _jquery2.default)(".minicart__shipping").addClass("slideUp")
		}, 900), setTimeout(function() {
			(0, _jquery2.default)(".minicart__suggestion").addClass("slideUp")
		}, 900), (0, _jquery2.default)("#minicart__close").on("click", function() {
			(0, _jquery2.default)(".minicart__overlay").removeClass("open"), (0, _jquery2.default)(".minicart").removeClass("open"), (0, _jquery2.default)("html").css("overflow-y", "scroll"), (0, _jquery2.default)(".minicart__main").removeClass("fadeIn"), (0, _jquery2.default)(".btn-container").removeClass("slideUp fadeIn"), (0, _jquery2.default)(".minicart__shipping").removeClass("slideUp"), (0, _jquery2.default)(".minicart__suggestion").removeClass("slideUp")
		}), (0, _jquery2.default)(".minicart__overlay").on("click", function() {
			(0, _jquery2.default)(".minicart__overlay").removeClass("open"), (0, _jquery2.default)(".minicart").removeClass("open"), (0, _jquery2.default)("html").css("overflow-y", "scroll"), (0, _jquery2.default)(".minicart__main").removeClass("fadeIn"), (0, _jquery2.default)(".btn-container").removeClass("slideUp fadeIn"), (0, _jquery2.default)(".minicart__shipping").removeClass("slideUp"), (0, _jquery2.default)(".minicart__suggestion").removeClass("slideUp")
		})
	}
	var _utilities = __webpack_require__(3),
		_utilities2 = _interopRequireDefault(_utilities),
		_minicart = __webpack_require__(2),
		_minicart2 = _interopRequireDefault(_minicart),
		_jquery = __webpack_require__(0),
		_jquery2 = _interopRequireDefault(_jquery),
		Utils = new _utilities2.default;
	(0, _jquery2.default)(".add-to-cart").click(function(e) {
		e.preventDefault();
		var id = (0, _jquery2.default)(this).attr("data-id"),
			quantity = ((0, _jquery2.default)(this).attr("data-cart-quantity")) ? (0, _jquery2.default)(this).attr("data-cart-quantity") : 1;

        let formData = {
            'items': [{
                'id': id,
                'quantity': quantity
            }]
        };
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(response => {
                minicart();
            })
            .catch((error) => {
                console.error('Error:', error);
            });

	}), (0, _jquery2.default)("#nav__bag").on("click", function() {
		minicart()
	})
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i);
	n(1), document.getElementById("homepage") && ((0, o.default)(".carousel").on("beforeChange", function(e, t, n, i) {
		switch (n) {
			case 0:
				var o = document.getElementsByClassName("slick-current")[0].getElementsByClassName("headline")[0],
					r = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__body")[0],
					s = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__image")[0],
					a = document.getElementById("slick-slide01").getElementsByClassName("carousel__image")[0],
					l = document.getElementById("slick-slide01").getElementsByClassName("slide__headline")[0],
					u = document.getElementById("slick-slide01").getElementsByClassName("carousel__description")[0];
				o.classList.remove("fade-in-left"), o.classList.add("fade-out-left"), r.classList.remove("fade-in-left"), r.classList.add("fade-out-left"), s.classList.remove("fade-in"), s.classList.add("fade-out"), l.classList.add("fade-in-left"), u.classList.add("fade-in-left"), a.classList.remove("wipe-hide"), a.classList.add("wipe-reveal");
				break;
			case 1:
				if (n > i) {
					var c = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__image")[0],
						d = document.getElementById("slick-slide00").getElementsByClassName("headline")[0],
						p = document.getElementById("slick-slide00").getElementsByClassName("carousel__body")[0],
						f = document.getElementById("slick-slide00").getElementsByClassName("carousel__image")[0],
						h = document.getElementById("slick-slide01").getElementsByClassName("slide__headline")[0],
						g = document.getElementById("slick-slide01").getElementsByClassName("carousel__description")[0];
					c.classList.remove("wipe-reveal"), c.classList.add("wipe-hide"), h.classList.remove("fade-in-left"), g.classList.remove("fade-in-left"), d.classList.remove("fade-out-left"), d.classList.add("fade-in-left"), p.classList.remove("fade-out-left"), p.classList.add("fade-in-left"), f.classList.remove("fade-out"), f.classList.add("fade-in")
				} else {
					var m = "slick-slide0" + n,
						v = (parseInt(m.slice(12, 13)) + 1).toString(),
						y = document.getElementById("slick-slide0" + v).getElementsByClassName("carousel__image")[0],
						w = document.getElementById("slick-slide0" + v).getElementsByClassName("slide__headline")[0],
						b = document.getElementById("slick-slide0" + v).getElementsByClassName("carousel__description")[0],
						x = document.getElementById("slick-slide01").getElementsByClassName("slide__headline")[0],
						k = document.getElementById("slick-slide01").getElementsByClassName("carousel__description")[0],
						C = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__image")[0];
					y.classList.remove("wipe-hide"), y.classList.add("wipe-reveal"), w.classList.add("fade-in-left"), b.classList.add("fade-in-left"), x.classList.remove("fade-in-left"), x.classList.add("fade-out-left"), k.classList.remove("fade-in-left"), k.classList.add("fade-out-left"), C.classList.remove("fade-in"), C.classList.add("fade-out")
				}
				break;
			default:
				if (n < i) {
					var T = "slick-slide0" + n,
						S = (parseInt(T.slice(12, 13)) + 1).toString(),
						E = document.getElementById("slick-slide0" + S).getElementsByClassName("carousel__image")[0],
						_ = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__image")[0],
						A = document.getElementById("slick-slide0" + S).getElementsByClassName("carousel__product")[0],
						$ = document.getElementsByClassName("slick-current")[0].getElementsByClassName("slide__headline")[0],
						P = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__description")[0];
					_.classList.remove("fade-in"), _.classList.add("fade-out"), E.classList.remove("wipe-hide"), E.classList.add("wipe-reveal"), A && A.classList.add("fade-in"), $ && ($.classList.remove("fade-in-left"), $.classList.add("fade-out-left")), P && (P.classList.remove("fade-in-left"), P.classList.add("fade-out-left"))
				} else {
					var L = "slick-slide0" + n,
						N = (parseInt(L.slice(12, 13)) - 1).toString(),
						j = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__image")[0],
						q = document.getElementById("slick-slide0" + N).getElementsByClassName("slide__headline")[0],
						H = document.getElementById("slick-slide0" + N).getElementsByClassName("carousel__description")[0],
						O = document.getElementById("slick-slide0" + N).getElementsByClassName("carousel__image")[0],
						D = document.getElementsByClassName("slick-current")[0].getElementsByClassName("slide__headline")[0],
						M = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__description")[0],
						I = document.getElementsByClassName("slick-current")[0].getElementsByClassName("carousel__product")[0];
					D && D.classList.remove("fade-in-left"), M && M.classList.remove("fade-in-left"), O.classList.remove("fade-out"), O.classList.add("fade-in"), j.classList.remove("wipe-reveal"), j.classList.add("wipe-hide"), q.classList.remove("fade-out-left"), q.classList.add("fade-in-left"), H.classList.remove("fade-out-left"), H.classList.add("fade-in-left"), I && I.classList.remove("fade-in")
				}
		}
	}), (0, o.default)(".carousel").slick({
		dots: !0,
		infinite: !1,
		autoplay: !1,
		fade: !0,
		speed: 300,
		adaptiveHeight: !1,
		nextArrow: '<i class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-right.svg?16506483156083883680" alt="Arrow Right"></i>',
		prevArrow: '<i class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-left.svg?16506483156083883680" alt="Arrow Left"></i>',
		responsive: [{
			breakpoint: 768,
			settings: {
				adaptiveHeight: !0
			}
		}]
	}), (0, o.default)(".testimonials").slick({
		dots: !0,
		infinite: !0,
		autoplay: !1,
		adaptiveHeight: !1,
		fade: !0,
		nextArrow: '<i class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-right.svg?16506483156083883680" alt="Arrow Right"></i>',
		prevArrow: '<i class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-left.svg?16506483156083883680" alt="Arrow Left"></i>'
	}), (0, o.default)(window).width() < 768 && ((0, o.default)(".instagram__posts").on("init", function(e) {
		(0, o.default)(".instagram__posts .post-1 .post__image").addClass("next"), (0, o.default)(".instagram__posts .post-2 .post__image").addClass("next"), (0, o.default)(".instagram__posts .post-3 .post__image").addClass("next")
	}), (0, o.default)(".instagram__posts").slick({
		dots: !0,
		infinite: !0,
		autoplay: !1,
		adaptiveHeight: !1,
		arrows: !1
	})))
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i);
	if (n(1), document.getElementById("product-page")) {
		var r = (0, o.default)(".productView__gallery .productView__image:last-of-type"),
			s = (0, o.default)(".productView__gallery");
		r.length > 0 && (r = parseInt(r.attr("class").split(" ")[0])) > 0 && s.slick({
			dots: !0,
			arrows: !0,
			infinite: !0,
			adaptiveHeight: !1,
			speed: 600,
			draggable: !0,
			mobileFirst: !0,
			nextArrow: '<i class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/icon-arrow-right.svg?6023620948586374762" alt="Arrow Right"></i>',
			prevArrow: '<i class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/icon-arrow-left.svg?6023620948586374762" alt="Arrow Left"></i>'
		})
	}
}, function(e, t, n) {
	"use strict";
	Object.defineProperty(t, "__esModule", {
		value: !0
	});
	var i = n(3),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i),
		r = (new o.default, {
			init: function() {
				window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
			}
		});
	t.default = r
}, function(e, t, n) {
	"use strict";

	function i() {
		a.classList.add("slideUp")
	}

	function o() {
		a.classList.remove("slideUp")
	}

	function r() {
		a.classList.add("white")
	}

	function s() {
		a.classList.remove("white")
	}
	window.onbeforeunload = function() {
		window.scrollTo(0, 0)
	};
	var a = document.getElementsByClassName("header")[0],
		l = document.getElementsByClassName("subheadernew")[0],
		u = document.getElementById("homepage"),
		c = document.getElementById("product-page"),
		d = window.scrollY;
	u || c ? window.addEventListener("scroll", function() {
		d = window.scrollY, d > 50 ? i() : o(), d > 300 ? r() : s()
	}) : (! function() {
		l.classList.add("white")
	}(), r(), window.addEventListener("scroll", function() {
		d = window.scrollY, d > 50 ? i() : o()
	}))
}, function(e, t, n) {
	"use strict";

	function i(e) {
		return e && e.__esModule ? e : {
			default: e
		}
	}
	var o = n(0),
		r = i(o),
		s = n(18),
		a = i(s),
		l = document.getElementById("homepage");
	(0, r.default)(document).ready(function() {
		setTimeout(function() {
			l && l.classList.add("fadeIn"), (0, r.default)("body").addClass("color"), setTimeout(function() {
				(0, r.default)(".header").addClass("slideDown")
			}, 500)
		}, 1e3), setTimeout(function() {
			(0, r.default)(".header").addClass("slideDown")
		}, 500)
	}), l && ((0, r.default)(".mobile-down-caret").on("click", function() {
		(0, a.default)((0, r.default)(this), "scroll", {
			offset: "100vh"
		}, {
			duration: 300,
			easing: "easeOutCubic"
		})
	}), (0, a.default)((0, r.default)(".hero__svg"), {
		translateY: "10px"
	}, {
		loop: !0
	}, {
		duration: 400,
		easing: "easeOutCubic"
	}))
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i);
	(0, o.default)(".hover .add-to-cart").mouseover(function() {
		var e = (0, o.default)(this).parents(".product");
		e.addClass("hovering");
		var t = e.attr("data-hover"),
			n = e.parent(".promotion__products-list");
		e.siblings(".product").addClass("hover--transparent");
		n.attr("style", "background-image: url('" + t + "')")
	}), (0, o.default)(".hover .add-to-cart").mouseout(function() {
		var e = (0, o.default)(this).parents(".product");
		e.removeClass("hovering");
		var t = e.parent(".promotion__products-list");
		e.siblings(".product").removeClass("hover--transparent");
		t.attr("style", "background-image: none")
	})
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i);
	(0, o.default)(".see-all").on("click", function() {
		(0, o.default)(this).toggleClass("open"), (0, o.default)(".productView__ingredients-more").toggleClass("less")
	})
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i),
		r = (0, o.default)(".menu"),
		s = (0, o.default)(".menu__nav li"),
		a = (0, o.default)(".menu__overlay"),
		l = (0, o.default)(".header"),
		u = (0, o.default)(".menu__link.parent .menu__link-anchor"),
		c = (0, o.default)(".menu__link:not(.parent) .menu__link-anchor"),
		d = (0, o.default)(".menu__link .menu__link-anchor"),
		p = (0, o.default)(".menu__child"),
		f = (0, o.default)(".menu__mobile"),
		h = (0, o.default)(".menu-mobile__nested"),
		g = (0, o.default)(".menu-mobile .menu__item.main"),
		m = (0, o.default)(".menu-mobile__nested .menu__item.parent"),
		v = window.scrollY;
	(0, o.default)(window).width() > 1024 ? ((0, o.default)(".nav__left li").on("click", function() {
		r.addClass("slideIn"), a.addClass("active"), s.removeClass("active"), (0, o.default)("html").css("overflow-y", "hidden"), (0, o.default)(this).hasClass("menu__product") ? (0, o.default)(".menu__nav .menu__product").addClass("active") : (0, o.default)(this).hasClass("menu__scent") ? (0, o.default)(".menu__nav .menu__scent").addClass("active") : (0, o.default)(this).hasClass("menu__collections") ? (0, o.default)(".menu__nav .menu__collections").addClass("active") : (0, o.default)(this).hasClass("menu__about") && (0, o.default)(".menu__nav .menu__about").addClass("active")
	}), s.on("click", function() {
		s.removeClass("active"), (0, o.default)(this).addClass("active"), d.removeClass("active"), p.removeClass("active")
	}), u.on("mouseover", function() {
		p.removeClass("active"), (0, o.default)(this).next(".menu__child").addClass("active")
	}), c.on("mouseover", function() {
		p.removeClass("active")
	}), c.on("mouseout", function() {
		(0, o.default)(this).removeClass("active")
	}), d.on("mouseover", function() {
		d.removeClass("active"), (0, o.default)(this).addClass("active")
	}), (0, o.default)(".menu__close").on("click", function() {
		r.removeClass("slideIn"), v > 50 && l.addClass("white"), a.removeClass("active"), (0, o.default)("html").css("overflow-y", "scroll"), d.removeClass("active"), p.removeClass("active")
	}), (0, o.default)(".menu__overlay").on("click", function() {
		r.removeClass("slideIn"), v > 50 && l.addClass("white"), a.removeClass("active"), (0, o.default)("html").css("overflow-y", "scroll"), d.removeClass("active"), p.removeClass("active")
	})) : (f.on("click", function() {
		r.toggleClass("slideIn"), l.toggleClass("mobile-open"), (0, o.default)("html").toggleClass("frozen"), h.removeClass("active nested"), r.removeClass("slideLeft"), (0, o.default)(".menu-mobile__nested .menu__list").removeClass("active"), (0, o.default)(".menu__child-nested").removeClass("active")
	}), g.on("click", function() {
		r.addClass("slideLeft"), h.addClass("active"), (0, o.default)(this).hasClass("menu-product") ? (0, o.default)(".menu-mobile__nested .menu-product").addClass("active") : (0, o.default)(this).hasClass("scent") ? (0, o.default)(".menu-mobile__nested .scent").addClass("active") : (0, o.default)(this).hasClass("collection") ? (0, o.default)(".menu-mobile__nested .collection").addClass("active") : (0, o.default)(this).hasClass("about") && (0, o.default)(".menu-mobile__nested .about").addClass("active")
	}), (0, o.default)(".menu-mobile__nested .back-first").on("click", function() {
		r.removeClass("slideLeft"), h.removeClass("active"), (0, o.default)(".menu-mobile__nested .menu__list").removeClass("active")
	}), m.on("click", function() {
		h.addClass("nested"), (0, o.default)(this).children(".menu__child-nested").addClass("active")
	}), (0, o.default)(".back-second").on("click", function(e) {
		(0, o.default)(this).parent(".menu__child-nested").removeClass("active"), h.removeClass("nested"), e.stopPropagation()
	}))
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i);
	if (n(1), document.getElementById("product-page")) {
		var r = (0, o.default)(".related-products");
		r.length > 0 && window.innerWidth < 768 && r.slick({
			dots: !1,
			arrows: !1,
			infinite: !0,
			adaptiveHeight: !0,
			slidesToShow: 1,
			centerMode: !0,
			fade: !1,
			speed: 600
		})
	}
	if (n(1), document.getElementById("collection")) {
		var r = (0, o.default)(".product-type-section .product-type-wrapper .product-type");
		r.length > 0 && window.innerWidth < 768 && r.slick({
			dots: !1,
			arrows: !1,
			infinite: !0,
			adaptiveHeight: !0,
			slidesToShow: 1,
			centerMode: !0,
			fade: !1,
			speed: 600
		})
	}
	if (n(1), document.querySelector(".homepage--article .related-products")) {
		var r = (0, o.default)(".homepage--article .related-products__holder");
		r.length > 0 && window.innerWidth < 768 && r.slick({
			dots: !1,
			arrows: !1,
			infinite: !0,
			adaptiveHeight: !0,
			slidesToShow: 1,
			centerMode: !0,
			fade: !1,
			speed: 600
		})
	}
	if (n(1), document.querySelector(".usc:not(.usc--v2)")) {
		var r = (0, o.default)(".usc__holder");
		r.length > 0 && window.innerWidth < 768 && r.slick({
			dots: !1,
			arrows: !1,
			infinite: !1,
			adaptiveHeight: !0,
			slidesToShow: 2,
			centerMode: !1,
			fade: !1,
			speed: 600
		})
	}
	if (n(1), document.querySelector(".usc.usc--v2")) {
		var r = (0, o.default)(".usc__holder");
		r.length > 0 && window.innerWidth < 1024 && r.slick({
			dots: !1,
			arrows: !1,
			infinite: !1,
			adaptiveHeight: !0,
			centerMode: !1,
			fade: !1,
			speed: 600,
			variableWidth: true,
		})
	}
	if (n(1), document.querySelector(".press-quotes")) {
		var r = (0, o.default)(".press-quotes__holder");
		r.length > 0 && r.slick({
			dots: !0,
			arrows: !0,
			infinite: !0,
			adaptiveHeight: !1,
			slidesToShow: 1,
			centerMode: !1,
			fade: !0,
			autoplay: !0,
  			autoplaySpeed: 3200,
			speed: 600,
			nextArrow: '<i class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-right.svg?16506483156083883680" alt="Arrow Right"></i>',
			prevArrow: '<i class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-left.svg?16506483156083883680" alt="Arrow Left"></i>'
		})
	}
	if (n(1), document.querySelector(".productView .testimonials")) {
		var r = (0, o.default)(".productView .testimonials");
		r.length > 0 && r.slick({
			dots: !0,
			arrows: !0,
			infinite: !0,
			adaptiveHeight: !0,
			slidesToShow: 1,
			centerMode: !1,
			fade: !0,
			speed: 600,
			nextArrow: '<i class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-right.svg?16506483156083883680" alt="Arrow Right"></i>',
			prevArrow: '<i class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0999/9748/files/carousel-arrow-left.svg?16506483156083883680" alt="Arrow Left"></i>'
		})
	}
	if (n(1), document.querySelector(".productView .instagram__posts")) {
		var r = (0, o.default)(".instagram__posts");
		if(r.length > 0 && window.innerWidth < 768) {
			r.slick({
				dots: !0,
				infinite: !0,
				autoplay: !1,
				adaptiveHeight: !1,
				arrows: !1
			})
			jQuery(".instagram__posts .post-1 .post__image").addClass("next")
			jQuery(".instagram__posts .post-2 .post__image").addClass("next")
			jQuery(".instagram__posts .post-3 .post__image").addClass("next")
		} 
	}
}, function(e, t, n) {
	"use strict";
	var i = n(0),
		o = function(e) {
			return e && e.__esModule ? e : {
				default: e
			}
		}(i),
		r = document.getElementById("product-page");
	(0, o.default)(document).ready(function() {
		if (r) {
			var e = (0, o.default)(".product-variants a.swatch:last-of-type"),
				t = (0, o.default)(".productView__image"),
				n = document.getElementsByClassName("productView__utility")[0],
				i = (0, o.default)(".productView__image img");
			if (e.length > 0)
				if (e = parseInt(e.attr("class").split(" ")[0]), window.innerWidth > 770) {
					var s = (0, o.default)(".product-variants .swatch.hide.4");
					s.length > 0 && s.removeClass("hide");
					var a = (e - 4).toString();
					if (a > 0) {
						var l = (0, o.default)(".product-variants .see-more");
						l && (l.text("+ " + a + " more"), l.removeClass("hide"), l.on("click", function() {
							(0, o.default)(this).toggleClass("minus"), (0, o.default)(this).toggleClass("hide"), (0, o.default)(".product-variants .swatch.hide").addClass("extra"), (0, o.default)(".product-variants .extra").toggleClass("hide")
						}))
					}
				} else {
					var u = (e - 3).toString();
					if (u > 0) {
						var c = (0, o.default)(".product-variants .see-more");
						c && (c.text("+ " + u + " more"), c.removeClass("hide"), c.on("click", function() {
							(0, o.default)(this).toggleClass("minus"), (0, o.default)(this).toggleClass("hide"), (0, o.default)(".product-variants .swatch.hide").addClass("extra"), (0, o.default)(".product-variants .extra").toggleClass("hide")
						}))
					}
				}
			t.removeClass("fadeOut"), i.removeClass("fadeOut"), n.classList.remove("slideDown"), (0, o.default)("a:not(.selected).swatch[href]").on("click", function(e) {
				if (t.addClass("fadeOut"), n.classList.add("slideDown"), this.href) {
					var i = this.href;
					setTimeout(function() {
						window.location = i
					}, 300)
				}
			}), (0, o.default)(".swatch").on("mouseover", function() {
				var e = (0, o.default)(this).attr("title");
				e = e.replace("The Healthy Deodorant ", ""), e = e.replace("The Healthy Fragrance ", ""), e = e.replace("The Healthy Body Butter ", ""), e = e.replace("The Healthy Roller-Ball ", ""), (0, o.default)(".swatch-hover .swatch-title").text(e)
			}), (0, o.default)(".swatch").on("mouseout", function() {
				(0, o.default)(".swatch-hover .swatch-title").text("")
			})
		}
	})
}, function(e, t, n) {
	"use strict";
	if (document.getElementById("product-page")) {
		var i = function() {
				a.classList.add("fix-utility"), u.classList.add("fix-utility"), c && c.classList.add("fix-utility"), d && d.classList.add("fix-utility")
			},
			o = function() {
				a.classList.remove("fix-utility"), u.classList.remove("fix-utility"), c && c.classList.remove("fix-utility"), d && d.classList.remove("fix-utility")
			},
			r = function() {
				p.classList.add("slideUpFull")
			},
			s = function() {
				p.classList.remove("slideUpFull")
			};
		window.onbeforeunload = function() {
			window.scrollTo(0, 0)
		};
		var a = document.getElementsByClassName("productView__utility")[0],
			l = a.getBoundingClientRect().top - 200,
			u = document.getElementsByClassName("productView__description")[0],
			c = document.getElementsByClassName("productView__variants")[0],
			d = document.getElementsByClassName("productView__content")[0],
			p = document.getElementsByClassName("header")[0],
			f = a.getBoundingClientRect().top - 285,
			h = window.scrollY;
		window.addEventListener("resize", function() {
			l = a.getBoundingClientRect().top - 200;
			f = a.getBoundingClientRect().top - 285;
			h = window.scrollY, h > l && window.innerWidth > 1024 ? i() : o(), h > f && window.innerWidth > 1024 ? r() : s();
		}); 
		window.addEventListener("scroll", function() {
			h = window.scrollY, h > l && window.innerWidth > 1024 ? i() : o(), h > f && window.innerWidth > 1024 ? r() : s()
		})
	}
}, function(e, t, n) {
	"use strict";

	function i(e) {
		return e && e.__esModule ? e : {
			default: e
		}
	}
	var o = n(4),
		r = (i(o), n(5)),
		s = (i(r), n(6)),
		a = (i(s), n(7)),
		l = (i(a), n(8)),
		u = (i(l), n(9)),
		c = (i(u), n(10)),
		d = (i(c), n(11)),
		p = (i(d), n(12)),
		f = (i(p), n(2)),
		h = (i(f), n(13)),
		g = (i(h), n(14)),
		m = (i(g), n(15));
	i(m)
}, function(e, t, n) {
	"use strict";
	var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
		return typeof e
	} : function(e) {
		return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
	};
	(function() {
		! function(e, t, n) {
			function o(e, t) {
				return (void 0 === e ? "undefined" : i(e)) === t
			}

			function r(e) {
				var t = T.className,
					n = C._config.classPrefix || "";
				if (S && (t = t.baseVal), C._config.enableJSClass) {
					var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
					t = t.replace(i, "$1" + n + "js$2")
				}
				C._config.enableClasses && (t += " " + n + e.join(" " + n), S ? T.className.baseVal = t : T.className = t)
			}

			function s(t, n, i) {
				var o;
				if ("getComputedStyle" in e) {
					o = getComputedStyle.call(e, t, n);
					var r = e.console;
					if (null !== o) i && (o = o.getPropertyValue(i));
					else if (r) {
						var s = r.error ? "error" : "log";
						r[s].call(r, "getComputedStyle returning null, its possible modernizr test results are inaccurate")
					}
				} else o = !n && t.currentStyle && t.currentStyle[i];
				return o
			}

			function a() {
				return "function" != typeof t.createElement ? t.createElement(arguments[0]) : S ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments)
			}

			function l() {
				var e = t.body;
				return e || (e = a(S ? "svg" : "body"), e.fake = !0), e
			}

			function u(e, n, i, o) {
				var r, s, u, c, d = "modernizr",
					p = a("div"),
					f = l();
				if (parseInt(i, 10))
					for (; i--;) u = a("div"), u.id = o ? o[i] : d + (i + 1), p.appendChild(u);
				return r = a("style"), r.type = "text/css", r.id = "s" + d, (f.fake ? f : p).appendChild(r), f.appendChild(p), r.styleSheet ? r.styleSheet.cssText = e : r.appendChild(t.createTextNode(e)), p.id = d, f.fake && (f.style.background = "", f.style.overflow = "hidden", c = T.style.overflow, T.style.overflow = "hidden", T.appendChild(f)), s = n(p, e), f.fake ? (f.parentNode.removeChild(f), T.style.overflow = c, T.offsetHeight) : p.parentNode.removeChild(p), !!s
			}

			function c(e, t) {
				if ("object" == (void 0 === e ? "undefined" : i(e)))
					for (var n in e) A(e, n) && c(n, e[n]);
				else {
					e = e.toLowerCase();
					var o = e.split("."),
						s = C[o[0]];
					if (2 == o.length && (s = s[o[1]]), void 0 !== s) return C;
					t = "function" == typeof t ? t() : t, 1 == o.length ? C[o[0]] = t : (!C[o[0]] || C[o[0]] instanceof Boolean || (C[o[0]] = new Boolean(C[o[0]])), C[o[0]][o[1]] = t), r([(t && 0 != t ? "" : "no-") + o.join("-")]), C._trigger(e, t)
				}
				return C
			}

			function d(e, t) {
				return !!~("" + e).indexOf(t)
			}

			function p(e) {
				return e.replace(/([a-z])-([a-z])/g, function(e, t, n) {
					return t + n.toUpperCase()
				}).replace(/^-/, "")
			}

			function f(e, t) {
				return function() {
					return e.apply(t, arguments)
				}
			}

			function h(e, t, n) {
				var i;
				for (var r in e)
					if (e[r] in t) return !1 === n ? e[r] : (i = t[e[r]], o(i, "function") ? f(i, n || t) : i);
				return !1
			}

			function g(e) {
				return e.replace(/([A-Z])/g, function(e, t) {
					return "-" + t.toLowerCase()
				}).replace(/^ms-/, "-ms-")
			}

			function m(t, i) {
				var o = t.length;
				if ("CSS" in e && "supports" in e.CSS) {
					for (; o--;)
						if (e.CSS.supports(g(t[o]), i)) return !0;
					return !1
				}
				if ("CSSSupportsRule" in e) {
					for (var r = []; o--;) r.push("(" + g(t[o]) + ":" + i + ")");
					return r = r.join(" or "), u("@supports (" + r + ") { #modernizr { position: absolute; } }", function(e) {
						return "absolute" == s(e, null, "position")
					})
				}
				return n
			}

			function v(e, t, i, r) {
				function s() {
					u && (delete j.style, delete j.modElem)
				}
				if (r = !o(r, "undefined") && r, !o(i, "undefined")) {
					var l = m(e, i);
					if (!o(l, "undefined")) return l
				}
				for (var u, c, f, h, g, v = ["modernizr", "tspan", "samp"]; !j.style && v.length;) u = !0, j.modElem = a(v.shift()), j.style = j.modElem.style;
				for (f = e.length, c = 0; f > c; c++)
					if (h = e[c], g = j.style[h], d(h, "-") && (h = p(h)), j.style[h] !== n) {
						if (r || o(i, "undefined")) return s(), "pfx" != t || h;
						try {
							j.style[h] = i
						} catch (e) {}
						if (j.style[h] != g) return s(), "pfx" != t || h
					}
				return s(), !1
			}

			function y(e, t, n, i, r) {
				var s = e.charAt(0).toUpperCase() + e.slice(1),
					a = (e + " " + P.join(s + " ") + s).split(" ");
				return o(t, "string") || o(t, "undefined") ? v(a, t, i, r) : (a = (e + " " + L.join(s + " ") + s).split(" "), h(a, t, n))
			}

			function w(e, t, i) {
				return y(e, n, n, t, i)
			}
			var b = [],
				x = [],
				k = {
					_version: "3.5.0",
					_config: {
						classPrefix: "",
						enableClasses: !0,
						enableJSClass: !0,
						usePrefixes: !0
					},
					_q: [],
					on: function(e, t) {
						var n = this;
						setTimeout(function() {
							t(n[e])
						}, 0)
					},
					addTest: function(e, t, n) {
						x.push({
							name: e,
							fn: t,
							options: n
						})
					},
					addAsyncTest: function(e) {
						x.push({
							name: null,
							fn: e
						})
					}
				},
				C = function() {};
			C.prototype = k, C = new C;
			var T = t.documentElement,
				S = "svg" === T.nodeName.toLowerCase(),
				E = k._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
			k._prefixes = E;
			var _ = k.testStyles = u;
			C.addTest("touchevents", function() {
				var n;
				if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;
				else {
					var i = ["@media (", E.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
					_(i, function(e) {
						n = 9 === e.offsetTop
					})
				}
				return n
			}), _("#modernizr { height: 50vh; }", function(t) {
				var n = parseInt(e.innerHeight / 2, 10),
					i = parseInt(s(t, null, "height"), 10);
				C.addTest("cssvhunit", i == n)
			}), _("#modernizr { width: 50vw; }", function(t) {
				var n = parseInt(e.innerWidth / 2, 10),
					i = parseInt(s(t, null, "width"), 10);
				C.addTest("cssvwunit", i == n)
			});
			var A;
			! function() {
				var e = {}.hasOwnProperty;
				A = o(e, "undefined") || o(e.call, "undefined") ? function(e, t) {
					return t in e && o(e.constructor.prototype[t], "undefined")
				} : function(t, n) {
					return e.call(t, n)
				}
			}(), k._l = {}, k.on = function(e, t) {
				this._l[e] || (this._l[e] = []), this._l[e].push(t), C.hasOwnProperty(e) && setTimeout(function() {
					C._trigger(e, C[e])
				}, 0)
			}, k._trigger = function(e, t) {
				if (this._l[e]) {
					var n = this._l[e];
					setTimeout(function() {
						var e;
						for (e = 0; e < n.length; e++)(0, n[e])(t)
					}, 0), delete this._l[e]
				}
			}, C._q.push(function() {
				k.addTest = c
			});
			var $ = "Moz O ms Webkit",
				P = k._config.usePrefixes ? $.split(" ") : [];
			k._cssomPrefixes = P;
			var L = k._config.usePrefixes ? $.toLowerCase().split(" ") : [];
			k._domPrefixes = L;
			var N = {
				elem: a("modernizr")
			};
			C._q.push(function() {
				delete N.elem
			});
			var j = {
				style: N.elem.style
			};
			C._q.unshift(function() {
					delete j.style
				}), k.testAllProps = y, k.testAllProps = w, C.addTest("flexbox", w("flexBasis", "1px", !0)),
				function() {
					var e, t, n, i, r, s, a;
					for (var l in x)
						if (x.hasOwnProperty(l)) {
							if (e = [], t = x[l], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
								for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
							for (i = o(t.fn, "function") ? t.fn() : t.fn, r = 0; r < e.length; r++) s = e[r], a = s.split("."), 1 === a.length ? C[a[0]] = i : (!C[a[0]] || C[a[0]] instanceof Boolean || (C[a[0]] = new Boolean(C[a[0]])), C[a[0]][a[1]] = i), b.push((i ? "" : "no-") + a.join("-"))
						}
				}(), r(b), delete k.addTest, delete k.addAsyncTest;
			for (var q = 0; q < C._q.length; q++) C._q[q]();
			e.Modernizr = C
		}(window, document), e.exports = window.Modernizr
	}).call(window)
}, function(e, t, n) {
	var i, o;
	! function(e) {
		"use strict";

		function t(e) {
			var t = e.length,
				i = n.type(e);
			return "function" !== i && !n.isWindow(e) && (!(1 !== e.nodeType || !t) || ("array" === i || 0 === t || "number" == typeof t && t > 0 && t - 1 in e))
		}
		if (!e.jQuery) {
			var n = function(e, t) {
				return new n.fn.init(e, t)
			};
			n.isWindow = function(e) {
				return e && e === e.window
			}, n.type = function(e) {
				return e ? "object" == typeof e || "function" == typeof e ? o[s.call(e)] || "object" : typeof e : e + ""
			}, n.isArray = Array.isArray || function(e) {
				return "array" === n.type(e)
			}, n.isPlainObject = function(e) {
				var t;
				if (!e || "object" !== n.type(e) || e.nodeType || n.isWindow(e)) return !1;
				try {
					if (e.constructor && !r.call(e, "constructor") && !r.call(e.constructor.prototype, "isPrototypeOf")) return !1
				} catch (e) {
					return !1
				}
				for (t in e);
				return void 0 === t || r.call(e, t)
			}, n.each = function(e, n, i) {
				var o = 0,
					r = e.length,
					s = t(e);
				if (i) {
					if (s)
						for (; o < r && !1 !== n.apply(e[o], i); o++);
					else
						for (o in e)
							if (e.hasOwnProperty(o) && !1 === n.apply(e[o], i)) break
				} else if (s)
					for (; o < r && !1 !== n.call(e[o], o, e[o]); o++);
				else
					for (o in e)
						if (e.hasOwnProperty(o) && !1 === n.call(e[o], o, e[o])) break;
				return e
			}, n.data = function(e, t, o) {
				if (void 0 === o) {
					var r = e[n.expando],
						s = r && i[r];
					if (void 0 === t) return s;
					if (s && t in s) return s[t]
				} else if (void 0 !== t) {
					var a = e[n.expando] || (e[n.expando] = ++n.uuid);
					return i[a] = i[a] || {}, i[a][t] = o, o
				}
			}, n.removeData = function(e, t) {
				var o = e[n.expando],
					r = o && i[o];
				r && (t ? n.each(t, function(e, t) {
					delete r[t]
				}) : delete i[o])
			}, n.extend = function() {
				var e, t, i, o, r, s, a = arguments[0] || {},
					l = 1,
					u = arguments.length,
					c = !1;
				for ("boolean" == typeof a && (c = a, a = arguments[l] || {}, l++), "object" != typeof a && "function" !== n.type(a) && (a = {}), l === u && (a = this, l--); l < u; l++)
					if (r = arguments[l])
						for (o in r) r.hasOwnProperty(o) && (e = a[o], i = r[o], a !== i && (c && i && (n.isPlainObject(i) || (t = n.isArray(i))) ? (t ? (t = !1, s = e && n.isArray(e) ? e : []) : s = e && n.isPlainObject(e) ? e : {}, a[o] = n.extend(c, s, i)) : void 0 !== i && (a[o] = i)));
				return a
			}, n.queue = function(e, i, o) {
				if (e) {
					i = (i || "fx") + "queue";
					var r = n.data(e, i);
					return o ? (!r || n.isArray(o) ? r = n.data(e, i, function(e, n) {
						var i = n || [];
						return e && (t(Object(e)) ? function(e, t) {
							for (var n = +t.length, i = 0, o = e.length; i < n;) e[o++] = t[i++];
							if (n !== n)
								for (; void 0 !== t[i];) e[o++] = t[i++];
							e.length = o
						}(i, "string" == typeof e ? [e] : e) : [].push.call(i, e)), i
					}(o)) : r.push(o), r) : r || []
				}
			}, n.dequeue = function(e, t) {
				n.each(e.nodeType ? [e] : e, function(e, i) {
					t = t || "fx";
					var o = n.queue(i, t),
						r = o.shift();
					"inprogress" === r && (r = o.shift()), r && ("fx" === t && o.unshift("inprogress"), r.call(i, function() {
						n.dequeue(i, t)
					}))
				})
			}, n.fn = n.prototype = {
				init: function(e) {
					if (e.nodeType) return this[0] = e, this;
					throw new Error("Not a DOM node.")
				},
				offset: function() {
					var t = this[0].getBoundingClientRect ? this[0].getBoundingClientRect() : {
						top: 0,
						left: 0
					};
					return {
						top: t.top + (e.pageYOffset || document.scrollTop || 0) - (document.clientTop || 0),
						left: t.left + (e.pageXOffset || document.scrollLeft || 0) - (document.clientLeft || 0)
					}
				},
				position: function() {
					var e = this[0],
						t = function(e) {
							for (var t = e.offsetParent; t && "html" !== t.nodeName.toLowerCase() && t.style && "static" === t.style.position.toLowerCase();) t = t.offsetParent;
							return t || document
						}(e),
						i = this.offset(),
						o = /^(?:body|html)$/i.test(t.nodeName) ? {
							top: 0,
							left: 0
						} : n(t).offset();
					return i.top -= parseFloat(e.style.marginTop) || 0, i.left -= parseFloat(e.style.marginLeft) || 0, t.style && (o.top += parseFloat(t.style.borderTopWidth) || 0, o.left += parseFloat(t.style.borderLeftWidth) || 0), {
						top: i.top - o.top,
						left: i.left - o.left
					}
				}
			};
			var i = {};
			n.expando = "velocity" + (new Date).getTime(), n.uuid = 0;
			for (var o = {}, r = o.hasOwnProperty, s = o.toString, a = "Boolean Number String Function Array Date RegExp Object Error".split(" "), l = 0; l < a.length; l++) o["[object " + a[l] + "]"] = a[l].toLowerCase();
			n.fn.init.prototype = n.fn, e.Velocity = {
				Utilities: n
			}
		}
	}(window),
	function(r) {
		"use strict";
		"object" == typeof e && "object" == typeof e.exports ? e.exports = r() : (i = r, void 0 !== (o = "function" == typeof i ? i.call(t, n, t, e) : i) && (e.exports = o))
	}(function() {
		"use strict";
		return function(e, t, n, i) {
			function o(e) {
				for (var t = -1, n = e ? e.length : 0, i = []; ++t < n;) {
					var o = e[t];
					o && i.push(o)
				}
				return i
			}

			function r(e) {
				return b.isWrapped(e) ? e = y.call(e) : b.isNode(e) && (e = [e]), e
			}

			function s(e) {
				var t = h.data(e, "velocity");
				return null === t ? i : t
			}

			function a(e, t) {
				var n = s(e);
				n && n.delayTimer && !n.delayPaused && (n.delayRemaining = n.delay - t + n.delayBegin, n.delayPaused = !0, clearTimeout(n.delayTimer.setTimeout))
			}

			function l(e, t) {
				var n = s(e);
				n && n.delayTimer && n.delayPaused && (n.delayPaused = !1, n.delayTimer.setTimeout = setTimeout(n.delayTimer.next, n.delayRemaining))
			}

			function u(e) {
				return function(t) {
					return Math.round(t * e) * (1 / e)
				}
			}

			function c(e, n, i, o) {
				function r(e, t) {
					return 1 - 3 * t + 3 * e
				}

				function s(e, t) {
					return 3 * t - 6 * e
				}

				function a(e) {
					return 3 * e
				}

				function l(e, t, n) {
					return ((r(t, n) * e + s(t, n)) * e + a(t)) * e
				}

				function u(e, t, n) {
					return 3 * r(t, n) * e * e + 2 * s(t, n) * e + a(t)
				}

				function c(t, n) {
					for (var o = 0; o < g; ++o) {
						var r = u(n, e, i);
						if (0 === r) return n;
						n -= (l(n, e, i) - t) / r
					}
					return n
				}

				function d() {
					for (var t = 0; t < w; ++t) C[t] = l(t * b, e, i)
				}

				function p(t, n, o) {
					var r, s, a = 0;
					do {
						s = n + (o - n) / 2, r = l(s, e, i) - t, r > 0 ? o = s : n = s
					} while (Math.abs(r) > v && ++a < y);
					return s
				}

				function f(t) {
					for (var n = 0, o = 1, r = w - 1; o !== r && C[o] <= t; ++o) n += b;
					--o;
					var s = (t - C[o]) / (C[o + 1] - C[o]),
						a = n + s * b,
						l = u(a, e, i);
					return l >= m ? c(t, a) : 0 === l ? a : p(t, n, n + b)
				}

				function h() {
					T = !0, e === n && i === o || d()
				}
				var g = 4,
					m = .001,
					v = 1e-7,
					y = 10,
					w = 11,
					b = 1 / (w - 1),
					x = "Float32Array" in t;
				if (4 !== arguments.length) return !1;
				for (var k = 0; k < 4; ++k)
					if ("number" != typeof arguments[k] || isNaN(arguments[k]) || !isFinite(arguments[k])) return !1;
				e = Math.min(e, 1), i = Math.min(i, 1), e = Math.max(e, 0), i = Math.max(i, 0);
				var C = x ? new Float32Array(w) : new Array(w),
					T = !1,
					S = function(t) {
						return T || h(), e === n && i === o ? t : 0 === t ? 0 : 1 === t ? 1 : l(f(t), n, o)
					};
				S.getControlPoints = function() {
					return [{
						x: e,
						y: n
					}, {
						x: i,
						y: o
					}]
				};
				var E = "generateBezier(" + [e, n, i, o] + ")";
				return S.toString = function() {
					return E
				}, S
			}

			function d(e, t) {
				var n = e;
				return b.isString(e) ? T.Easings[e] || (n = !1) : n = b.isArray(e) && 1 === e.length ? u.apply(null, e) : b.isArray(e) && 2 === e.length ? S.apply(null, e.concat([t])) : !(!b.isArray(e) || 4 !== e.length) && c.apply(null, e), !1 === n && (n = T.Easings[T.defaults.easing] ? T.defaults.easing : C), n
			}

			function p(e) {
				if (e) {
					var t = T.timestamp && !0 !== e ? e : v.now(),
						n = T.State.calls.length;
					n > 1e4 && (T.State.calls = o(T.State.calls), n = T.State.calls.length);
					for (var r = 0; r < n; r++)
						if (T.State.calls[r]) {
							var a = T.State.calls[r],
								l = a[0],
								u = a[2],
								c = a[3],
								d = !c,
								m = null,
								y = a[5],
								w = a[6];
							if (c || (c = T.State.calls[r][3] = t - 16), y) {
								if (!0 !== y.resume) continue;
								c = a[3] = Math.round(t - w - 16), a[5] = null
							}
							w = a[6] = t - c;
							for (var x = Math.min(w / u.duration, 1), k = 0, C = l.length; k < C; k++) {
								var S = l[k],
									_ = S.element;
								if (s(_)) {
									var $ = !1;
									if (u.display !== i && null !== u.display && "none" !== u.display) {
										if ("flex" === u.display) {
											var P = ["-webkit-box", "-moz-box", "-ms-flexbox", "-webkit-flex"];
											h.each(P, function(e, t) {
												E.setPropertyValue(_, "display", t)
											})
										}
										E.setPropertyValue(_, "display", u.display)
									}
									u.visibility !== i && "hidden" !== u.visibility && E.setPropertyValue(_, "visibility", u.visibility);
									for (var L in S)
										if (S.hasOwnProperty(L) && "element" !== L) {
											var N, j = S[L],
												q = b.isString(j.easing) ? T.Easings[j.easing] : j.easing;
											if (b.isString(j.pattern)) {
												var H = 1 === x ? function(e, t, n) {
													var i = j.endValue[t];
													return n ? Math.round(i) : i
												} : function(e, t, n) {
													var i = j.startValue[t],
														o = j.endValue[t] - i,
														r = i + o * q(x, u, o);
													return n ? Math.round(r) : r
												};
												N = j.pattern.replace(/{(\d+)(!)?}/g, H)
											} else if (1 === x) N = j.endValue;
											else {
												var O = j.endValue - j.startValue;
												N = j.startValue + O * q(x, u, O)
											}
											if (!d && N === j.currentValue) continue;
											if (j.currentValue = N, "tween" === L) m = N;
											else {
												var D;
												if (E.Hooks.registered[L]) {
													D = E.Hooks.getRoot(L);
													var M = s(_).rootPropertyValueCache[D];
													M && (j.rootPropertyValue = M)
												}
												var I = E.setPropertyValue(_, L, j.currentValue + (g < 9 && 0 === parseFloat(N) ? "" : j.unitType), j.rootPropertyValue, j.scrollData);
												E.Hooks.registered[L] && (E.Normalizations.registered[D] ? s(_).rootPropertyValueCache[D] = E.Normalizations.registered[D]("extract", null, I[1]) : s(_).rootPropertyValueCache[D] = I[1]), "transform" === I[0] && ($ = !0)
											}
										}
									u.mobileHA && s(_).transformCache.translate3d === i && (s(_).transformCache.translate3d = "(0px, 0px, 0px)", $ = !0), $ && E.flushTransformCache(_)
								}
							}
							u.display !== i && "none" !== u.display && (T.State.calls[r][2].display = !1), u.visibility !== i && "hidden" !== u.visibility && (T.State.calls[r][2].visibility = !1), u.progress && u.progress.call(a[1], a[1], x, Math.max(0, c + u.duration - t), c, m), 1 === x && f(r)
						}
				}
				T.State.isTicking && A(p)
			}

			function f(e, t) {
				if (!T.State.calls[e]) return !1;
				for (var n = T.State.calls[e][0], o = T.State.calls[e][1], r = T.State.calls[e][2], a = T.State.calls[e][4], l = !1, u = 0, c = n.length; u < c; u++) {
					var d = n[u].element;
					t || r.loop || ("none" === r.display && E.setPropertyValue(d, "display", r.display), "hidden" === r.visibility && E.setPropertyValue(d, "visibility", r.visibility));
					var p = s(d);
					if (!0 !== r.loop && (h.queue(d)[1] === i || !/\.velocityQueueEntryFlag/i.test(h.queue(d)[1])) && p) {
						p.isAnimating = !1, p.rootPropertyValueCache = {};
						var f = !1;
						h.each(E.Lists.transforms3D, function(e, t) {
							var n = /^scale/.test(t) ? 1 : 0,
								o = p.transformCache[t];
							p.transformCache[t] !== i && new RegExp("^\\(" + n + "[^.]").test(o) && (f = !0, delete p.transformCache[t])
						}), r.mobileHA && (f = !0, delete p.transformCache.translate3d), f && E.flushTransformCache(d), E.Values.removeClass(d, "velocity-animating")
					}
					if (!t && r.complete && !r.loop && u === c - 1) try {
						r.complete.call(o, o)
					} catch (e) {
						setTimeout(function() {
							throw e
						}, 1)
					}
					a && !0 !== r.loop && a(o), p && !0 === r.loop && !t && (h.each(p.tweensContainer, function(e, t) {
						if (/^rotate/.test(e) && (parseFloat(t.startValue) - parseFloat(t.endValue)) % 360 == 0) {
							var n = t.startValue;
							t.startValue = t.endValue, t.endValue = n
						}
						/^backgroundPosition/.test(e) && 100 === parseFloat(t.endValue) && "%" === t.unitType && (t.endValue = 0, t.startValue = 100)
					}), T(d, "reverse", {
						loop: !0,
						delay: r.delay
					})), !1 !== r.queue && h.dequeue(d, r.queue)
				}
				T.State.calls[e] = !1;
				for (var g = 0, m = T.State.calls.length; g < m; g++)
					if (!1 !== T.State.calls[g]) {
						l = !0;
						break
					}!1 === l && (T.State.isTicking = !1, delete T.State.calls, T.State.calls = [])
			}
			var h, g = function() {
					if (n.documentMode) return n.documentMode;
					for (var e = 7; e > 4; e--) {
						var t = n.createElement("div");
						if (t.innerHTML = "\x3c!--[if IE " + e + "]><span></span><![endif]--\x3e", t.getElementsByTagName("span").length) return t = null, e
					}
					return i
				}(),
				m = function() {
					var e = 0;
					return t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || function(t) {
						var n, i = (new Date).getTime();
						return n = Math.max(0, 16 - (i - e)), e = i + n, setTimeout(function() {
							t(i + n)
						}, n)
					}
				}(),
				v = function() {
					var e = t.performance || {};
					if ("function" != typeof e.now) {
						var n = e.timing && e.timing.navigationStart ? e.timing.navigationStart : (new Date).getTime();
						e.now = function() {
							return (new Date).getTime() - n
						}
					}
					return e
				}(),
				y = function() {
					var e = Array.prototype.slice;
					try {
						return e.call(n.documentElement), e
					} catch (t) {
						return function(t, n) {
							var i = this.length;
							if ("number" != typeof t && (t = 0), "number" != typeof n && (n = i), this.slice) return e.call(this, t, n);
							var o, r = [],
								s = t >= 0 ? t : Math.max(0, i + t),
								a = n < 0 ? i + n : Math.min(n, i),
								l = a - s;
							if (l > 0)
								if (r = new Array(l), this.charAt)
									for (o = 0; o < l; o++) r[o] = this.charAt(s + o);
								else
									for (o = 0; o < l; o++) r[o] = this[s + o];
							return r
						}
					}
				}(),
				w = function() {
					return Array.prototype.includes ? function(e, t) {
						return e.includes(t)
					} : Array.prototype.indexOf ? function(e, t) {
						return e.indexOf(t) >= 0
					} : function(e, t) {
						for (var n = 0; n < e.length; n++)
							if (e[n] === t) return !0;
						return !1
					}
				},
				b = {
					isNumber: function(e) {
						return "number" == typeof e
					},
					isString: function(e) {
						return "string" == typeof e
					},
					isArray: Array.isArray || function(e) {
						return "[object Array]" === Object.prototype.toString.call(e)
					},
					isFunction: function(e) {
						return "[object Function]" === Object.prototype.toString.call(e)
					},
					isNode: function(e) {
						return e && e.nodeType
					},
					isWrapped: function(e) {
						return e && e !== t && b.isNumber(e.length) && !b.isString(e) && !b.isFunction(e) && !b.isNode(e) && (0 === e.length || b.isNode(e[0]))
					},
					isSVG: function(e) {
						return t.SVGElement && e instanceof t.SVGElement
					},
					isEmptyObject: function(e) {
						for (var t in e)
							if (e.hasOwnProperty(t)) return !1;
						return !0
					}
				},
				x = !1;
			if (e.fn && e.fn.jquery ? (h = e, x = !0) : h = t.Velocity.Utilities, g <= 8 && !x) throw new Error("Velocity: IE8 and below require jQuery to be loaded before Velocity.");
			if (g <= 7) return void(jQuery.fn.velocity = jQuery.fn.animate);
			var k = 400,
				C = "swing",
				T = {
					State: {
						isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(t.navigator.userAgent),
						isAndroid: /Android/i.test(t.navigator.userAgent),
						isGingerbread: /Android 2\.3\.[3-7]/i.test(t.navigator.userAgent),
						isChrome: t.chrome,
						isFirefox: /Firefox/i.test(t.navigator.userAgent),
						prefixElement: n.createElement("div"),
						prefixMatches: {},
						scrollAnchor: null,
						scrollPropertyLeft: null,
						scrollPropertyTop: null,
						isTicking: !1,
						calls: [],
						delayedElements: {
							count: 0
						}
					},
					CSS: {},
					Utilities: h,
					Redirects: {},
					Easings: {},
					Promise: t.Promise,
					defaults: {
						queue: "",
						duration: k,
						easing: C,
						begin: i,
						complete: i,
						progress: i,
						display: i,
						visibility: i,
						loop: !1,
						delay: !1,
						mobileHA: !0,
						_cacheValues: !0,
						promiseRejectEmpty: !0
					},
					init: function(e) {
						h.data(e, "velocity", {
							isSVG: b.isSVG(e),
							isAnimating: !1,
							computedStyle: null,
							tweensContainer: null,
							rootPropertyValueCache: {},
							transformCache: {}
						})
					},
					hook: null,
					mock: !1,
					version: {
						major: 1,
						minor: 5,
						patch: 1
					},
					debug: !1,
					timestamp: !0,
					pauseAll: function(e) {
						var t = (new Date).getTime();
						h.each(T.State.calls, function(t, n) {
							if (n) {
								if (e !== i && (n[2].queue !== e || !1 === n[2].queue)) return !0;
								n[5] = {
									resume: !1
								}
							}
						}), h.each(T.State.delayedElements, function(e, n) {
							n && a(n, t)
						})
					},
					resumeAll: function(e) {
						var t = (new Date).getTime();
						h.each(T.State.calls, function(t, n) {
							if (n) {
								if (e !== i && (n[2].queue !== e || !1 === n[2].queue)) return !0;
								n[5] && (n[5].resume = !0)
							}
						}), h.each(T.State.delayedElements, function(e, n) {
							n && l(n, t)
						})
					}
				};
			t.pageYOffset !== i ? (T.State.scrollAnchor = t, T.State.scrollPropertyLeft = "pageXOffset", T.State.scrollPropertyTop = "pageYOffset") : (T.State.scrollAnchor = n.documentElement || n.body.parentNode || n.body, T.State.scrollPropertyLeft = "scrollLeft", T.State.scrollPropertyTop = "scrollTop");
			var S = function() {
				function e(e) {
					return -e.tension * e.x - e.friction * e.v
				}

				function t(t, n, i) {
					var o = {
						x: t.x + i.dx * n,
						v: t.v + i.dv * n,
						tension: t.tension,
						friction: t.friction
					};
					return {
						dx: o.v,
						dv: e(o)
					}
				}

				function n(n, i) {
					var o = {
							dx: n.v,
							dv: e(n)
						},
						r = t(n, .5 * i, o),
						s = t(n, .5 * i, r),
						a = t(n, i, s),
						l = 1 / 6 * (o.dx + 2 * (r.dx + s.dx) + a.dx),
						u = 1 / 6 * (o.dv + 2 * (r.dv + s.dv) + a.dv);
					return n.x = n.x + l * i, n.v = n.v + u * i, n
				}
				return function e(t, i, o) {
					var r, s, a, l = {
							x: -1,
							v: 0,
							tension: null,
							friction: null
						},
						u = [0],
						c = 0;
					for (t = parseFloat(t) || 500, i = parseFloat(i) || 20, o = o || null, l.tension = t, l.friction = i, r = null !== o, r ? (c = e(t, i), s = c / o * .016) : s = .016;;)
						if (a = n(a || l, s), u.push(1 + a.x), c += 16, !(Math.abs(a.x) > 1e-4 && Math.abs(a.v) > 1e-4)) break;
					return r ? function(e) {
						return u[e * (u.length - 1) | 0]
					} : c
				}
			}();
			T.Easings = {
				linear: function(e) {
					return e
				},
				swing: function(e) {
					return .5 - Math.cos(e * Math.PI) / 2
				},
				spring: function(e) {
					return 1 - Math.cos(4.5 * e * Math.PI) * Math.exp(6 * -e)
				}
			}, h.each([
				["ease", [.25, .1, .25, 1]],
				["ease-in", [.42, 0, 1, 1]],
				["ease-out", [0, 0, .58, 1]],
				["ease-in-out", [.42, 0, .58, 1]],
				["easeInSine", [.47, 0, .745, .715]],
				["easeOutSine", [.39, .575, .565, 1]],
				["easeInOutSine", [.445, .05, .55, .95]],
				["easeInQuad", [.55, .085, .68, .53]],
				["easeOutQuad", [.25, .46, .45, .94]],
				["easeInOutQuad", [.455, .03, .515, .955]],
				["easeInCubic", [.55, .055, .675, .19]],
				["easeOutCubic", [.215, .61, .355, 1]],
				["easeInOutCubic", [.645, .045, .355, 1]],
				["easeInQuart", [.895, .03, .685, .22]],
				["easeOutQuart", [.165, .84, .44, 1]],
				["easeInOutQuart", [.77, 0, .175, 1]],
				["easeInQuint", [.755, .05, .855, .06]],
				["easeOutQuint", [.23, 1, .32, 1]],
				["easeInOutQuint", [.86, 0, .07, 1]],
				["easeInExpo", [.95, .05, .795, .035]],
				["easeOutExpo", [.19, 1, .22, 1]],
				["easeInOutExpo", [1, 0, 0, 1]],
				["easeInCirc", [.6, .04, .98, .335]],
				["easeOutCirc", [.075, .82, .165, 1]],
				["easeInOutCirc", [.785, .135, .15, .86]]
			], function(e, t) {
				T.Easings[t[0]] = c.apply(null, t[1])
			});
			var E = T.CSS = {
				RegEx: {
					isHex: /^#([A-f\d]{3}){1,2}$/i,
					valueUnwrap: /^[A-z]+\((.*)\)$/i,
					wrappedValueAlreadyExtracted: /[0-9.]+ [0-9.]+ [0-9.]+( [0-9.]+)?/,
					valueSplit: /([A-z]+\(.+\))|(([A-z0-9#-.]+?)(?=\s|$))/gi
				},
				Lists: {
					colors: ["fill", "stroke", "stopColor", "color", "backgroundColor", "borderColor", "borderTopColor", "borderRightColor", "borderBottomColor", "borderLeftColor", "outlineColor"],
					transformsBase: ["translateX", "translateY", "scale", "scaleX", "scaleY", "skewX", "skewY", "rotateZ"],
					transforms3D: ["transformPerspective", "translateZ", "scaleZ", "rotateX", "rotateY"],
					units: ["%", "em", "ex", "ch", "rem", "vw", "vh", "vmin", "vmax", "cm", "mm", "Q", "in", "pc", "pt", "px", "deg", "grad", "rad", "turn", "s", "ms"],
					colorNames: {
						aliceblue: "240,248,255",
						antiquewhite: "250,235,215",
						aquamarine: "127,255,212",
						aqua: "0,255,255",
						azure: "240,255,255",
						beige: "245,245,220",
						bisque: "255,228,196",
						black: "0,0,0",
						blanchedalmond: "255,235,205",
						blueviolet: "138,43,226",
						blue: "0,0,255",
						brown: "165,42,42",
						burlywood: "222,184,135",
						cadetblue: "95,158,160",
						chartreuse: "127,255,0",
						chocolate: "210,105,30",
						coral: "255,127,80",
						cornflowerblue: "100,149,237",
						cornsilk: "255,248,220",
						crimson: "220,20,60",
						cyan: "0,255,255",
						darkblue: "0,0,139",
						darkcyan: "0,139,139",
						darkgoldenrod: "184,134,11",
						darkgray: "169,169,169",
						darkgrey: "169,169,169",
						darkgreen: "0,100,0",
						darkkhaki: "189,183,107",
						darkmagenta: "139,0,139",
						darkolivegreen: "85,107,47",
						darkorange: "255,140,0",
						darkorchid: "153,50,204",
						darkred: "139,0,0",
						darksalmon: "233,150,122",
						darkseagreen: "143,188,143",
						darkslateblue: "72,61,139",
						darkslategray: "47,79,79",
						darkturquoise: "0,206,209",
						darkviolet: "148,0,211",
						deeppink: "255,20,147",
						deepskyblue: "0,191,255",
						dimgray: "105,105,105",
						dimgrey: "105,105,105",
						dodgerblue: "30,144,255",
						firebrick: "178,34,34",
						floralwhite: "255,250,240",
						forestgreen: "34,139,34",
						fuchsia: "255,0,255",
						gainsboro: "220,220,220",
						ghostwhite: "248,248,255",
						gold: "255,215,0",
						goldenrod: "218,165,32",
						gray: "128,128,128",
						grey: "128,128,128",
						greenyellow: "173,255,47",
						green: "0,128,0",
						honeydew: "240,255,240",
						hotpink: "255,105,180",
						indianred: "205,92,92",
						indigo: "75,0,130",
						ivory: "255,255,240",
						khaki: "240,230,140",
						lavenderblush: "255,240,245",
						lavender: "230,230,250",
						lawngreen: "124,252,0",
						lemonchiffon: "255,250,205",
						lightblue: "173,216,230",
						lightcoral: "240,128,128",
						lightcyan: "224,255,255",
						lightgoldenrodyellow: "250,250,210",
						lightgray: "211,211,211",
						lightgrey: "211,211,211",
						lightgreen: "144,238,144",
						lightpink: "255,182,193",
						lightsalmon: "255,160,122",
						lightseagreen: "32,178,170",
						lightskyblue: "135,206,250",
						lightslategray: "119,136,153",
						lightsteelblue: "176,196,222",
						lightyellow: "255,255,224",
						limegreen: "50,205,50",
						lime: "0,255,0",
						linen: "250,240,230",
						magenta: "255,0,255",
						maroon: "128,0,0",
						mediumaquamarine: "102,205,170",
						mediumblue: "0,0,205",
						mediumorchid: "186,85,211",
						mediumpurple: "147,112,219",
						mediumseagreen: "60,179,113",
						mediumslateblue: "123,104,238",
						mediumspringgreen: "0,250,154",
						mediumturquoise: "72,209,204",
						mediumvioletred: "199,21,133",
						midnightblue: "25,25,112",
						mintcream: "245,255,250",
						mistyrose: "255,228,225",
						moccasin: "255,228,181",
						navajowhite: "255,222,173",
						navy: "0,0,128",
						oldlace: "253,245,230",
						olivedrab: "107,142,35",
						olive: "128,128,0",
						orangered: "255,69,0",
						orange: "255,165,0",
						orchid: "218,112,214",
						palegoldenrod: "238,232,170",
						palegreen: "152,251,152",
						paleturquoise: "175,238,238",
						palevioletred: "219,112,147",
						papayawhip: "255,239,213",
						peachpuff: "255,218,185",
						peru: "205,133,63",
						pink: "255,192,203",
						plum: "221,160,221",
						powderblue: "176,224,230",
						purple: "128,0,128",
						red: "255,0,0",
						rosybrown: "188,143,143",
						royalblue: "65,105,225",
						saddlebrown: "139,69,19",
						salmon: "250,128,114",
						sandybrown: "244,164,96",
						seagreen: "46,139,87",
						seashell: "255,245,238",
						sienna: "160,82,45",
						silver: "192,192,192",
						skyblue: "135,206,235",
						slateblue: "106,90,205",
						slategray: "112,128,144",
						snow: "255,250,250",
						springgreen: "0,255,127",
						steelblue: "70,130,180",
						tan: "210,180,140",
						teal: "0,128,128",
						thistle: "216,191,216",
						tomato: "255,99,71",
						turquoise: "64,224,208",
						violet: "238,130,238",
						wheat: "245,222,179",
						whitesmoke: "245,245,245",
						white: "255,255,255",
						yellowgreen: "154,205,50",
						yellow: "255,255,0"
					}
				},
				Hooks: {
					templates: {
						textShadow: ["Color X Y Blur", "black 0px 0px 0px"],
						boxShadow: ["Color X Y Blur Spread", "black 0px 0px 0px 0px"],
						clip: ["Top Right Bottom Left", "0px 0px 0px 0px"],
						backgroundPosition: ["X Y", "0% 0%"],
						transformOrigin: ["X Y Z", "50% 50% 0px"],
						perspectiveOrigin: ["X Y", "50% 50%"]
					},
					registered: {},
					register: function() {
						for (var e = 0; e < E.Lists.colors.length; e++) {
							var t = "color" === E.Lists.colors[e] ? "0 0 0 1" : "255 255 255 1";
							E.Hooks.templates[E.Lists.colors[e]] = ["Red Green Blue Alpha", t]
						}
						var n, i, o;
						if (g)
							for (n in E.Hooks.templates)
								if (E.Hooks.templates.hasOwnProperty(n)) {
									i = E.Hooks.templates[n], o = i[0].split(" ");
									var r = i[1].match(E.RegEx.valueSplit);
									"Color" === o[0] && (o.push(o.shift()), r.push(r.shift()), E.Hooks.templates[n] = [o.join(" "), r.join(" ")])
								}
						for (n in E.Hooks.templates)
							if (E.Hooks.templates.hasOwnProperty(n)) {
								i = E.Hooks.templates[n], o = i[0].split(" ");
								for (var s in o)
									if (o.hasOwnProperty(s)) {
										var a = n + o[s],
											l = s;
										E.Hooks.registered[a] = [n, l]
									}
							}
					},
					getRoot: function(e) {
						var t = E.Hooks.registered[e];
						return t ? t[0] : e
					},
					getUnit: function(e, t) {
						var n = (e.substr(t || 0, 5).match(/^[a-z%]+/) || [])[0] || "";
						return n && w(E.Lists.units, n) ? n : ""
					},
					fixColors: function(e) {
						return e.replace(/(rgba?\(\s*)?(\b[a-z]+\b)/g, function(e, t, n) {
							return E.Lists.colorNames.hasOwnProperty(n) ? (t || "rgba(") + E.Lists.colorNames[n] + (t ? "" : ",1)") : t + n
						})
					},
					cleanRootPropertyValue: function(e, t) {
						return E.RegEx.valueUnwrap.test(t) && (t = t.match(E.RegEx.valueUnwrap)[1]), E.Values.isCSSNullValue(t) && (t = E.Hooks.templates[e][1]), t
					},
					extractValue: function(e, t) {
						var n = E.Hooks.registered[e];
						if (n) {
							var i = n[0],
								o = n[1];
							return t = E.Hooks.cleanRootPropertyValue(i, t), t.toString().match(E.RegEx.valueSplit)[o]
						}
						return t
					},
					injectValue: function(e, t, n) {
						var i = E.Hooks.registered[e];
						if (i) {
							var o, r = i[0],
								s = i[1];
							return n = E.Hooks.cleanRootPropertyValue(r, n), o = n.toString().match(E.RegEx.valueSplit), o[s] = t, o.join(" ")
						}
						return n
					}
				},
				Normalizations: {
					registered: {
						clip: function(e, t, n) {
							switch (e) {
								case "name":
									return "clip";
								case "extract":
									var i;
									return E.RegEx.wrappedValueAlreadyExtracted.test(n) ? i = n : (i = n.toString().match(E.RegEx.valueUnwrap), i = i ? i[1].replace(/,(\s+)?/g, " ") : n), i;
								case "inject":
									return "rect(" + n + ")"
							}
						},
						blur: function(e, t, n) {
							switch (e) {
								case "name":
									return T.State.isFirefox ? "filter" : "-webkit-filter";
								case "extract":
									var i = parseFloat(n);
									if (!i && 0 !== i) {
										var o = n.toString().match(/blur\(([0-9]+[A-z]+)\)/i);
										i = o ? o[1] : 0
									}
									return i;
								case "inject":
									return parseFloat(n) ? "blur(" + n + ")" : "none"
							}
						},
						opacity: function(e, t, n) {
							if (g <= 8) switch (e) {
								case "name":
									return "filter";
								case "extract":
									var i = n.toString().match(/alpha\(opacity=(.*)\)/i);
									return n = i ? i[1] / 100 : 1;
								case "inject":
									return t.style.zoom = 1, parseFloat(n) >= 1 ? "" : "alpha(opacity=" + parseInt(100 * parseFloat(n), 10) + ")"
							} else switch (e) {
								case "name":
									return "opacity";
								case "extract":
								case "inject":
									return n
							}
						}
					},
					register: function() {
						function e(e, t, n) {
							if ("border-box" === E.getPropertyValue(t, "boxSizing").toString().toLowerCase() === (n || !1)) {
								var i, o, r = 0,
									s = "width" === e ? ["Left", "Right"] : ["Top", "Bottom"],
									a = ["padding" + s[0], "padding" + s[1], "border" + s[0] + "Width", "border" + s[1] + "Width"];
								for (i = 0; i < a.length; i++) o = parseFloat(E.getPropertyValue(t, a[i])), isNaN(o) || (r += o);
								return n ? -r : r
							}
							return 0
						}

						function t(t, n) {
							return function(i, o, r) {
								switch (i) {
									case "name":
										return t;
									case "extract":
										return parseFloat(r) + e(t, o, n);
									case "inject":
										return parseFloat(r) - e(t, o, n) + "px"
								}
							}
						}
						g && !(g > 9) || T.State.isGingerbread || (E.Lists.transformsBase = E.Lists.transformsBase.concat(E.Lists.transforms3D));
						for (var n = 0; n < E.Lists.transformsBase.length; n++) ! function() {
							var e = E.Lists.transformsBase[n];
							E.Normalizations.registered[e] = function(t, n, o) {
								switch (t) {
									case "name":
										return "transform";
									case "extract":
										return s(n) === i || s(n).transformCache[e] === i ? /^scale/i.test(e) ? 1 : 0 : s(n).transformCache[e].replace(/[()]/g, "");
									case "inject":
										var r = !1;
										switch (e.substr(0, e.length - 1)) {
											case "translate":
												r = !/(%|px|em|rem|vw|vh|\d)$/i.test(o);
												break;
											case "scal":
											case "scale":
												T.State.isAndroid && s(n).transformCache[e] === i && o < 1 && (o = 1), r = !/(\d)$/i.test(o);
												break;
											case "skew":
											case "rotate":
												r = !/(deg|\d)$/i.test(o)
										}
										return r || (s(n).transformCache[e] = "(" + o + ")"), s(n).transformCache[e]
								}
							}
						}();
						for (var o = 0; o < E.Lists.colors.length; o++) ! function() {
							var e = E.Lists.colors[o];
							E.Normalizations.registered[e] = function(t, n, o) {
								switch (t) {
									case "name":
										return e;
									case "extract":
										var r;
										if (E.RegEx.wrappedValueAlreadyExtracted.test(o)) r = o;
										else {
											var s, a = {
												black: "rgb(0, 0, 0)",
												blue: "rgb(0, 0, 255)",
												gray: "rgb(128, 128, 128)",
												green: "rgb(0, 128, 0)",
												red: "rgb(255, 0, 0)",
												white: "rgb(255, 255, 255)"
											};
											/^[A-z]+$/i.test(o) ? s = a[o] !== i ? a[o] : a.black : E.RegEx.isHex.test(o) ? s = "rgb(" + E.Values.hexToRgb(o).join(" ") + ")" : /^rgba?\(/i.test(o) || (s = a.black), r = (s || o).toString().match(E.RegEx.valueUnwrap)[1].replace(/,(\s+)?/g, " ")
										}
										return (!g || g > 8) && 3 === r.split(" ").length && (r += " 1"), r;
									case "inject":
										return /^rgb/.test(o) ? o : (g <= 8 ? 4 === o.split(" ").length && (o = o.split(/\s+/).slice(0, 3).join(" ")) : 3 === o.split(" ").length && (o += " 1"), (g <= 8 ? "rgb" : "rgba") + "(" + o.replace(/\s+/g, ",").replace(/\.(\d)+(?=,)/g, "") + ")")
								}
							}
						}();
						E.Normalizations.registered.innerWidth = t("width", !0), E.Normalizations.registered.innerHeight = t("height", !0), E.Normalizations.registered.outerWidth = t("width"), E.Normalizations.registered.outerHeight = t("height")
					}
				},
				Names: {
					camelCase: function(e) {
						return e.replace(/-(\w)/g, function(e, t) {
							return t.toUpperCase()
						})
					},
					SVGAttribute: function(e) {
						var t = "width|height|x|y|cx|cy|r|rx|ry|x1|x2|y1|y2";
						return (g || T.State.isAndroid && !T.State.isChrome) && (t += "|transform"), new RegExp("^(" + t + ")$", "i").test(e)
					},
					prefixCheck: function(e) {
						if (T.State.prefixMatches[e]) return [T.State.prefixMatches[e], !0];
						for (var t = ["", "Webkit", "Moz", "ms", "O"], n = 0, i = t.length; n < i; n++) {
							var o;
							if (o = 0 === n ? e : t[n] + e.replace(/^\w/, function(e) {
									return e.toUpperCase()
								}), b.isString(T.State.prefixElement.style[o])) return T.State.prefixMatches[e] = o, [o, !0]
						}
						return [e, !1]
					}
				},
				Values: {
					hexToRgb: function(e) {
						var t, n = /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
							i = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
						return e = e.replace(n, function(e, t, n, i) {
							return t + t + n + n + i + i
						}), t = i.exec(e), t ? [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)] : [0, 0, 0]
					},
					isCSSNullValue: function(e) {
						return !e || /^(none|auto|transparent|(rgba\(0, ?0, ?0, ?0\)))$/i.test(e)
					},
					getUnitType: function(e) {
						return /^(rotate|skew)/i.test(e) ? "deg" : /(^(scale|scaleX|scaleY|scaleZ|alpha|flexGrow|flexHeight|zIndex|fontWeight)$)|((opacity|red|green|blue|alpha)$)/i.test(e) ? "" : "px"
					},
					getDisplayType: function(e) {
						var t = e && e.tagName.toString().toLowerCase();
						return /^(b|big|i|small|tt|abbr|acronym|cite|code|dfn|em|kbd|strong|samp|var|a|bdo|br|img|map|object|q|script|span|sub|sup|button|input|label|select|textarea)$/i.test(t) ? "inline" : /^(li)$/i.test(t) ? "list-item" : /^(tr)$/i.test(t) ? "table-row" : /^(table)$/i.test(t) ? "table" : /^(tbody)$/i.test(t) ? "table-row-group" : "block"
					},
					addClass: function(e, t) {
						if (e)
							if (e.classList) e.classList.add(t);
							else if (b.isString(e.className)) e.className += (e.className.length ? " " : "") + t;
						else {
							var n = e.getAttribute(g <= 7 ? "className" : "class") || "";
							e.setAttribute("class", n + (n ? " " : "") + t)
						}
					},
					removeClass: function(e, t) {
						if (e)
							if (e.classList) e.classList.remove(t);
							else if (b.isString(e.className)) e.className = e.className.toString().replace(new RegExp("(^|\\s)" + t.split(" ").join("|") + "(\\s|$)", "gi"), " ");
						else {
							var n = e.getAttribute(g <= 7 ? "className" : "class") || "";
							e.setAttribute("class", n.replace(new RegExp("(^|s)" + t.split(" ").join("|") + "(s|$)", "gi"), " "))
						}
					}
				},
				getPropertyValue: function(e, n, o, r) {
					function a(e, n) {
						var o = 0;
						if (g <= 8) o = h.css(e, n);
						else {
							var l = !1;
							/^(width|height)$/.test(n) && 0 === E.getPropertyValue(e, "display") && (l = !0, E.setPropertyValue(e, "display", E.Values.getDisplayType(e)));
							var u = function() {
								l && E.setPropertyValue(e, "display", "none")
							};
							if (!r) {
								if ("height" === n && "border-box" !== E.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
									var c = e.offsetHeight - (parseFloat(E.getPropertyValue(e, "borderTopWidth")) || 0) - (parseFloat(E.getPropertyValue(e, "borderBottomWidth")) || 0) - (parseFloat(E.getPropertyValue(e, "paddingTop")) || 0) - (parseFloat(E.getPropertyValue(e, "paddingBottom")) || 0);
									return u(), c
								}
								if ("width" === n && "border-box" !== E.getPropertyValue(e, "boxSizing").toString().toLowerCase()) {
									var d = e.offsetWidth - (parseFloat(E.getPropertyValue(e, "borderLeftWidth")) || 0) - (parseFloat(E.getPropertyValue(e, "borderRightWidth")) || 0) - (parseFloat(E.getPropertyValue(e, "paddingLeft")) || 0) - (parseFloat(E.getPropertyValue(e, "paddingRight")) || 0);
									return u(), d
								}
							}
							var p;
							p = s(e) === i ? t.getComputedStyle(e, null) : s(e).computedStyle ? s(e).computedStyle : s(e).computedStyle = t.getComputedStyle(e, null), "borderColor" === n && (n = "borderTopColor"), o = 9 === g && "filter" === n ? p.getPropertyValue(n) : p[n], "" !== o && null !== o || (o = e.style[n]), u()
						}
						if ("auto" === o && /^(top|right|bottom|left)$/i.test(n)) {
							var f = a(e, "position");
							("fixed" === f || "absolute" === f && /top|left/i.test(n)) && (o = h(e).position()[n] + "px")
						}
						return o
					}
					var l;
					if (E.Hooks.registered[n]) {
						var u = n,
							c = E.Hooks.getRoot(u);
						o === i && (o = E.getPropertyValue(e, E.Names.prefixCheck(c)[0])), E.Normalizations.registered[c] && (o = E.Normalizations.registered[c]("extract", e, o)), l = E.Hooks.extractValue(u, o)
					} else if (E.Normalizations.registered[n]) {
						var d, p;
						d = E.Normalizations.registered[n]("name", e), "transform" !== d && (p = a(e, E.Names.prefixCheck(d)[0]), E.Values.isCSSNullValue(p) && E.Hooks.templates[n] && (p = E.Hooks.templates[n][1])), l = E.Normalizations.registered[n]("extract", e, p)
					}
					if (!/^[\d-]/.test(l)) {
						var f = s(e);
						if (f && f.isSVG && E.Names.SVGAttribute(n))
							if (/^(height|width)$/i.test(n)) try {
								l = e.getBBox()[n]
							} catch (e) {
								l = 0
							} else l = e.getAttribute(n);
							else l = a(e, E.Names.prefixCheck(n)[0])
					}
					return E.Values.isCSSNullValue(l) && (l = 0), T.debug >= 2 && console.log("Get " + n + ": " + l), l
				},
				setPropertyValue: function(e, n, i, o, r) {
					var a = n;
					if ("scroll" === n) r.container ? r.container["scroll" + r.direction] = i : "Left" === r.direction ? t.scrollTo(i, r.alternateValue) : t.scrollTo(r.alternateValue, i);
					else if (E.Normalizations.registered[n] && "transform" === E.Normalizations.registered[n]("name", e)) E.Normalizations.registered[n]("inject", e, i), a = "transform", i = s(e).transformCache[n];
					else {
						if (E.Hooks.registered[n]) {
							var l = n,
								u = E.Hooks.getRoot(n);
							o = o || E.getPropertyValue(e, u), i = E.Hooks.injectValue(l, i, o), n = u
						}
						if (E.Normalizations.registered[n] && (i = E.Normalizations.registered[n]("inject", e, i), n = E.Normalizations.registered[n]("name", e)), a = E.Names.prefixCheck(n)[0], g <= 8) try {
							e.style[a] = i
						} catch (e) {
							T.debug && console.log("Browser does not support [" + i + "] for [" + a + "]")
						} else {
							var c = s(e);
							c && c.isSVG && E.Names.SVGAttribute(n) ? e.setAttribute(n, i) : e.style[a] = i
						}
						T.debug >= 2 && console.log("Set " + n + " (" + a + "): " + i)
					}
					return [a, i]
				},
				flushTransformCache: function(e) {
					var t = "",
						n = s(e);
					if ((g || T.State.isAndroid && !T.State.isChrome) && n && n.isSVG) {
						var i = function(t) {
								return parseFloat(E.getPropertyValue(e, t))
							},
							o = {
								translate: [i("translateX"), i("translateY")],
								skewX: [i("skewX")],
								skewY: [i("skewY")],
								scale: 1 !== i("scale") ? [i("scale"), i("scale")] : [i("scaleX"), i("scaleY")],
								rotate: [i("rotateZ"), 0, 0]
							};
						h.each(s(e).transformCache, function(e) {
							/^translate/i.test(e) ? e = "translate" : /^scale/i.test(e) ? e = "scale" : /^rotate/i.test(e) && (e = "rotate"), o[e] && (t += e + "(" + o[e].join(" ") + ") ", delete o[e])
						})
					} else {
						var r, a;
						h.each(s(e).transformCache, function(n) {
							if (r = s(e).transformCache[n], "transformPerspective" === n) return a = r, !0;
							9 === g && "rotateZ" === n && (n = "rotate"), t += n + r + " "
						}), a && (t = "perspective" + a + " " + t)
					}
					E.setPropertyValue(e, "transform", t)
				}
			};
			E.Hooks.register(), E.Normalizations.register(), T.hook = function(e, t, n) {
				var o;
				return e = r(e), h.each(e, function(e, r) {
					if (s(r) === i && T.init(r), n === i) o === i && (o = E.getPropertyValue(r, t));
					else {
						var a = E.setPropertyValue(r, t, n);
						"transform" === a[0] && T.CSS.flushTransformCache(r), o = a
					}
				}), o
			};
			var _ = function() {
				function e() {
					return c ? S.promise || null : g
				}

				function o(e, o) {
					function r(r) {
						var c, f;
						if (l.begin && 0 === $) try {
							l.begin.call(v, v)
						} catch (e) {
							setTimeout(function() {
								throw e
							}, 1)
						}
						if ("scroll" === N) {
							var g, m, k, C = /^x$/i.test(l.axis) ? "Left" : "Top",
								_ = parseFloat(l.offset) || 0;
							l.container ? b.isWrapped(l.container) || b.isNode(l.container) ? (l.container = l.container[0] || l.container, g = l.container["scroll" + C], k = g + h(e).position()[C.toLowerCase()] + _) : l.container = null : (g = T.State.scrollAnchor[T.State["scrollProperty" + C]], m = T.State.scrollAnchor[T.State["scrollProperty" + ("Left" === C ? "Top" : "Left")]], k = h(e).offset()[C.toLowerCase()] + _), u = {
								scroll: {
									rootPropertyValue: !1,
									startValue: g,
									currentValue: g,
									endValue: k,
									unitType: "",
									easing: l.easing,
									scrollData: {
										container: l.container,
										direction: C,
										alternateValue: m
									}
								},
								element: e
							}, T.debug && console.log("tweensContainer (scroll): ", u.scroll, e)
						} else if ("reverse" === N) {
							if (!(c = s(e))) return;
							if (!c.tweensContainer) return void h.dequeue(e, l.queue);
							"none" === c.opts.display && (c.opts.display = "auto"), "hidden" === c.opts.visibility && (c.opts.visibility = "visible"), c.opts.loop = !1, c.opts.begin = null, c.opts.complete = null, x.easing || delete l.easing, x.duration || delete l.duration, l = h.extend({}, c.opts, l), f = h.extend(!0, {}, c ? c.tweensContainer : null);
							for (var P in f)
								if (f.hasOwnProperty(P) && "element" !== P) {
									var L = f[P].startValue;
									f[P].startValue = f[P].currentValue = f[P].endValue, f[P].endValue = L, b.isEmptyObject(x) || (f[P].easing = l.easing), T.debug && console.log("reverse tweensContainer (" + P + "): " + JSON.stringify(f[P]), e)
								}
							u = f
						} else if ("start" === N) {
							c = s(e), c && c.tweensContainer && !0 === c.isAnimating && (f = c.tweensContainer);
							var j = function(o, r) {
								var s, d = E.Hooks.getRoot(o),
									p = !1,
									g = r[0],
									m = r[1],
									v = r[2];
								if (!(c && c.isSVG || "tween" === d || !1 !== E.Names.prefixCheck(d)[1] || E.Normalizations.registered[d] !== i)) return void(T.debug && console.log("Skipping [" + d + "] due to a lack of browser support."));
								(l.display !== i && null !== l.display && "none" !== l.display || l.visibility !== i && "hidden" !== l.visibility) && /opacity|filter/.test(o) && !v && 0 !== g && (v = 0), l._cacheValues && f && f[o] ? (v === i && (v = f[o].endValue + f[o].unitType), p = c.rootPropertyValueCache[d]) : E.Hooks.registered[o] ? v === i ? (p = E.getPropertyValue(e, d), v = E.getPropertyValue(e, o, p)) : p = E.Hooks.templates[d][1] : v === i && (v = E.getPropertyValue(e, o));
								var y, w, x, k = !1,
									C = function(e, t) {
										var n, i;
										return i = (t || "0").toString().toLowerCase().replace(/[%A-z]+$/, function(e) {
											return n = e, ""
										}), n || (n = E.Values.getUnitType(e)), [i, n]
									};
								if (v !== g && b.isString(v) && b.isString(g)) {
									s = "";
									var S = 0,
										_ = 0,
										A = [],
										$ = [],
										P = 0,
										L = 0,
										N = 0;
									for (v = E.Hooks.fixColors(v), g = E.Hooks.fixColors(g); S < v.length && _ < g.length;) {
										var j = v[S],
											q = g[_];
										if (/[\d\.-]/.test(j) && /[\d\.-]/.test(q)) {
											for (var H = j, O = q, D = ".", I = "."; ++S < v.length;) {
												if ((j = v[S]) === D) D = "..";
												else if (!/\d/.test(j)) break;
												H += j
											}
											for (; ++_ < g.length;) {
												if ((q = g[_]) === I) I = "..";
												else if (!/\d/.test(q)) break;
												O += q
											}
											var B = E.Hooks.getUnit(v, S),
												z = E.Hooks.getUnit(g, _);
											if (S += B.length, _ += z.length, B === z) H === O ? s += H + B : (s += "{" + A.length + (L ? "!" : "") + "}" + B, A.push(parseFloat(H)), $.push(parseFloat(O)));
											else {
												var V = parseFloat(H),
													F = parseFloat(O);
												s += (P < 5 ? "calc" : "") + "(" + (V ? "{" + A.length + (L ? "!" : "") + "}" : "0") + B + " + " + (F ? "{" + (A.length + (V ? 1 : 0)) + (L ? "!" : "") + "}" : "0") + z + ")", V && (A.push(V), $.push(0)), F && (A.push(0), $.push(F))
											}
										} else {
											if (j !== q) {
												P = 0;
												break
											}
											s += j, S++, _++, 0 === P && "c" === j || 1 === P && "a" === j || 2 === P && "l" === j || 3 === P && "c" === j || P >= 4 && "(" === j ? P++ : (P && P < 5 || P >= 4 && ")" === j && --P < 5) && (P = 0), 0 === L && "r" === j || 1 === L && "g" === j || 2 === L && "b" === j || 3 === L && "a" === j || L >= 3 && "(" === j ? (3 === L && "a" === j && (N = 1), L++) : N && "," === j ? ++N > 3 && (L = N = 0) : (N && L < (N ? 5 : 4) || L >= (N ? 4 : 3) && ")" === j && --L < (N ? 5 : 4)) && (L = N = 0)
										}
									}
									S === v.length && _ === g.length || (T.debug && console.error('Trying to pattern match mis-matched strings ["' + g + '", "' + v + '"]'), s = i), s && (A.length ? (T.debug && console.log('Pattern found "' + s + '" -> ', A, $, "[" + v + "," + g + "]"), v = A, g = $, w = x = "") : s = i)
								}
								s || (y = C(o, v), v = y[0], x = y[1], y = C(o, g), g = y[0].replace(/^([+-\/*])=/, function(e, t) {
									return k = t, ""
								}), w = y[1], v = parseFloat(v) || 0, g = parseFloat(g) || 0, "%" === w && (/^(fontSize|lineHeight)$/.test(o) ? (g /= 100, w = "em") : /^scale/.test(o) ? (g /= 100, w = "") : /(Red|Green|Blue)$/i.test(o) && (g = g / 100 * 255, w = "")));
								if (/[\/*]/.test(k)) w = x;
								else if (x !== w && 0 !== v)
									if (0 === g) w = x;
									else {
										a = a || function() {
											var i = {
													myParent: e.parentNode || n.body,
													position: E.getPropertyValue(e, "position"),
													fontSize: E.getPropertyValue(e, "fontSize")
												},
												o = i.position === M.lastPosition && i.myParent === M.lastParent,
												r = i.fontSize === M.lastFontSize;
											M.lastParent = i.myParent, M.lastPosition = i.position, M.lastFontSize = i.fontSize;
											var s = {};
											if (r && o) s.emToPx = M.lastEmToPx, s.percentToPxWidth = M.lastPercentToPxWidth, s.percentToPxHeight = M.lastPercentToPxHeight;
											else {
												var a = c && c.isSVG ? n.createElementNS("http://www.w3.org/2000/svg", "rect") : n.createElement("div");
												T.init(a), i.myParent.appendChild(a), h.each(["overflow", "overflowX", "overflowY"], function(e, t) {
													T.CSS.setPropertyValue(a, t, "hidden")
												}), T.CSS.setPropertyValue(a, "position", i.position), T.CSS.setPropertyValue(a, "fontSize", i.fontSize), T.CSS.setPropertyValue(a, "boxSizing", "content-box"), h.each(["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height"], function(e, t) {
													T.CSS.setPropertyValue(a, t, "100%")
												}), T.CSS.setPropertyValue(a, "paddingLeft", "100em"), s.percentToPxWidth = M.lastPercentToPxWidth = (parseFloat(E.getPropertyValue(a, "width", null, !0)) || 1) / 100, s.percentToPxHeight = M.lastPercentToPxHeight = (parseFloat(E.getPropertyValue(a, "height", null, !0)) || 1) / 100, s.emToPx = M.lastEmToPx = (parseFloat(E.getPropertyValue(a, "paddingLeft")) || 1) / 100, i.myParent.removeChild(a)
											}
											return null === M.remToPx && (M.remToPx = parseFloat(E.getPropertyValue(n.body, "fontSize")) || 16), null === M.vwToPx && (M.vwToPx = parseFloat(t.innerWidth) / 100, M.vhToPx = parseFloat(t.innerHeight) / 100), s.remToPx = M.remToPx, s.vwToPx = M.vwToPx, s.vhToPx = M.vhToPx, T.debug >= 1 && console.log("Unit ratios: " + JSON.stringify(s), e), s
										}();
										var R = /margin|padding|left|right|width|text|word|letter/i.test(o) || /X$/.test(o) || "x" === o ? "x" : "y";
										switch (x) {
											case "%":
												v *= "x" === R ? a.percentToPxWidth : a.percentToPxHeight;
												break;
											case "px":
												break;
											default:
												v *= a[x + "ToPx"]
										}
										switch (w) {
											case "%":
												v *= 1 / ("x" === R ? a.percentToPxWidth : a.percentToPxHeight);
												break;
											case "px":
												break;
											default:
												v *= 1 / a[w + "ToPx"]
										}
									}
								switch (k) {
									case "+":
										g = v + g;
										break;
									case "-":
										g = v - g;
										break;
									case "*":
										g *= v;
										break;
									case "/":
										g = v / g
								}
								u[o] = {
									rootPropertyValue: p,
									startValue: v,
									currentValue: v,
									endValue: g,
									unitType: w,
									easing: m
								}, s && (u[o].pattern = s), T.debug && console.log("tweensContainer (" + o + "): " + JSON.stringify(u[o]), e)
							};
							for (var q in y)
								if (y.hasOwnProperty(q)) {
									var H = E.Names.camelCase(q),
										O = function(t, n) {
											var i, r, s;
											return b.isFunction(t) && (t = t.call(e, o, A)), b.isArray(t) ? (i = t[0], !b.isArray(t[1]) && /^[\d-]/.test(t[1]) || b.isFunction(t[1]) || E.RegEx.isHex.test(t[1]) ? s = t[1] : b.isString(t[1]) && !E.RegEx.isHex.test(t[1]) && T.Easings[t[1]] || b.isArray(t[1]) ? (r = n ? t[1] : d(t[1], l.duration), s = t[2]) : s = t[1] || t[2]) : i = t, n || (r = r || l.easing), b.isFunction(i) && (i = i.call(e, o, A)), b.isFunction(s) && (s = s.call(e, o, A)), [i || 0, r, s]
										}(y[q]);
									if (w(E.Lists.colors, H)) {
										var D = O[0],
											B = O[1],
											z = O[2];
										if (E.RegEx.isHex.test(D)) {
											for (var V = ["Red", "Green", "Blue"], F = E.Values.hexToRgb(D), R = z ? E.Values.hexToRgb(z) : i, W = 0; W < V.length; W++) {
												var U = [F[W]];
												B && U.push(B), R !== i && U.push(R[W]), j(H + V[W], U)
											}
											continue
										}
									}
									j(H, O)
								}
							u.element = e
						}
						u.element && (E.Values.addClass(e, "velocity-animating"), I.push(u), c = s(e), c && ("" === l.queue && (c.tweensContainer = u, c.opts = l), c.isAnimating = !0), $ === A - 1 ? (T.State.calls.push([I, v, l, null, S.resolver, null, 0]), !1 === T.State.isTicking && (T.State.isTicking = !0, p())) : $++)
					}
					var a, l = h.extend({}, T.defaults, x),
						u = {};
					switch (s(e) === i && T.init(e), parseFloat(l.delay) && !1 !== l.queue && h.queue(e, l.queue, function(t, n) {
						if (!0 === n) return !0;
						T.velocityQueueEntryFlag = !0;
						var i = T.State.delayedElements.count++;
						T.State.delayedElements[i] = e;
						var o = function(e) {
							return function() {
								T.State.delayedElements[e] = !1, t()
							}
						}(i);
						s(e).delayBegin = (new Date).getTime(), s(e).delay = parseFloat(l.delay), s(e).delayTimer = {
							setTimeout: setTimeout(t, parseFloat(l.delay)),
							next: o
						}
					}), l.duration.toString().toLowerCase()) {
						case "fast":
							l.duration = 200;
							break;
						case "normal":
							l.duration = k;
							break;
						case "slow":
							l.duration = 600;
							break;
						default:
							l.duration = parseFloat(l.duration) || 1
					}
					if (!1 !== T.mock && (!0 === T.mock ? l.duration = l.delay = 1 : (l.duration *= parseFloat(T.mock) || 1, l.delay *= parseFloat(T.mock) || 1)), l.easing = d(l.easing, l.duration), l.begin && !b.isFunction(l.begin) && (l.begin = null), l.progress && !b.isFunction(l.progress) && (l.progress = null), l.complete && !b.isFunction(l.complete) && (l.complete = null), l.display !== i && null !== l.display && (l.display = l.display.toString().toLowerCase(), "auto" === l.display && (l.display = T.CSS.Values.getDisplayType(e))), l.visibility !== i && null !== l.visibility && (l.visibility = l.visibility.toString().toLowerCase()), l.mobileHA = l.mobileHA && T.State.isMobile && !T.State.isGingerbread, !1 === l.queue)
						if (l.delay) {
							var c = T.State.delayedElements.count++;
							T.State.delayedElements[c] = e;
							var f = function(e) {
								return function() {
									T.State.delayedElements[e] = !1, r()
								}
							}(c);
							s(e).delayBegin = (new Date).getTime(), s(e).delay = parseFloat(l.delay), s(e).delayTimer = {
								setTimeout: setTimeout(r, parseFloat(l.delay)),
								next: f
							}
						} else r();
					else h.queue(e, l.queue, function(e, t) {
						if (!0 === t) return S.promise && S.resolver(v), !0;
						T.velocityQueueEntryFlag = !0, r(e)
					});
					"" !== l.queue && "fx" !== l.queue || "inprogress" === h.queue(e)[0] || h.dequeue(e)
				}
				var u, c, g, m, v, y, x, C = arguments[0] && (arguments[0].p || h.isPlainObject(arguments[0].properties) && !arguments[0].properties.names || b.isString(arguments[0].properties));
				b.isWrapped(this) ? (c = !1, m = 0, v = this, g = this) : (c = !0, m = 1, v = C ? arguments[0].elements || arguments[0].e : arguments[0]);
				var S = {
					promise: null,
					resolver: null,
					rejecter: null
				};
				if (c && T.Promise && (S.promise = new T.Promise(function(e, t) {
						S.resolver = e, S.rejecter = t
					})), C ? (y = arguments[0].properties || arguments[0].p, x = arguments[0].options || arguments[0].o) : (y = arguments[m], x = arguments[m + 1]), !(v = r(v))) return void(S.promise && (y && x && !1 === x.promiseRejectEmpty ? S.resolver() : S.rejecter()));
				var A = v.length,
					$ = 0;
				if (!/^(stop|finish|finishAll|pause|resume)$/i.test(y) && !h.isPlainObject(x)) {
					var P = m + 1;
					x = {};
					for (var L = P; L < arguments.length; L++) b.isArray(arguments[L]) || !/^(fast|normal|slow)$/i.test(arguments[L]) && !/^\d/.test(arguments[L]) ? b.isString(arguments[L]) || b.isArray(arguments[L]) ? x.easing = arguments[L] : b.isFunction(arguments[L]) && (x.complete = arguments[L]) : x.duration = arguments[L]
				}
				var N;
				switch (y) {
					case "scroll":
						N = "scroll";
						break;
					case "reverse":
						N = "reverse";
						break;
					case "pause":
						var j = (new Date).getTime();
						return h.each(v, function(e, t) {
							a(t, j)
						}), h.each(T.State.calls, function(e, t) {
							var n = !1;
							t && h.each(t[1], function(e, o) {
								var r = x === i ? "" : x;
								return !0 !== r && t[2].queue !== r && (x !== i || !1 !== t[2].queue) || (h.each(v, function(e, i) {
									if (i === o) return t[5] = {
										resume: !1
									}, n = !0, !1
								}), !n && void 0)
							})
						}), e();
					case "resume":
						return h.each(v, function(e, t) {
							l(t, j)
						}), h.each(T.State.calls, function(e, t) {
							var n = !1;
							t && h.each(t[1], function(e, o) {
								var r = x === i ? "" : x;
								return !0 !== r && t[2].queue !== r && (x !== i || !1 !== t[2].queue) || (!t[5] || (h.each(v, function(e, i) {
									if (i === o) return t[5].resume = !0, n = !0, !1
								}), !n && void 0))
							})
						}), e();
					case "finish":
					case "finishAll":
					case "stop":
						h.each(v, function(e, t) {
							s(t) && s(t).delayTimer && (clearTimeout(s(t).delayTimer.setTimeout), s(t).delayTimer.next && s(t).delayTimer.next(), delete s(t).delayTimer), "finishAll" !== y || !0 !== x && !b.isString(x) || (h.each(h.queue(t, b.isString(x) ? x : ""), function(e, t) {
								b.isFunction(t) && t()
							}), h.queue(t, b.isString(x) ? x : "", []))
						});
						var q = [];
						return h.each(T.State.calls, function(e, t) {
							t && h.each(t[1], function(n, o) {
								var r = x === i ? "" : x;
								if (!0 !== r && t[2].queue !== r && (x !== i || !1 !== t[2].queue)) return !0;
								h.each(v, function(n, i) {
									if (i === o)
										if ((!0 === x || b.isString(x)) && (h.each(h.queue(i, b.isString(x) ? x : ""), function(e, t) {
												b.isFunction(t) && t(null, !0)
											}), h.queue(i, b.isString(x) ? x : "", [])), "stop" === y) {
											var a = s(i);
											a && a.tweensContainer && !1 !== r && h.each(a.tweensContainer, function(e, t) {
												t.endValue = t.currentValue
											}), q.push(e)
										} else "finish" !== y && "finishAll" !== y || (t[2].duration = 1)
								})
							})
						}), "stop" === y && (h.each(q, function(e, t) {
							f(t, !0)
						}), S.promise && S.resolver(v)), e();
					default:
						if (!h.isPlainObject(y) || b.isEmptyObject(y)) {
							if (b.isString(y) && T.Redirects[y]) {
								u = h.extend({}, x);
								var H = u.duration,
									O = u.delay || 0;
								return !0 === u.backwards && (v = h.extend(!0, [], v).reverse()), h.each(v, function(e, t) {
									parseFloat(u.stagger) ? u.delay = O + parseFloat(u.stagger) * e : b.isFunction(u.stagger) && (u.delay = O + u.stagger.call(t, e, A)), u.drag && (u.duration = parseFloat(H) || (/^(callout|transition)/.test(y) ? 1e3 : k), u.duration = Math.max(u.duration * (u.backwards ? 1 - e / A : (e + 1) / A), .75 * u.duration, 200)), T.Redirects[y].call(t, t, u || {}, e, A, v, S.promise ? S : i)
								}), e()
							}
							var D = "Velocity: First argument (" + y + ") was not a property map, a known action, or a registered redirect. Aborting.";
							return S.promise ? S.rejecter(new Error(D)) : t.console && console.log(D), e()
						}
						N = "start"
				}
				var M = {
						lastParent: null,
						lastPosition: null,
						lastFontSize: null,
						lastPercentToPxWidth: null,
						lastPercentToPxHeight: null,
						lastEmToPx: null,
						remToPx: null,
						vwToPx: null,
						vhToPx: null
					},
					I = [];
				h.each(v, function(e, t) {
					b.isNode(t) && o(t, e)
				}), u = h.extend({}, T.defaults, x), u.loop = parseInt(u.loop, 10);
				var B = 2 * u.loop - 1;
				if (u.loop)
					for (var z = 0; z < B; z++) {
						var V = {
							delay: u.delay,
							progress: u.progress
						};
						z === B - 1 && (V.display = u.display, V.visibility = u.visibility, V.complete = u.complete), _(v, "reverse", V)
					}
				return e()
			};
			T = h.extend(_, T), T.animate = _;
			var A = t.requestAnimationFrame || m;
			if (!T.State.isMobile && n.hidden !== i) {
				var $ = function() {
					n.hidden ? (A = function(e) {
						return setTimeout(function() {
							e(!0)
						}, 16)
					}, p()) : A = t.requestAnimationFrame || m
				};
				$(), n.addEventListener("visibilitychange", $)
			}
			return e.Velocity = T, e !== t && (e.fn.velocity = _, e.fn.velocity.defaults = T.defaults), h.each(["Down", "Up"], function(e, t) {
				T.Redirects["slide" + t] = function(e, n, o, r, s, a) {
					var l = h.extend({}, n),
						u = l.begin,
						c = l.complete,
						d = {},
						p = {
							height: "",
							marginTop: "",
							marginBottom: "",
							paddingTop: "",
							paddingBottom: ""
						};
					l.display === i && (l.display = "Down" === t ? "inline" === T.CSS.Values.getDisplayType(e) ? "inline-block" : "block" : "none"), l.begin = function() {
						0 === o && u && u.call(s, s);
						for (var n in p)
							if (p.hasOwnProperty(n)) {
								d[n] = e.style[n];
								var i = E.getPropertyValue(e, n);
								p[n] = "Down" === t ? [i, 0] : [0, i]
							}
						d.overflow = e.style.overflow, e.style.overflow = "hidden"
					}, l.complete = function() {
						for (var t in d) d.hasOwnProperty(t) && (e.style[t] = d[t]);
						o === r - 1 && (c && c.call(s, s), a && a.resolver(s))
					}, T(e, p, l)
				}
			}), h.each(["In", "Out"], function(e, t) {
				T.Redirects["fade" + t] = function(e, n, o, r, s, a) {
					var l = h.extend({}, n),
						u = l.complete,
						c = {
							opacity: "In" === t ? 1 : 0
						};
					0 !== o && (l.begin = null), l.complete = o !== r - 1 ? null : function() {
						u && u.call(s, s), a && a.resolver(s)
					}, l.display === i && (l.display = "In" === t ? "auto" : "none"), T(this, c, l)
				}
			}), T
		}(window.jQuery || window.Zepto || window, window, window ? window.document : void 0)
	})
}]);

// mailchimp forms
$(function() {
    var slideBlocks = $('.mch-su');	
	var media = window.matchMedia("(max-width: 768px)")
	slideBlocks.each(function(index, el){
		var $blc = $(el);
		var $btn = $blc.find('.mch-su__btn');
		var $btnTxt = $btn.find('span');
		var $container = $blc.find('.mch-su__container');
		var txtWidth;		
		var checkTxtWidth = function() {			
			$btnTxt.css('width', 'auto');			
			txtWidth = $btnTxt.outerWidth();
			if (media.matches) {
				var shift = Math.round(($blc.outerWidth() - $btn.outerWidth()) / 2);
				$btn.css('right', shift + 'px');
			} else {
				$btn.css('right', '');
			}
			if ($blc.hasClass( 'mch-su--open' )) {
				$btnTxt.css('width', 0);
			} else {
				$btnTxt.css('width', txtWidth + 'px');
			}
			//todo
		} 
		checkTxtWidth();			
		$btn.on('click', function(){
			if ($blc.hasClass( 'mch-su--open' )) {
				$blc.removeClass( 'mch-su--open' );
				$container.slideUp({ duration: 500, queue: false });
				$btnTxt.animate({
						opacity: 1,
						width: txtWidth + 'px'
					}, {duration: 500, queue: false}
				);
			} else {
				$blc.addClass( 'mch-su--open' );
				$container.slideDown({ duration: 500, queue: false });
				$btnTxt.animate({
						opacity: 0,
						width: 0
					}, {duration: 500, queue: false}
				);
			}
		});
		$( window ).on( "resize", checkTxtWidth);
	});

	var $modal = $('.mch-modal');
	var mchFormStatus = localStorage.getItem('mch_form');
	var mchModalStatus = localStorage.getItem('mch_modal');
	// var mchFormPage = sessionStorage.getItem('mch_form_page');
	// if (mchFormPage) {
	// 	mchFormPage = parseInt(mchFormPage);
	// }
	//console.log(mchFormPage);	
	
	if (($modal.length > 0) && ( mchModalStatus != '1')) {		
		var wasOpened = false;
		var isModalOpened = false;	
		//functions
		var keyCatchHandler = function(evt) {
			if ((evt.key === 'Escape') && isModalOpened){
				closeModalHandler();
			}
		}

		var openModalHandler = function() {
			$modal.css('display', 'block');
			$('body').addClass('mch-modal-open');
			$('html').addClass('mch-modal-open');
			setTimeout(function(){					
				$modal.addClass('mch-modal--show');		
			}, 5);				
			$modal.find('.mch-modal__close').on('click', function(){
				closeModalHandler();							
			});
			$modal.on('click', function(event){					
				if ($(event.target).closest('.mch-reg__container').length == 0) {
					closeModalHandler();
				}					
			});				
			wasOpened = true;
			isModalOpened = true;	
		}

		var closeModalHandler = function() {
			$('body').removeClass('mch-modal-open');
			$('html').removeClass('mch-modal-open');
			$modal.removeClass('mch-modal--show');
			setTimeout(function(){					
				$modal.css('display', 'none');	
			}, 155);
			isModalOpened = false;
			document.removeEventListener('keydown',  keyCatchHandler);
			//sessionStorage.setItem('mch_form_page', 1);
			localStorage.setItem('mch_modal', 1);
		}
		
		document.addEventListener('keydown',  keyCatchHandler);
		//todo openers
		if (! mchModalStatus) {
			setTimeout(function(){
				openModalHandler();				
			}, 20000);
		}		
		/*if (! mchFormPage) {						
			setTimeout(function(){
				openModalHandler();
				sessionStorage.setItem('mch_form_page', 1);
			}, 15000);
			
		// } else if (mchFormPage >= 3) {
		// 	$(window).scroll(function () { 
		// 		let scrollTop = $(window).scrollTop();
		// 		let height = 100;
		// 		if ( scrollTop > height && wasOpened === false ) {
		// 			openModalHandler();
		// 			sessionStorage.setItem('mch_form_page', 1);
		// 		}
		// 	});			
		} else {
			mchFormPage++;
			sessionStorage.setItem('mch_form_page', mchFormPage);
		}
		*/
		$( document ).on('mailchimpsent', function(event, formId) {
			var $form = $modal.find('.mch-form');
			if ($form.attr('id') == formId) {
				$modal.find('.mch-modal__close')[0].click();				
			}
		});		
	}	
	
	var calcAppHeight = function() {
		var doc = document.documentElement;
		doc.style.setProperty('--app-inner-height', window.innerHeight + 'px');
	}
	window.addEventListener('resize', calcAppHeight);
	calcAppHeight();	
});